/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 475:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
       (accessible)
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1@accessible360.1
  Author: Jason Webb (Accessible360)
 Website: https://accessible360.com
    Docs: https://accessible360.github.io/accessible-slick
    Repo: https://github.com/Accessible360/accessible-slick
  Issues: https://github.com/Accessible360/accessible-slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(755)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                arrowsPlacement: null,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" type="button">'
                            + '<span class="slick-prev-icon" aria-hidden="true"></span>'
                            + '<span class="slick-sr-only">Previous</span>'
                         + '</button>',
                nextArrow: '<button class="slick-next" type="button">'
                            + '<span class="slick-next-icon" aria-hidden="true"></span>'
                            + '<span class="slick-sr-only">Next</span>'
                         + '</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button">'
                                + '<span class="slick-dot-icon" aria-hidden="true"></span>'
                                + '<span class="slick-sr-only">Go to slide ' + (i+1) + '</span>'
                            + '</button>');
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                infinite: true,
                initialSlide: 0,
                instructionsText: null,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                playIcon: '<span class="slick-play-icon" aria-hidden="true"></span>',
                pauseIcon: '<span class="slick-pause-icon" aria-hidden="true"></span>',
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                regionLabel: 'carousel',
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useAutoplayToggleButton: true,
                useCSS: true,
                useGroupRole: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                $instructionsText: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $pauseButton: null,
                $pauseIcon: null,
                $playIcon: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.autoPlayToggleHandler = $.proxy(_.autoPlayToggleHandler, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
            $(element).attr('role', 'group');
            $(element).attr('aria-label', 'slide ' + index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.autoPlayToggleHandler = function() {
        var _ = this;

        if(_.paused) {
            _.$playIcon.css('display', 'none');
            _.$pauseIcon.css('display', 'inline');

            _.$pauseButton.find('.slick-play-text').attr('style', 'display: none');
            _.$pauseButton.find('.slick-pause-text').removeAttr('style');

            _.slickPlay();
        } else {
            _.$playIcon.css('display', 'inline');
            _.$pauseIcon.css('display', 'none');

            _.$pauseButton.find('.slick-play-text').removeAttr('style');
            _.$pauseButton.find('.slick-pause-text').attr('style', 'display: none');

            _.slickPause();
        }
    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    if(_.options.arrowsPlacement != null) {
                        switch(_.options.arrowsPlacement) {
                            case 'beforeSlides':
                            case 'split':
                                console.log('test');
                                _.$prevArrow.prependTo(_.options.appendArrows);
                                break;

                            case 'afterSlides':
                                _.$prevArrow.appendTo(_.options.appendArrows);
                                break;
                        }

                    } else {
                        _.$prevArrow.prependTo(_.options.appendArrows);
                    }
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    if(_.options.arrowsPlacement != null) {
                        switch(_.options.arrowsPlacement) {
                            case 'beforeSlides':
                                console.log('test2');
                                _.$prevArrow.after(_.$nextArrow);
                                break;

                            case 'afterSlides':
                            case 'split':
                                _.$nextArrow.appendTo(_.options.appendArrows);
                        }
                    } else {
                       _.$nextArrow.appendTo(_.options.appendArrows);
                    }
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .prop('disabled', true);
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .prop('disabled', true);
            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');

            if(_.options.useGroupRole) {
                $(element)
                    .attr('role', 'group')
                    .attr('aria-label', 'slide ' + (index + 1));
            }
        });

        _.$slider.addClass('slick-slider');

        _.$slider.attr('role', 'region');
        _.$slider.attr('aria-label', _.options.regionLabel);

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

        if ( _.options.autoplay && _.options.useAutoplayToggleButton ) {
            _.$pauseIcon = $(_.options.pauseIcon).attr('aria-hidden', true);
            _.$playIcon = $(_.options.playIcon).attr('aria-hidden', true);

            _.$pauseButton = $('<button type="button" class="slick-autoplay-toggle-button">');
            _.$pauseButton.append(_.$pauseIcon);
            _.$pauseButton.append(_.$playIcon.css('display', 'none'));
            _.$pauseButton.append($('<span class="slick-pause-text slick-sr-only">Pause</span>'));
            _.$pauseButton.append($('<span class="slick-play-text slick-sr-only" style="display: none">Play</span>'));

            _.$pauseButton.prependTo(_.$slider);
        }

        if((_.options.instructionsText != null && _.options.instructionsText != '')) {
            _.$instructionsText = $('<p class="slick-instructions slick-sr-only">' + _.options.instructionsText + '</p>');
            _.$instructionsText.prependTo(_.$slider);
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if(_.options.autoplay && _.options.useAutoplayToggleButton) {
            _.$pauseButton.off('click.slick', _.autoPlayToggleHandler);
        }

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if(_.options.autoplay && _.options.useAutoplayToggleButton) {
            _.$pauseButton.remove();
        }

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .prop('disabled', false)
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .prop('disabled', false)
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        // If any child element receives focus within the slider we need to pause the autoplay
        _.$slider
            .off('focus.slick blur.slick')
            .on(
                'focus.slick',
                '*',
                function(event) {
                    var $sf = $(this);

                    setTimeout(function() {
                        if( _.options.pauseOnFocus ) {
                            if ($sf.is(':focus')) {
                                _.focussed = true;
                                _.autoPlay();
                            }
                        }
                    }, 0);
                }
            ).on(
                'blur.slick',
                '*',
                function(event) {
                    var $sf = $(this);

                    // When a blur occurs on any elements within the slider we become unfocused
                    if( _.options.pauseOnFocus ) {
                        _.focussed = false;
                        _.autoPlay();
                    }
                }
            );
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, swipeTarget, centerOffset;

        centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
        swipeTarget = (_.swipeLeft * -1) + centerOffset;

        if (_.options.swipeToSlide === true) {

            _.$slideTrack.find('.slick-slide').each(function(index, slide) {

                var slideOuterWidth, slideOffset, slideRightBoundary;
                slideOuterWidth = $(slide).outerWidth();
                slideOffset = slide.offsetLeft;
                if (_.options.centerMode !== true) {
                    slideOffset += (slideOuterWidth / 2);
                }

                slideRightBoundary = slideOffset + (slideOuterWidth);

                if (swipeTarget < slideRightBoundary) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

        _.updateSlideVisibility();

        if(_.options.accessibility != undefined) {
            console.warn('accessibility setting is no longer supported.')
        }

        if(_.options.focusOnChange != undefined) {
            console.warn('focusOnChange is no longer supported.');
        }

        if(_.options.focusOnSelect != undefined) {
            console.warn('focusOnSelect is no longer supported.');
        }

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        if(_.options.autoplay && _.options.useAutoplayToggleButton) {
            _.$pauseButton.on('click.slick', _.autoPlayToggleHandler);
        }

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            _.updateSlideVisibility();

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true')
            .attr('aria-label', function() {
                return $(this).attr('aria-label').replace(' (centered)', '');
            });

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .removeAttr('aria-hidden');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .removeAttr('aria-hidden');

                }

                if (index === 0) {

                    allSlides
                        .eq( _.options.slidesToShow + _.slideCount + 1 )
                        .addClass('slick-center')
                        .attr('aria-label', function() {
                            return $(this).attr('aria-label') + ' (centered)';
                        });

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center')
                        .attr('aria-label', function() {
                            return $(this).attr('aria-label') + ' (centered)';
                        });

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center')
                .attr('aria-label', function() {
                    return $(this).attr('aria-label') + ' (centered)';
                });

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .removeAttr('aria-hidden');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .removeAttr('aria-hidden');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .removeAttr('aria-hidden');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .removeAttr('aria-hidden');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').prop('disabled', false);
            _.$nextArrow.removeClass('slick-disabled').prop('disabled', false);

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').prop('disabled', true);
                _.$nextArrow.removeClass('slick-disabled').prop('disabled', false);

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').prop('disabled', true);
                _.$prevArrow.removeClass('slick-disabled').prop('disabled', false);

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').prop('disabled', true);
                _.$prevArrow.removeClass('slick-disabled').prop('disabled', false);

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .find('button')
                        .removeAttr('aria-current')
                        .end()
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                    .addClass('slick-active')
                    .find('button')
                        .attr('aria-current', true)
                        .end()
                    .end();

        }

    };

    Slick.prototype.updateSlideVisibility = function() {
        var _ = this;

        _.$slideTrack
            .find('.slick-slide')
                .attr('aria-hidden', 'true')
                .find('a, input, button, select')
                    .attr('tabindex', '-1');

        _.$slideTrack
            .find('.slick-active')
                .removeAttr('aria-hidden')
                .find('a, input, button, select')
                    .removeAttr('tabindex');
    }

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


/***/ }),

/***/ 755:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.3
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-12-20T21:28Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.3",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.9
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2022-12-19
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {

					// `qSA` may not throw for unrecognized parts using forgiving parsing:
					// https://drafts.csswg.org/selectors/#forgiving-selector
					// like the `:has()` pseudo-class:
					// https://drafts.csswg.org/selectors/#relational
					// `CSS.supports` is still expected to return `false` then:
					// https://drafts.csswg.org/css-conditional-4/#typedef-supports-selector-fn
					// https://drafts.csswg.org/css-conditional-4/#dfn-support-selector
					if ( support.cssSupportsSelector &&

						// eslint-disable-next-line no-undef
						!CSS.supports( "selector(:is(" + newSelector + "))" ) ) {

						// Support: IE 11+
						// Throw to get to the same code path as an error directly in qSA.
						// Note: once we only support browser supporting
						// `CSS.supports('selector(...)')`, we can most likely drop
						// the `try-catch`. IE doesn't implement the API.
						throw new Error();
					}

					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	// Support: Chrome 105+, Firefox 104+, Safari 15.4+
	// Make sure forgiving mode is not used in `CSS.supports( "selector(...)" )`.
	//
	// `:is()` uses a forgiving selector list as an argument and is widely
	// implemented, so it's a good one to test against.
	support.cssSupportsSelector = assert( function() {
		/* eslint-disable no-undef */

		return CSS.supports( "selector(*)" ) &&

			// Support: Firefox 78-81 only
			// In old Firefox, `:is()` didn't use forgiving parsing. In that case,
			// fail this test as there's no selector to test against that.
			// `CSS.supports` uses unforgiving parsing
			document.querySelectorAll( ":is(:jqfake)" ) &&

			// `*` is needed as Safari & newer Chrome implemented something in between
			// for `:has()` - it throws in `qSA` if it only contains an unsupported
			// argument but multiple ones, one of which is supported, are fine.
			// We want to play safe in case `:is()` gets the same treatment.
			!CSS.supports( "selector(:is(*,:jqfake))" );

		/* eslint-enable */
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	if ( !support.cssSupportsSelector ) {

		// Support: Chrome 105+, Safari 15.4+
		// `:has()` uses a forgiving selector list as an argument so our regular
		// `try-catch` mechanism fails to catch `:has()` with arguments not supported
		// natively like `:has(:contains("Foo"))`. Where supported & spec-compliant,
		// we now use `CSS.supports("selector(:is(SELECTOR_TO_BE_TESTED))")`, but
		// outside that we mark `:has` as buggy.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {

			// Support: IE <9 only
			// IE doesn't have `contains` on `document` so we need to check for
			// `documentElement` presence.
			// We need to fall back to `a` when `documentElement` is missing
			// as `ownerDocument` of elements within `<template/>` may have
			// a null one - a default behavior of all modern browsers.
			var adown = a.nodeType === 9 && a.documentElement || a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
;// CONCATENATED MODULE: ./assets/js/utilities/plugins.js



/**
 * Uses MutationObserver to watch for added elements
 * 
 * @param {String | Element} child 
 * @param {Function} callback 
 * @param {String} parent 
 * 
 * @usage
 *  $('.element-to-watch').watch('.element-to-watch', function($el) {
        this.onElementRender($el);
    });
 */
(jquery_default()).fn.watchFor = function(child, callback) {
    const parent = this[0];

    const observer = new MutationObserver(function(mutations_list) {
        mutations_list.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(added_node) {
            const $found_nodes = jquery_default()(added_node).find(child);

            if ( $found_nodes.length && callback ) callback($found_nodes);
        });
        });
    });
    observer.observe(parent, { subtree: true, childList: true });

    if ( callback ) callback(jquery_default()(child));

    return this;
};

;// CONCATENATED MODULE: ./assets/js/utilities.js



const useState = (defaultValue) => {
  // 👆 We create a function useState with a default value
  let value = defaultValue;
  // 👆 We create a local variable value = defaultValue
  const getValue = () => value
  // 👇 We create a function to set the value with parameter newValue
  const setValue = newValue => value = newValue // 👈 We change the value for newValue
  return [getValue, setValue]; // 👈 We return an array with the value and the function
}

/**
 * Checks if the given elements exist on the DOM
 * @param elements An array of jQuery objects
 * @returns boolean
 */
function elementsExist(elements = []) {
  return elements.filter(el => jquery_default()(el).length).length == elements.length;
}


/**
 * Determines if the current screen is mobile-sized
 * @returns boolean
 */
function isMobile() {
  return window.screen.availWidth < 769;
}

function isTablet() {
  return window.screen.availWidth < 1025;
}


/**
 * Disables scrolling on the page
 */
function disableScroll() {
  jquery_default()(document.body).addClass('overflow-hidden');
}


/**
 * Enables scrolling on the page
 */
function enableScroll() {
  jquery_default()(document.body).removeClass('overflow-hidden');
}


function syncElementsHeight($elements) {
  if (!$elements.length) return;

  // Reset heights to get accurate measurement
  $elements.height('auto');

  // Sort elements by intrinsic height
  const sortedByHeight = $elements.sort((a, b) => {
    return b.offsetHeight - a.offsetHeight;
  });
  const maxHeight = sortedByHeight[0].offsetHeight;

  // Set all elements to match the tallest element found
  $elements.height(maxHeight);

  return maxHeight;
}


/**
 *
 * @param {*} cents
 * @param {*} format [Enum: "amount", "amount_no_decimals", "amount_with_comma_separator", "amount_no_decimals_with_comma_separator"]
 * @returns
 */
function formatMoney(cents, format) {
  if ( typeof cents == 'string' ) {
    cents = cents.replace('.','');
  }

  var value = '';
  var defaultFormat = "amount"
  var formatString = (format || defaultFormat);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return value
};

function replaceHistory(href) {
  if ( href ) history.replaceState({}, '', href);
}

;// CONCATENATED MODULE: ./assets/js/components/sectionNav.js




class SectionNav {
    constructor(navLink) {
        this.$navLink = jquery_default()(navLink);
        this.$section = jquery_default()(this.$navLink.data('section-nav--wrapper'));
    }

    init() {
        if ( !elementsExist([this.$section, this.$navLink]) ) return;

        this.initEventListeners();
    }

    initEventListeners() {
        this.$navLink.on('click', (e) => this.renderSection(e));
    }

    renderSection(e) {
        e.preventDefault();

        const $trigger = jquery_default()(e.currentTarget);
        const sectionToRender = $trigger.data('section-nav')
        const newHref = $trigger.data('section-nav--href');
        const shouldReplaceHistory = $trigger.data('replace-history');

        $trigger.addClass("active")

        jquery_default()('[data-section-nav]')
          .not($trigger)
          .removeClass('active')

        jquery_default().ajax(`${newHref}/?sections=${ sectionToRender }`)
            .then(json => {
                this.$section.html(json[sectionToRender]);
            });

        if ( newHref && shouldReplaceHistory ) replaceHistory(newHref);
    }
}

;// CONCATENATED MODULE: ./assets/js/components/sectionRerender.js




class SectionRerender {
    constructor(link) {
        this.$link = jquery_default()(link);
        this.sectionID = this.$link.data('section-rerender');
        this.searchParams = Array(this.$link.data('section-rerender--params'))[0];   
    }

    init() {
        if ( !elementsExist([this.$link]) ) return;

        this.initEventListeners();
    }

    initEventListeners() {
        this.$link.on('click', (e) => {
            this.rerenderSection(e);
        })
    }

    rerenderSection(e) {
        e.preventDefault();
    

        // console.log(this.$link)
        if ( this.searchParams ) this.updateURL();

        const urlParams = location.search;
        
        // console.log(urlParams);
        
        let requestURL = `${ location.pathname }${ urlParams }`;
 
        if (requestURL.includes("?")) {
            requestURL += `&section_id=${ this.sectionID }`;
        } else {
            requestURL += `?section_id=${ this.sectionID }`;
        }
        
        // console.log(requestURL);

        jquery_default().ajax(requestURL).then(json => {
            // debugger
            jquery_default()(`#shopify-section-${ this.sectionID }`).replaceWith(json);
        });
    }

    updateURL() {
        const href = new URL(window.location.href);
    
        href.searchParams.set(this.searchParams[0], this.searchParams[1]);
        window.history.replaceState(null, '', href.search);
    }
}

;// CONCATENATED MODULE: ./assets/js/components/index.js



;// CONCATENATED MODULE: ./assets/js/utilities/inlineToggle.js
// utilities/inlineToggle.js




/**
 * * Toggles the 'activated' class on a given element on click
 *
 * @options
    * [data-toggle] {required} - Pass selector for target element
 */
class InlineToggle {
    constructor(trigger) {
        this.targetSelector = jquery_default()(trigger).data('toggle');
        this.$target = jquery_default()(this.targetSelector);

        this.$trigger  = jquery_default()(trigger);
        this.$triggers = jquery_default()(`[data-toggle="${ this.targetSelector }"]`);
    }

    init() {
        if ( !elementsExist([this.$target, this.$triggers]) ) return;
        
        this.initEventListeners();
    }

    initEventListeners() {
        this.$trigger.on('click', () => (this.toggleProperties()));
    }

    toggleProperties() {
        this.$target.toggleClass('activated');
        this.$triggers.toggleClass('activated');
    }
}
;// CONCATENATED MODULE: ./assets/js/utilities/deactivate.js
// utilities/Deactivate.js




/**
 * * Removes the 'activated' class on other non-active elements
 *
 * @options
    * [data-deactivate] {required} - Pass selector for target element
 */

class Deactivate {
    constructor(trigger) {
        this.trigger = jquery_default()(trigger)
        this.data = jquery_default()(trigger).data('deactivate');
        this.elements = jquery_default()(`[data-deactivate='${this.data}']`).not(this.trigger);
    }

    init() {
        if ( !elementsExist([this.trigger]) ) return;
        
        this.initEventListeners();
    }

    initEventListeners() {
        this.trigger.on('click', () => (this.toggleProperties()));
    }

    toggleProperties() {        
        this.elements.filter(".activated").each(function(index, element){
            let $element = jquery_default()(element)
            let $target = jquery_default()($element.data('toggle'));
            $element.removeClass('activated');
            $target.removeClass('activated');
        })
    }
}
;// CONCATENATED MODULE: ./assets/js/accordion.js



const Accordion = (function(){
  const cache = {
    $toggle: jquery_default()(".js-expandable-toggle"),
    $content: jquery_default()(".js-expandable-content"),
    $group: jquery_default()(".js-expandable-group")
  }

  const settings = {
    activeClass: "active"
  }

  const init = function(){
    if (!elementsExist([cache.$toggle])) return;

    cache.$toggle.on('click', toggleContent);
  }

  const hideContent = function($content, $toggle){
    $content.removeClass(settings.activeClass)
    $toggle.removeClass(settings.activeClass)

    $content.slideUp(300)
    $content.attr( 'aria-expanded', false )

    $toggle.find('.icon-plus').removeClass('hidden')
    $toggle.find('.icon-minus').addClass('hidden')
  }

  const showContent = function($content, $toggle){
    $content.addClass(settings.activeClass)
    $toggle.addClass(settings.activeClass)

    $content.slideDown(300)
    $content.attr( 'aria-expanded', true )

    $toggle.find('.icon-plus').addClass('hidden')
    $toggle.find('.icon-minus').removeClass('hidden')

    $content.find('.js-slick').slick()
  }

  const toggleContent = function(e){
    let $this = jquery_default()(this)
    let toggleReference = $this.data('toggle')
    let $content = cache.$content.closest(`#${toggleReference}`)


    if ($content.hasClass(settings.activeClass)) {
      hideContent($content, $this)
    } else {
      showContent($content, $this)

      let $group = $this.parents(".js-expandable-group")
      let $groupContent = $group.find(".js-expandable-content").not($content)
      let $groupToggle = $group.find(".js-expandable-toggle").not($this)

      hideContent(
        $groupContent,
        $groupToggle
      )
    }

    return false;
  }

  return {
    init
  }
})()

/* harmony default export */ const accordion = (Accordion);

;// CONCATENATED MODULE: ./assets/js/audioTrigger.js
// audioTrigger.js




const AudioTrigger = (function(){
  const selectors = {
    playButton: ".js-play-pronunciation",
    pronunciationFile: ".js-product-pronunciation"
  }

  const init = function(){
    if (elementsExist([jquery_default()(selectors.playButton), jquery_default()(selectors.pronunciationFile)])) {
      initEventListeners()
    }
  }

  const initEventListeners = function(){
    jquery_default()(selectors.playButton).on('click', playAudio);
  }

  const playAudio = function(e){
    let $this = jquery_default()(this);
    let pronunciationAudio = $this.find(selectors.pronunciationFile)[0]

    if (pronunciationAudio) {
      pronunciationAudio.play()
    }
  }

  return { init }
})()

/* harmony default export */ const audioTrigger = (AudioTrigger);

;// CONCATENATED MODULE: ./assets/js/backInStock.js



const BackInStock = (function() {
  const selectors = {
    bisSubmit: ".js-bis-submit",
    bisInput: ".js-bis-input",
    bisLabel: ".js-bis-label",
    bisText: ".js-bis-text",
    bisForm: ".js-bis-form",
    bisError: ".js-bis-error"
  }

  const init = function(){
    if (elementsExist([selectors.bisSubmit])) {
      initEventListeners()
    }
  }

  const initEventListeners = function(){
    jquery_default()(selectors.bisSubmit).on('click', subscribeToBIS)
  }

  const subscribeToBIS = function(e){
    let productId = jquery_default()(this).data('productId');
    let variantId = jquery_default()(this).data('variantId');
    let productTitle = jquery_default()(this).data('productTitle');
    let email = jquery_default()(selectors.bisInput).val();

    //Empty email validation
    if(email.length == 0){
      jquery_default()(selectors.bisError).text('Email field can not be blank')
      jquery_default()(selectors.bisError).removeClass('hidden')
    }

    if (variantId && email) {
      jquery_default().ajax({
        type: "POST",
        url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data: {
          a: "MYFtmx",
          email: email,
          variant: variantId,
          product: productId,
          platform: "shopify",
          subscribe_for_newsletter: false,
        },
        success: function(response){
          jquery_default()(selectors.bisText).text("You're on the list! You'll receive an email when " + productTitle + " becomes available.");
          jquery_default()(selectors.bisForm).hide();
          jquery_default()(selectors.bisError).addClass('hidden')
        },
        error: function(error){
          jquery_default()(selectors.bisError).text("We couldn't add your email, please double check your email and try again.")
          jquery_default()(selectors.bisError).removeClass('hidden')
        }
      })
    }
  }

  return { init }
})()


/* harmony default export */ const backInStock = (BackInStock);

;// CONCATENATED MODULE: ./assets/js/blendComponents.js



const BlendComponents = (function(){
  const settings = {
    searchButton: ".js-search-blends",
    roastDateSelect: "#blend-components",
    blendContainer: ".js-blend-container"
  }

  const init = function(){
    if (elementsExist([jquery_default()(settings.searchButton)])) {
      jquery_default()(settings.searchButton).on('click', renderBlendComponents);
    }
  }

  const renderBlendComponents = function(){
    
    //let activeDate = $(settings.roastDateSelect).val()
    // let $blendContainers = $(settings.blendContainer)
    // let $activeBlendContainer = $blendContainers.closest(`[data-date="${activeDate}"]`)

    let activeDate = jquery_default()(this).parents().siblings().children('.js-hidden-option-select').val()
    let $blendContainers = jquery_default()(this).parents().parent().siblings('.js-blend-container')
    let $activeBlendContainer = $blendContainers.closest(`[data-date="${activeDate}"]`)

    $blendContainers.not($activeBlendContainer).addClass('hidden')
    $activeBlendContainer.removeClass('hidden')
  }

  return { init }
})()

/* harmony default export */ const blendComponents = (BlendComponents);

;// CONCATENATED MODULE: ./assets/js/cart.js



const Cart = (function(){
  const urls = {
    cartUpdate: '/cart/update.js',
    cartChange: '/cart/change.js',
    cartAdd: '/cart/add.js',
    cartGet: '/cart.json'
  }

  const settings = {
    slideCartContainer: ".js-cart--container",
    slideCartInner: ".js-cart--inner",
    closeCart: ".js-cart--close",
    openCart: "a[href='/cart']",
    removeItem: ".js-cart--remove-item",
    itemQuantity: ".js-item-quantity",
    quantityButton: ".js-change-quantity",
    itemSellingPlanOptions: ".js-hidden-item-select",
    itemDeliveryFrequency: ".js-cart-item-delivery",
    productForm: "form[action='/cart/add']",
    cartCount: ".cart_count",
    cartNoteTextarea: ".js-cart-note-textarea",
    cartNoteContainer: ".js-cart-note-container",
    cartNoteToggle: ".js-cart-note-toggle",
    checkoutButton: ".js-process-checkout",
    cartOverlay: ".js-cart--overlay",
    coffeeFill: ".js-cart-coffee-fill",
    shippingIndicator: ".js-shipping-indicator",
    shippingIndicatorBar: ".js-shipping-indicator-bar",
    zohoChatButton: ".zsiq_floatmain",
    subUpgradeBtn: ".subscription__upgrade",
    cartComplianceCheckbox: ".cart_compliance_checkbox",
    toggleBundleContentsBtn: ".view-bundle-contents__btn"
  }

  let $elementToFocusOnClose = jquery_default()(settings.openCart);

  const init = function(){
    if (!jquery_default()(settings.slideCartContainer).length) return;

    initializeEventListeners();
    buildCart();
  }




 
// Cart Free Gift Code Start 

// function Cart_free_gift_remove(){
	 
// 	 setTimeout(function(){
// 		// Cart.openCart();
//             Cart.buildCart();
// 	  }, 1500)
// 	  let alredy_p = '0';

//     fetch('/cart.json')
//       .then(res => res.json())
//       .then(cart => {

//         console.log("Current cart data:", cart);

//          alredy_p = '0';

//         // Check if free product already exists
//         cart.items.forEach(item => {
			
//           if (item.product_id == '6732362416205') {
//             alredy_p = '1';
// 			console.log('item.id',item.id);
//           }
//         });

		

// 		setTimeout(function(){
// 			console.log('alredy_p',alredy_p)
//         // Remove free product if parent product removed
//         cart.items.forEach(item => {
//           if (item.id == '42285262209101' && alredy_p == '0') {
//             let updates = {
//   42285262209101: 0,
// };

// fetch(window.Shopify.routes.root + 'cart/update.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({ updates })
// })
// .then(response => {
// 	//Cart.openCart();
//             Cart.buildCart();
//   return response.json();
// })
// .catch((error) => {
//   console.error('Error:', error);
// })
//       .catch(error => console.error("Error fetching cart data:", error));
// }
		
//         }, 500);
		

//       })
// 	})
  
// }

// document.addEventListener('click', function (e) {
//   if (!e.target.closest('.js-cart--container .js-cart--remove-item')) return;
//   setTimeout(() => {
// 	Cart_free_gift_remove();
// }, 2000);
// });

// document.addEventListener('click', function (e) {
//   if (!e.target.closest('.js-cart--container .js-change-quantity')) return;
//   setTimeout(() => {
// 	Cart_free_gift_remove();
// }, 2000);
// });


// document.querySelectorAll('.js-product-form-atc').forEach(btn => {
//   btn.addEventListener('click', function () {
// let alreadyP = false;
//     setTimeout(() => {
//       console.log('mainn iff');

// 	  setTimeout(function(){
// 		setTimeout(function(){
// 		// Cart.openCart();
// 		}, 1500);
//             Cart.buildCart();
// 	  }, 1500)

//       fetch('/cart.json')
//         .then(res => res.json())
//         .then(cart => {
//           console.log("Current cart data:", cart);

//            alreadyP = false;

//           // Check if specific variant already exists
//           cart.items.forEach(item => {
//             if (item.id == '42285262209101') {
//               alreadyP = true;
//             }
//           });

//           // Add free product only if not added yet
//           cart.items.forEach(item => {
//             if (item.product_id == '6732362416205' && !alreadyP) {

//               fetch('/cart/add.js', {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   quantity: 1,
//                   id: 42285262209101,
// 				   properties: {
//                     _is_gift: true 
//                 }
//                 })
//               })
//               .then(r => r.json())
//               .then(data => {
//                 console.log("Free product added:", data);
// 				setTimeout(function(){
// 		// Cart.openCart();
// 		}, 1500);
//             Cart.buildCart();
//               })
//               .catch(err => console.error("Error adding free item:", err));
//             }
//           });

//         })
//         .catch(err => console.error("Error fetching cart:", err));

//     }, 2000);

//   });
// });
// Cart Free Gift End Code 


  const initializeEventListeners = function(){
    jquery_default()(settings.slideCartContainer).on('click', settings.removeItem, handleItemRemove)
    jquery_default()(settings.slideCartContainer).on('click', settings.checkoutButton, processCheckout)
    jquery_default()(settings.slideCartContainer).on('change', settings.itemQuantity, adjustItemQuantity)
    jquery_default()(settings.slideCartContainer).on('change', settings.itemSellingPlanOptions, updateItemSellingPlan)
    jquery_default()(settings.slideCartContainer).on('change', settings.itemDeliveryFrequency, updateItemDeliveryFrequency)
    jquery_default()(settings.slideCartContainer).on('click', settings.subUpgradeBtn, upgradeToSubscription)
    jquery_default()(settings.slideCartContainer).on('click', settings.cartComplianceCheckbox, subComplianceCheckToggle)

    // $(settings.slideCartContainer).on('click', settings.quantityButton, updateItemQuantity)
    jquery_default()(settings.slideCartContainer).on('change', settings.cartNoteToggle, toggleCartNote)
    jquery_default()(settings.slideCartContainer).on('change', settings.cartNoteTextarea, updateCartNote)

    jquery_default()(document).on('submit', settings.productForm, handleProductSubmit)
    jquery_default()(document).on('quizKitAddToCartSuccess', handleQuizKitSubmit)

    if (location.pathname !== "/cart") {
      jquery_default()(document).on('click', settings.openCart, openCart)
      jquery_default()(document).on('click', `${settings.closeCart}, ${settings.cartOverlay}`, closeCart)
    }


    //Remove Bundle Item
    jquery_default()(document).on('click', '.bundle-product__remove', handleBundleRemove);

    //Toggle Bundle Contents
    jquery_default()(document).on('click', settings.toggleBundleContentsBtn, toggleBundleContents);
  }

  const upgradeToSubscription = function(e){
    e.preventDefault()


    const closestRadioButton = jquery_default()(e.target).parent().find('input[type="radio"][id^="delivery--subscribe--"]');

    if (closestRadioButton) {
      closestRadioButton.trigger('click');
    }

  }

  const subComplianceCheckToggle = function(e){
    //e.preventDefault();
    //console.log('subComplianceCheckToggle', $(e.target))
    jquery_default()('.compliance__checked').toggleClass('hidden');
    jquery_default()(settings.checkoutButton).prop('disabled', function (index, value) {
      return !value;
    });  
  }

  const handleQuizKitSubmit = function(e){
    buildCart()
    openCart()
  }

  // var listenForEscape = function(e){
  //   if (e.keyCode === 27) {
  //     closeCart(e);
  //   }
  // }

  const processCheckout = function(e){
    location.href = "/checkout"
  }

  const processCartRequest = function(data, endpoint, callback){
    var params = {
      url: endpoint,
      data: data,
      method: 'POST',
      dataType: 'json',
      success: function(cart){
        if (callback) {
          callback(cart);
        } else {
          buildCart();
        }
      },
      error: function(err){
        console.warn(err)
      }
    }

    jquery_default().ajax(params);
  }

  const toggleCartNote = function(e){
    let $this = jquery_default()(this);

    if ($this.is(":checked")){
      jquery_default()(settings.cartNoteContainer).slideDown(300)
    } else {
      jquery_default()(settings.cartNoteContainer).slideUp(300)
      jquery_default()(settings.cartNoteTextarea).val('').change()
    }
  }

  const updateCartNote = function(e){
    let $this = jquery_default()(this)
    let value = $this.val();

    let data = {
      note: value
    }

    processCartRequest(data, urls.cartUpdate, function(){})
  }

  const adjustItemQuantity = function(e){
    let $this = jquery_default()(this);
    let key = $this.data('key');

    let data = {
      updates: {
        [key]: $this.val()
      }
    }

    processCartRequest(data, urls.cartUpdate, function(){
      buildCart()
    });
  }

  const updateItemSellingPlan = function(e){
    let $this = jquery_default()(this)

    let data = {
      id: $this.data('key'),
      selling_plan: $this.val(),
      quantity: $this.data('quantity')
    }

    processCartRequest(data, urls.cartChange);
  }

  const updateItemDeliveryFrequency = function(e){
    let $this = jquery_default()(this)
    let data = {};
    let value = $this.val()

    if (value === "one-time") {
      data = {
        id: $this.data('key'),
        selling_plan: null,
        quantity: $this.data('quantity')
      }
    } else {
      data = {
        id: $this.data('key'),
        selling_plan: $this.data('default-plan'),
        quantity: $this.data('quantity')
      }
    }

    processCartRequest(data, urls.cartChange);
  }

  const handleProductSubmit = function(e){
    e.preventDefault()

    let $this = jquery_default()(this);
	console.log("this",$this);
    let data = $this.serialize();
		console.log("data",data);

    $elementToFocusOnClose = $this;

// 		function addProduct(formDataStr, productId, quantity) {
//   return `${formDataStr}&id=${encodeURIComponent(productId)}&quantity=${encodeURIComponent(quantity)}`;
// }

//    data = addProduct(data, window.free_product, "1");

	let ischeck = data.includes("selling_plan");

		  	// Add free tote
		if(ischeck && free_product_offer){
			setTimeout(()=>{
				let formData = {
				items: [{
					id: window.free_product, // Replace with your Variant ID
					quantity: 1
				}]
				};
				fetch('/cart/add.js',{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData)})
				.then(res=>res.json())
				.then(result=>{
					console.log("result",result)
					// setTimeout(function(){

					// })
						Cart.buildCart();
				})
				.catch(err=>console.log("err",err));

			},2000)
		}

    processCartRequest(data, urls.cartAdd, () => {

      buildCart()
	    if (location.pathname !== "/pages/single-origin-subscription"){
		  openCart()
      }else{
		setTimeout(()=>{
			window.location.href = '/checkout';

		},2000)
      }
      
      //openCart();
    })

  }

  const toggleBundleContents = function(e){
    e.preventDefault();


    let $this = jquery_default()(this);

    $this.toggleClass('content-open')
    $this.siblings('.set-contents').slideToggle();
  }

  const handleItemRemove = function(e){
    let $this = jquery_default()(this);
    let key = $this.data('key');

    let data = {
      updates: {
        [key]: 0
      }
    }



    processCartRequest(data, urls.cartUpdate, function(){
      buildCart(['header', 'items', 'footer'])
    });
  }


  const handleBundleRemove = function(e){
    e.preventDefault();

    // Find the closest '.cart-inner' element to the remove button
    var $cartInner = jquery_default()(this).closest('.cart-inner');
  
    // Get the value of the data-remove attribute
    var removeData = $cartInner.find('.data-remove').val(); 
  
    // Parse the data and create the jsonData object
    var jsonData = {
      updates: JSON.parse(removeData)
    };


  
    // Disable the button and change its text
    jquery_default()(this).css("pointer-events", "none");
  
    // Perform the AJAX request to remove the bundled product
    processCartRequest(jsonData, urls.cartUpdate, function(){
      buildCart(['header', 'items', 'footer'])
    });
  }

  const getCart = function(callback){
    jquery_default().ajax(urls.cartGet).then(callback);
  }

  const buildCart = function(sectionsToRender=['header', 'items', 'notes', 'upsell', 'footer']){
   // console.log('==== Build Cart called.. =====')
    getCart(function(cart){

      const isCartPage = location.pathname.includes('/cart');
      const sectionID = isCartPage
        ? jquery_default()(settings.slideCartContainer).filter('.cart--page').data('section-id')
        : 'ajax-cart';


      if (cart.item_count > 0) {
        jquery_default()(settings.coffeeFill).addClass('active')
      } else {
        jquery_default()(settings.coffeeFill).removeClass('active')
      }


      jquery_default().ajax(`/?sections=${ sectionID }`)

        .then(function(response){

          if ( response[sectionID] ) {
            let $response = jquery_default()(response[sectionID]);
            let $newInnerHTML = $response.find(settings.slideCartInner);
    


            let newShippingIndicator = $newInnerHTML.find(settings.shippingIndicatorBar)
            let newShippingIndicatorWidth = newShippingIndicator.data('width')
            newShippingIndicator.replaceWith(jquery_default()(settings.shippingIndicatorBar))


  
            if (cart.item_count > 0 && jquery_default()('.js-slide-cart--items').length){


          

              sectionsToRender.forEach(function(section){

                let $sectionEl = jquery_default()(settings.slideCartContainer).find(`.js-slide-cart--${section}`)
                let $newEl = $newInnerHTML.find(`.js-slide-cart--${section}`);
                $sectionEl.replaceWith($newEl)
              })

            } else {

              jquery_default()(settings.slideCartContainer).html($newInnerHTML)
            }

            //update nav cart count
            if (cart.item_count > 0) {
              jquery_default()(settings.cartCount).text(cart.item_count).removeClass('hidden')
            } else {
              jquery_default()(settings.cartCount).text(cart.item_count).addClass('hidden')
            }

            jquery_default()(settings.slideCartContainer).find(settings.shippingIndicatorBar).css({
              width: newShippingIndicatorWidth
            })
          }



          //Update Bundle Code:
          updateCartBundleItems(cart);
  

          





          //update complaince based on the items of the cart
         
          //Determine if there is any cart item that is a subscription
            const isSubscriptionInCart = cart.items.some(item => item.selling_plan_allocation);

            //console.log('--- after build ----', cart.items)
            if (isSubscriptionInCart) {
                
                // One subscription item
                //console.log('There is at least one subscription item in the cart.');
                //(settings.cartComplianceCheckbox).slideToggle(300)
                jquery_default()(settings.cartComplianceCheckbox).slideToggle(500)
                jquery_default()(settings.checkoutButton).attr('disabled', 'disabled')
            } else {
                
                // No subscription item
                //console.log('There are no subscription items in the cart.');
                jquery_default()(settings.checkoutButton).removeAttr('disabled')

            }



        })
        .catch(function(){})
    })
  }


  const updateCartBundleItems = function(cart){
//====== VARIANT BUNDLES: START =======//

              const isCartPage = location.pathname.includes('/cart');

              // Wrap items with '_bundleCode' property inside 'bundle__parent'
              var filterData=[];
		          filterData=cart.items.filter(cart => cart.properties != null && cart.properties._bundleCode != null);

              let grouped = Array.from(filterData.reduce((m, o) =>
	            m.set(o.properties._bundleCode, (m.get(o.properties._bundleCode) || []).concat(o)), new Map).values());
              //console.log('grouped', grouped, grouped.length);


              let bundleList=[];
              var setItemsList="";


              if(grouped.length > 0){
                for(var i = 0; i < grouped.length; i++){

                  let setItems="";
                  let bundleProductName = grouped[i][0].properties._bundleProductName;
                  let bundleProductImg = grouped[i][0].properties._bundleProductImg;
                  let bundleProductGradient = grouped[i][0].properties._bundleProductGradient;
                  let bundlePrice = grouped[i][0].properties._bundlePrice;
                  let removeObject = JSON.stringify(Object.fromEntries(grouped[i].map(group => [group.key, 0])))

                  let bundleQty = 1;
                 

                  for(var x = 0; x < grouped[i].length; x++){
 

                    var borderClass = x === grouped[i].length - 1 ? '' : 'border-b border-dashed border-grey';
                    bundleQty = grouped[i][x].quantity;

                    setItems+=`<div class="py-3 ${borderClass} flex gap-3 items-center" data-line-item="${x}">
                                  <img class="w-12" src="${grouped[i][x].featured_image.url}" alt="${grouped[i][x].title}" />
                                  <p class="font-semibold text-sm"> 1 x ${grouped[i][x].title}</p>
                    
                                </div>`;
                    setItemsList=setItems;
                  }

                  const totalPrice = bundlePrice * parseInt(bundleQty);
                  let formattedTotalPrice = formatMoney(totalPrice, "amount")

                  
                  bundleList.push(`
                  
                  <div class="cart-table-row bundle-item px-0 py-4 border-b border-grey bg-transparent relative ${isCartPage ? 'border-b-0 py-0 mb-10' : '' }">
                  <div class="cart-inner ${isCartPage ? 'border border-black border-b-0' : '' }">
                    <div class="slide-cart--item grid gap-2 md:gap-2.5">

                      <!-- =====  Bundle Image ===== -->
                      <div class="h-full ${isCartPage ? 'flex items-center' : '' }">
                        <div class="slide-cart--item-image" style="${bundleProductGradient}">
                            <img src="${bundleProductImg}" alt="${bundleProductName}">
                        </div>
                      </div>

                      <!-- =====  Bundle Details ===== -->
                      <div class="${isCartPage ? 'flex flex-col h-full justify-center p-4 md:p-9' : '' }">
                        <div class="flex flex-col mb-1">
                          <div class="flex justify-between mb-1">
                              <div class="flex flex-col gap-0">
                                <!-- Product Title -->
                                <h3 class="text-xl mb-0  ${isCartPage ? 'text-2xl md:text-3xl lg:text-4xl mb-0 font-acorn' : 'font-acorn-semibold' }">${bundleQty} x ${bundleProductName}</h3>
                              </div>

                              <!-- Remove button -->
                            
                              <button class=" ${isCartPage ? 'hidden' : '' }">
                                <input type="hidden" value='${removeObject}' class="data-remove" />
                                <a href="javascript:void(0)" class="bundle-product__remove">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                    <path d="M13.1094 3.09375C13.4902 3.09375 13.8125 3.41602 13.8125 3.79688C13.8125 4.20703 13.4902 4.5 13.1094 4.5H12.7578L12.0547 14.0215C11.9668 15.0176 11.1758 15.75 10.1797 15.75H4.29102C3.29492 15.75 2.50391 15.0176 2.41602 14.0215L1.71289 4.5H1.39062C0.980469 4.5 0.6875 4.20703 0.6875 3.79688C0.6875 3.41602 0.980469 3.09375 1.39062 3.09375H3.41211L4.49609 1.48242C4.78906 1.04297 5.31641 0.75 5.87305 0.75H8.59766C9.1543 0.75 9.68164 1.04297 9.97461 1.48242L11.0586 3.09375H13.1094ZM5.87305 2.15625C5.78516 2.15625 5.69727 2.21484 5.66797 2.27344L5.11133 3.09375H9.35938L8.80273 2.27344C8.77344 2.21484 8.68555 2.15625 8.59766 2.15625H5.87305ZM11.3516 4.5H3.11914L3.82227 13.9336C3.85156 14.168 4.05664 14.3438 4.29102 14.3438H10.1797C10.4141 14.3438 10.6191 14.168 10.6484 13.9336L11.3516 4.5Z" fill="#000F9F"/>
                                  </svg>
                                </a>
                              </button>
                              
                          </div>

                          <!-- Plan Status -->
                          <div class="plan_status text-sm font-semibold">
                              One Time Purchase
                          </div>

                          <div class="flex mt-2 font-variant-lining">
                            <span class="font-semibold text-base">$${formattedTotalPrice}</span>
                          </div>
                        </div>


                        <div class="flex items-center gap-2">
                        <!-- Quantity -->
                        <div class="grid grid-cols-3 gap-1 bg-white w-24 rounded-full border border-black ${isCartPage ? 'w-24' : 'w-1/2' }">
                            <label for="quantity--${bundleProductName}-{{ key }}" class="sr-only">Quantity</label>

                            <button type="button"
                                    class="js-change-quantity opacity-30 pointer-events-none
                                          btn-transparent ss-icon product-minus
                                          py-1 pl-3
                                          flex justify-center items-center"
                                    data-action="minus">
                              <span class="sr-only">Decrease Quantity of ${bundleProductName}</span>
                                <svg class="w-2" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.8 6H0.7C0.313401 6 0 6.3134 0 6.7V8.3C0 8.6866 0.313401 9 0.7 9H13.8C14.1866 9 14.5 8.6866 14.5 8.3V6.7C14.5 6.3134 14.1866 6 13.8 6Z" fill="currentColor"/>
                                </svg>
                            </button>

                            <input id="quantity--${bundleProductName}-{{ key }}"
                            type="number"
                            min="{{ min }}"
                            size="2"
                            class="text-center text-base py-1 js-quantity-input"
                            name="{{ name }}"
                            {% if key != blank %} data-key="{{ key }}"{% endif %}
                            value="${bundleQty}">


                            <button type="button"
                                    class="js-change-quantity opacity-30 pointer-events-none btn-transparent
                                    py-1 pr-3
                                    flex justify-center items-center ss-icon product-plus"
                                    data-action="plus">
                              <span class="sr-only">Increase Quantity of ${bundleProductName}</span>
                                <svg class="w-2" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.2837 5.97924H9.09344V0.726642C9.09075 0.53476 9.01333 0.351491 8.87764 0.215796C8.74195 0.0801017 8.55868 0.00268406 8.36679 0H6.69551C6.5046 0.00272761 6.32243 0.080486 6.1884 0.216464C6.05436 0.352441 5.97923 0.53571 5.97925 0.726642V5.97924H0.72666C0.535727 5.97922 0.352453 6.05435 0.216475 6.18838C0.0804974 6.32242 0.00273905 6.50459 1.14441e-05 6.6955V8.36678C0.00269551 8.55866 0.0801151 8.74193 0.21581 8.87763C0.351504 9.01332 0.534777 9.09074 0.72666 9.09342H5.97925V14.2837C5.97925 14.4737 6.05471 14.6559 6.18904 14.7902C6.32336 14.9245 6.50555 15 6.69551 15H8.36679C8.55773 15 8.741 14.9249 8.87698 14.7909C9.01295 14.6568 9.09071 14.4746 9.09344 14.2837V9.09342H14.2837C14.4747 9.0907 14.6568 9.01294 14.7909 8.87696C14.9249 8.74098 15 8.55771 15 8.36678V6.6955C15 6.60144 14.9815 6.5083 14.9455 6.4214C14.9095 6.3345 14.8567 6.25554 14.7902 6.18903C14.7237 6.12251 14.6448 6.06975 14.5578 6.03376C14.4709 5.99776 14.3778 5.97924 14.2837 5.97924V5.97924Z" fill="currentColor"/>
                                </svg>
                            </button>


                        </div>

                        <button class=" ${isCartPage ? 'block ml-2' : 'hidden' }">
                          <input type="hidden" value='${removeObject}' class="data-remove" />
                          <a href="javascript:void(0)" class="bundle-product__remove">
                          <svg  
                            " width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0.5 5.30951H11.5V16.5H0.5V5.30951Z" fill="currentColor" stroke="currentColor"></path>
                                  <path d="M12 3.2857L0 3.28571" stroke="currentColor"></path>
                                  <path d="M2.25 15.4762L2.25 6.33331" stroke="white"></path>
                                  <path d="M6 15.4762L6 6.33331" stroke="white"></path>
                                  <path d="M9.75 15.4762L9.75 6.33331" stroke="white"></path>
                                  <rect x="4.5" y="1" width="3" height="2.28571" stroke="currentColor"></rect>
                          </svg>
                          </a>
                        </button>
                        </div>


                      </div>

                      


                      

                    </div>


                  </div>


                  <div class="set-contents--wrapper w-full mt-6 cursor-pointer  ${isCartPage ? 'border border-black mt-0 py-6 px-5' : '' }">
                    <div class="view-bundle-contents__btn w-full flex justify-between items-center font-founders-grotesk-medium">
                      <span class="text-sm uppercase font-medium">View Bundle Contents</span>
                      <span class="set-content-svg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                          <path d="M1 1L6.5 6.5L12 1" stroke="black" stroke-width="1.5"/>
                        </svg>
                      </span>
                    </div>
                    <div class="set-contents hidden">
                      <div class="set-inner">
                        `+setItemsList+`
                      </div>
                    </div>
                  </div>


                  </div>`)

                  jquery_default()("body #cart__bundle-items").html(bundleList.join(''));
                }
              }
              else{

                jquery_default()("body #cart__bundle-items").html('');
              }




          //====== VARIANT BUNDLES: END =======// 

  }

  const openCart = function(e){
    if (e) {
      e.preventDefault()

      $elementToFocusOnClose = jquery_default()(this);
    }

    let $cartContainer = jquery_default()(settings.slideCartContainer);
    $cartContainer.show()

    setTimeout(function(){
      jquery_default()(settings.cartOverlay).removeClass('hidden');
      $cartContainer.addClass("active");

      jquery_default()(settings.zohoChatButton).css({
        transition: 'all .4s linear',
        transform: 'translateX(-28rem)'
      })

    }, 10)

    jquery_default()(settings.closeCart).focus();

    disableScroll()
  }

  const closeCart = function(e){
    if (e) {
      e.preventDefault()
    }

    let $cartContainer = jquery_default()(settings.slideCartContainer);
    $cartContainer.removeClass("active");
    jquery_default()(settings.cartOverlay).addClass('hidden');

    jquery_default()(settings.zohoChatButton).css({
      transition: 'all .4s linear',
      transform: 'translateX(0)'
    })

    setTimeout(function(){
      $cartContainer.hide()

      if ($elementToFocusOnClose && $elementToFocusOnClose.length) {
        $elementToFocusOnClose.focus()
      }
    }, 600)

    enableScroll()
  }

  return {
    init,
    getCart,
    buildCart,
    openCart,
    closeCart,
    processCartRequest
  }
})();

const {
  init,
  getCart,
  buildCart,
  openCart,
  closeCart,
  processCartRequest
} = Cart



;// CONCATENATED MODULE: ./assets/js/collectionNav.js


// ++++++++++++++++
//  Collection Nav
// ++++++++++++++++

const collectionNav = {
  settings: {
    nav: '.js-collection-nav',
    link: '.js-collection-nav--link',
    item: '.js-collection-nav--item',
    indicator: '.js-collection-nav--indicator'
  },

  init: function() {
    const $nav = jquery_default()(collectionNav.settings.nav);
    if ( !$nav.length ) return;

    // $(collectionNav.settings.link).on('click', (e) => collectionNav.handleClick(e));

    // Get collection sections
    const sections = collectionNav.gatherSections($nav);

    jquery_default()(document).on('scroll', function() {
      const sectionVisibility = collectionNav.checkSectionVisibility(sections);

      // Find the section w/ largest viewport presence
      const sortableSections = Object.entries(sectionVisibility);
      sortableSections.sort((a, b) => {
        return b[1] - a[1];
      });

      // Find the associated link
      collectionNav.updateLinks($nav, sortableSections);
    });

    // $(document).trigger('scroll');
  },

  handleClick: function(e) {
    e.preventDefault();

    const $link = jquery_default()(e.currentTarget);
    const $targetSection = jquery_default()($link.attr('href'));

    const scrollTarget = $targetSection.offset().top;
    const navHeight = jquery_default()('.js-nav .content').innerHeight();

    window.scrollTo(0, scrollTarget - navHeight);
  },

  gatherSections: function($nav) {
    let sections = [];

    const $navLinks = $nav.find(collectionNav.settings.link);
    $navLinks.each(function() {
      const $link = jquery_default()(this);
      const href = $link.attr('href').substring(1);

      sections.push(document.getElementById(href));
    });

    return sections;
  },

  checkSectionVisibility: function(sections) {
    const viewportHeight = window.innerHeight;
    const viewportTop = jquery_default()(document).scrollTop();
    const viewportBottom = viewportTop + viewportHeight;

    const sectionVisibility = {};

    sections.forEach((section) => {
      const $section = jquery_default()(section);

      const sectionHeight = $section.height();
      const sectionTop = $section.offset().top;
      const sectionBottom = sectionTop + sectionHeight;

      // Check if section is (at least) partially on screen
      const issectionVisible = (viewportTop < sectionBottom) && (viewportBottom > sectionTop);
      if ( issectionVisible ) {
        let pxOffScreen = 0;

        if ( viewportTop > sectionTop ) { // px above screen
          const pxAboveScreen = viewportTop - sectionTop;
          pxOffScreen = pxOffScreen + pxAboveScreen;
        }

        if ( viewportBottom < sectionBottom ) { // px below screen
          const pxBelowScreen = sectionBottom - viewportBottom;
          pxOffScreen = pxOffScreen + pxBelowScreen;
        }

        const pxOnScreen = sectionHeight - pxOffScreen;

        if ( pxOnScreen >= 150 ) {
          sectionVisibility[$section.attr('id')] = pxOnScreen;
        }
      }
    });

    return sectionVisibility;
  },

  updateLinks: function($nav, sortableSections) {

    const $navIndicator = $nav.find(collectionNav.settings.indicator);
    const $links = jquery_default()(collectionNav.settings.link);

    if ( sortableSections && sortableSections[0] && sortableSections[0][0] ) {
      const activeLink = sortableSections[0][0];
      const $activeLink = $links.filter(`[href="#${ activeLink }"]`);

      $links.removeClass('active');
      $activeLink.addClass('active');

      $navIndicator.css({
        left: $activeLink.position().left + 'px',
        width: $activeLink.width() + 'px'
      });
    } else {
      $navIndicator.css({ width: 0 });
      $links.removeClass('active');
    }
  }
};

/* harmony default export */ const js_collectionNav = (collectionNav);

;// CONCATENATED MODULE: ./assets/js/customerAddresses.js


const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button.js-add-edit-btn',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: '.js-delete-address',
  hideElementsOnToggle: ".js-hide-on-toggle"
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

const CustomerAddresses = (function(){
  let elements = {}

  const getElements = function(){
    const container = jquery_default()(selectors.customerAddresses);
    return container.length ? {
      container,
      addressContainer: jquery_default()(selectors.addressContainer),
      toggleButtons: jquery_default()(selectors.toggleAddressButton),
      cancelButtons: jquery_default()(selectors.cancelAddressButton),
      deleteButtons: jquery_default()(selectors.deleteAddressButton),
      countrySelects: jquery_default()(selectors.addressCountrySelect),
      hideElementsOnToggle: jquery_default()(selectors.hideElementsOnToggle)
    } : {};
  }

  const setupCountries = function() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      //console.log('CountryProvinceSelector')
      new Shopify.CountryProvinceSelector('AddressCountry_new', 'AddressProvince_new', {
        hideElement: 'AddressProvinceContainer_new'
      });
      // eslint-disable-next-line no-new

      elements.countrySelects.each((index, select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  const initEventListeners = function() {
    // elements.toggleButtons.on('click', handleAddEditButtonClick)
    // elements.cancelButtons.on('click', handleCancelButtonClick)
    // elements.deleteButtons.on('click', handleDeleteButtonClick)


    //$('.js-delete-address').on('click', handleDeleteButtonClick)

    
    //Updated Address Code
    const loc = window.location.href;
    if(loc.includes('address_form')){
      //https://counterculturecoffee.com/account/addresses?address_form=true

      jquery_default()('#AddAddress').toggleClass("hidden");
    }
    else if(loc.includes('#EditAddress')){
      //https://counterculturecoffee.com/account/addresses#EditAddress_7597093912653

      const url = loc;
      const regex = /#EditAddress_(\d+)/;
      const match = url.match(regex);

      if (match) {
        const addressId = match[1];
        //console.log("Address ID:", addressId);
        jquery_default()("#EditAddress_" + addressId).toggleClass("hidden")
      } else {
        //console.log("Address ID not found in the URL.");
      }
    }

    else{
      jquery_default()("#deleteSuccess").toggleClass("hidden")
    }
  }

  const toggleExpanded = function($target) {
    $target.toggleClass('hidden')
    elements.hideElementsOnToggle.toggle()
  }

  const handleAddEditButtonClick = function(e){
    let $this = jquery_default()(this)
    let target = jquery_default()($this.data('target'))

    toggleExpanded(target)
  }

  const handleCancelButtonClick = function(e){
    let $this = jquery_default()(this)
    let target = jquery_default()($this.data('target'))

    toggleExpanded(target)
  }

  const handleDeleteButtonClick = function(e){
    //console.log('handledeletebutton')
    Shopify.postLink(jquery_default()(this).data('target'), {
      parameters: { _method: 'delete' },
    });

  }


    jquery_default()(".address-delete").on("click", function() {
      //console.log('address delete')
      var t = jquery_default()(this),
          e = t.data("form-id"),
          t = t.data("confirm-message");

    confirm("Are you sure you wish to delete this address?") && Shopify.postLink(jquery_default()(this).data('target'), {
      parameters: { _method: 'delete' },
    });
    })



  const init = function(){
    elements = getElements();

    //console.log('elements: ', elements)


    //Removed these elements from the page, hence commenting it out
    if (Object.keys(elements).length === 0) return;

    setupCountries();
    initEventListeners();
  }

  return {
    init
  }
})()

/* harmony default export */ const customerAddresses = (CustomerAddresses);

;// CONCATENATED MODULE: ./assets/js/customSelect.js


const CustomSelect = function($customSelectContainer){
  const cache = {
    $selectTrigger: $customSelectContainer.find(".js-custom-select-trigger"),
    $selectTriggerText: $customSelectContainer.find(".js-select-trigger-text"),
    $customSelectOptions: $customSelectContainer.find(".js-custom-select-options"),
    $selectOption: $customSelectContainer.find(".js-option-select")
  }

  let settings = {
    activeClass: "active"
  }

  const initEventListeners = function(){
    cache.$selectTrigger.on('click', toggleCustomSelect)
    cache.$selectOption.on('click', setActiveOption)
  }

  const toggleCustomSelect = function(e){
    e.preventDefault()
    e.stopPropagation()

    let $this = jquery_default()(this);
    cache.$selectTrigger.toggleClass('active')
    cache.$customSelectOptions.toggleClass('hidden')
  }

  const closeCustomSelect = function(){
    cache.$customSelectOptions.addClass('hidden')
    cache.$selectTrigger.removeClass('active')
  }

  const setOptionText = function(value){
    cache.$selectTriggerText.text(value)
  }

  const setActiveOption = function(e){
    e.preventDefault()
    e.stopPropagation()

    let $this = jquery_default()(this)
    let value = $this.data('value')
    let text = $this.text().trim()
    let target = $this.data('target')
    
    let targetNode = document.getElementById(target)

    let $targetSelect = jquery_default()(targetNode)

    $targetSelect.val(value).change()

    cache.$selectOption.removeClass(settings.activeClass)

    $this.addClass(settings.activeClass)

    setOptionText(text)

    closeCustomSelect()
  }

  initEventListeners()
}

/* harmony default export */ const customSelect = (CustomSelect);

;// CONCATENATED MODULE: ./assets/js/customSelectInit.js




const CustomSelectInit = (function(){
  const selectors = {
    customSelectContainer: ".js-custom-select-container"
  }

  const init = function(){
    if (!elementsExist([selectors.customSelectContainer])) return;

    jquery_default()(selectors.customSelectContainer).each(function(index, customSelectContainer){
      customSelect(jquery_default()(customSelectContainer))
    })
  }

  // Events for escape key or document click off to close.

  return {
    init
  }

})()

/* harmony default export */ const customSelectInit = ((/* unused pure expression or super */ null && (CustomSelectInit)));

;// CONCATENATED MODULE: ./assets/js/filterOptions.js


const FilterOptionList = (function(){
  let baseUrl = location.pathname
  let baseFilterURL = "filter.p.m.filters."
  // .roast-level=
  let sortUrl = "sort_by="
  let sectionRenderingURL = "sections=collection-grid"
  let sortOption = ""
  let activeFilters = []

  const settings = {
    sectionWrapper: '.js-filter-section',
    filterWrapper: '[data-filter-wrapper]',
    filterContainer: '.js-filter-container',
    filterTrigger: '.js-trigger-filter-container',
    filterOption: '.js-collection-filter-option',
    filterOptionMob: '.js-collection-filter-option-mob',
    removeFilter: '.js-remove-filter',
    activeFilterContainer: '.js-active-filter-container',
    filterCount: ".js-active-filter-count",
    filterTitle: ".js-active-filter-title",
    collectionList: ".js-collection-list",
    sortOptionButton: ".js-collection-sort-option",
    clearFiltersBtn: ".js-clear-filters",
    applyFiltersBtn: ".js-apply-filters",
    subscriptionColFilterBtn: ".js-collection__sub-tab"
  }

  let marqueeSection = document.querySelector('.js__section-marquee');
  let bannerSection = document.querySelector('.js__section-banner');
  let rotatingSection = document.querySelector('.js__section-rotating');

  let breakerUSP = document.querySelector('.plp--section-breaker-usp');
  let breakerReview = document.querySelector('.plp--section-breaker-reviews');

  let breakerProduct = document.querySelector('.plp--section-breaker-product');

  let breakerSub = document.querySelector('.plp--section-breaker-sub');

  let breakerBrew = document.querySelector('.plp--section-breaker-brew');

  let breakerBreville = document.querySelector('.plp--section-breaker-breville');

  // sections/subscription-product-feature.liquid in "PLP breaker" mode
  // + sections/subscription-testimonial.liquid (same placement settings)
  let breakerSubProducts = document.querySelectorAll('.plp--section-breaker-sub-product');

  let breakerSubProductsTrestimonial = document.querySelectorAll('.plp--section-breaker-testimonial');

  let breakerfindcoffee= document.querySelectorAll('.plp--section-breaker-rhythm');


  let breakerQuiz = document.querySelector('.plp--section-breaker-quiz');






  const init = function(){
    //if (!elementsExist([ settings.filterTrigger, settings.filterContainer ])) return;
   
    insertSectionsBetweenProducts()
    initializeEventListeners()
    getActiveFiltersOnLoad()


    let sectionData = $(settings.sectionWrapper).data();

    if (sectionData && sectionData.filterUrl) {
      baseFilterURL = sectionData.filterUrl
      sectionRenderingURL = sectionData.section
    }
  }





  const insertSectionsBetweenProducts = function(){
   //PLP Breaker 1 - Product
   if(breakerProduct){
    if($(".js-collection-list > ul > li").length > 4){
      breakerProduct.classList.remove('hidden')
      $(".js-collection-list > ul > li:nth-child(4)").after(breakerProduct)
     }
     else{
      breakerProduct.classList.add('hidden')
     }
   }
   


   //PLP Breaker 2 - Subscription
   if(breakerSub){
    if($(".js-collection-list > ul > li").length >= 13){
      breakerSub.classList.remove('hidden')
      $(".js-collection-list > ul > li:nth-child(13)").after(breakerSub)
    }
    else{
      breakerSub.classList.add('hidden')
    } 
   }

   //PLP Breaker 3 - Brew
   if(breakerBrew){
    if($(".js-collection-list > ul > li").length >= 18){
      breakerBrew.classList.remove('hidden')
      $(".js-collection-list > ul > li:nth-child(18)").after(breakerBrew)
    }
    else{
      breakerBrew.classList.add('hidden')
    }
   }

   if(window.location.href.includes("collections/equipments")){
	   if(breakerBreville){
		if($(".js-collection-list > ul > li").length >= 1){
		  breakerBreville.classList.remove('hidden')
		  $(".js-collection-list > ul > li:nth-child(2)").after(breakerBreville)
		}
		else{
		  breakerBreville.classList.add('hidden')
		}
	   }

   }

   //PLP Breaker - Subscription product. Position and collections come from the

      //section's data attributes; other breakers are skipped when counting products.
   breakerSubProductsTrestimonial.forEach(function(breaker){
    let handles = (breaker.dataset.collections || '').split(',').map(function(h){ return h.trim() }).filter(Boolean)
    let onAllowedCollection = handles.length === 0 || handles.some(function(h){
      return window.location.pathname.includes('/collections/' + h)
    })
    let insertAfter = parseInt(breaker.dataset.insertAfter, 20) || 6
    let $products = $(".js-collection-list > ul > li").not('[class*="plp--section-breaker"]')

    if(onAllowedCollection && $products.length >= insertAfter){
      breaker.classList.remove('hidden')
      $products.eq(insertAfter - 1).after(breaker)
    }
    else{
      breaker.classList.add('hidden')
    }
   })

      //section's data attributes; other breakers are skipped when counting products.
   breakerfindcoffee.forEach(function(breaker){
    let handles = (breaker.dataset.collections || '').split(',').map(function(h){ return h.trim() }).filter(Boolean)
    let onAllowedCollection = handles.length === 0 || handles.some(function(h){
      return window.location.pathname.includes('/collections/' + h)
    })
    let insertAfter = parseInt(breaker.dataset.insertAfter, 20) || 10;
    let $products = $(".js-collection-list > ul > li").not('[class*="plp--section-breaker"]')

    if(onAllowedCollection && $products.length >= insertAfter){
      breaker.classList.remove('hidden')
      $products.eq(insertAfter - 1).after(breaker)
    }
    else{
      breaker.classList.add('hidden')
    }
   })

      //section's data attributes; other breakers are skipped when counting products.
   breakerSubProducts.forEach(function(breaker){
    let handles = (breaker.dataset.collections || '').split(',').map(function(h){ return h.trim() }).filter(Boolean)
    let onAllowedCollection = handles.length === 0 || handles.some(function(h){
      return window.location.pathname.includes('/collections/' + h)
    })
    let insertAfter = parseInt(breaker.dataset.insertAfter, 10) || 6
    let $products = $(".js-collection-list > ul > li").not('[class*="plp--section-breaker"]')

    if(onAllowedCollection && $products.length >= insertAfter){
      breaker.classList.remove('hidden')
      $products.eq(insertAfter - 1).after(breaker)
    }
    else{
      breaker.classList.add('hidden')
    }
   })

   //PLP Breaker 4 - Quiz
   if(breakerQuiz){
      if($(".js-collection-list > ul > li").length >= 27){
        breakerQuiz.classList.remove('hidden')
        $(".js-collection-list > ul > li:nth-child(27)").after(breakerQuiz)
      }
      else{
        breakerQuiz.classList.add('hidden')
      }
    }

  
  }






  const getActiveFiltersOnLoad = function(){
    var currentURL = window.location.href;

    var queryString = currentURL.split('?')[1];
    //console.log(currentURL, queryString)

    if(queryString != undefined){
      var queryParams = queryString.split('&');
      var filterObjects = [];

      // Loop through each query parameter and extract its name and value
      for (var i = 0; i < queryParams.length; i++) {
        var param = queryParams[i].split('=');
        var paramName = decodeURIComponent(param[0]);
        var paramValue = decodeURIComponent(param[1]);

        // If the parameter name starts with "filter.", it's a filter parameter
        if (paramName.startsWith('filter.')) {
          paramName = paramName.replace('filter.', ''); 
          paramName = paramName.replace('p.m.filters.', '');
          var filterObject = {
            name: paramName,
            value: paramValue
          };
          filterObjects.push(filterObject);
        }
      }

      //Instead of Activating, call the handleCollectionFilter method for all the triggers that are active
      filterObjects.forEach(function(filterObject){
        $('.js-collection-filter-option').each(function(){
          if($(this).attr('data-value').toLowerCase() == filterObject.value){
            activateSelectedFiltersOnLoad($(this))           
          }
        })
      })
      
    }
  }

  const activateSelectedFiltersOnLoad = function($this) {
    let filterValue = $this.data('value');
    let filterGroup = $this.data('key')

    let filterOnLoad = {
      name: filterGroup,
      value: filterValue
    }

    addOrRemoveFilterValue(filterOnLoad)
    renderActiveFilterList()
	console.log("activateSelectedFiltersOnLoad.....");
    updateFilterCount()
    // getFilteredSection()
  }

  const initializeEventListeners = function(){
    $(settings.filterTrigger).on('click', toggleFilterContainer)
    $(settings.filterOption).on('click', handleCollectionFilter)
    $(settings.filterOptionMob).on('click', handleCollectionFilter)
    $(document).on('click', handleOffClick)
    $('.js-trigger-filter-close').on('click', handleFilterClose)

    $(document).on('click', settings.removeFilter, handleCollectionFilter)
    $(settings.sortOptionButton).on('click', handleCollectionSort)
    $(settings.clearFiltersBtn).on('click', clearFilters)
	$(settings.applyFiltersBtn).on('click', applyFilters)


    $(settings.subscriptionColFilterBtn).on('click', handleSubscriptionFilter)
    
  }


  const handleSubscriptionFilter = function(e){
    //e.stopPropagation()
     $(this).addClass('plp_tab_active').siblings().removeClass('plp_tab_active')

     let subFilterSelected = $(this).attr('data-sub-plp-filter')
     // Optional: a different product metafield than coffee-type (e.g. certification
     // for organic), or a product tag (e.g. gift-subscription) for tabs that have
     // no storefront filter.
     let subFilterKey = $(this).attr('data-sub-plp-filter-key') || 'coffee-type'
     let subFilterTag = $(this).attr('data-sub-plp-tag')

     getFilteredSectionForSubscription(subFilterSelected, subFilterKey, subFilterTag)
  }

  

  const toggleFilterContainer = function(e){
    e.stopPropagation()

    $(settings.filterWrapper).removeClass('z-30').addClass('z-50')


    let $this = $(this);
    let target = $this.data('target')

    let $parentContainer = $this.parents(settings.filterContainer).eq(0)

    let $targetContainer = $parentContainer.find(`${settings.filterContainer}[data-target="${target}"]`)
    let $otherContainers = $parentContainer.find(settings.filterContainer).not($targetContainer)
    let $otherTriggers = $parentContainer.find(settings.filterTrigger).not($this)
	$('body').toggleClass('freeze');

    if ($targetContainer.length) {
      $otherContainers.hide()
      $otherTriggers.removeClass('active')

      $this.toggleClass('active')
      $targetContainer.slideToggle(200, function(){
        if ($targetContainer.is(":visible")) {
          $('.js-trigger-filter-close-mobile').removeClass('hidden');
        } else {
          $('.js-trigger-filter-close-mobile').addClass('hidden');
        }
      })
    }
  }

  const handleOffClick = function(e){

    let $target = $(e.target);
    let targetHasFilterParents = $target.parents('.js-filter-container').length
    let targetHasActiveFilterParents = $target.parents('.js-remove-filter').length
	
    if (!(targetHasFilterParents ||
          $target.hasClass('js-filter-container') ||
          targetHasActiveFilterParents ||
          $target.hasClass('js-remove-filter'))
        ) {
      $(settings.filterContainer + '[data-target]').slideUp(200)
      $(settings.filterTrigger).removeClass('active')

      $('.js-trigger-filter-close-mobile').addClass('hidden');

      $(settings.filterWrapper).removeClass('z-50').addClass('z-30')
    }
	$('body').removeClass('freeze');

  }

function toTitleCase(str) {
  return str.replace(/\b[\w-]+\b/g, (word) =>
    word
      .split("-")
      .map(
        (part) =>
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
      )
      .join("-")
  );
}

  var filterObjectsv2 = [];
 

  const handleFilterClose = function(){
    $(settings.filterContainer + '[data-target]').slideUp(200)
    $(settings.filterTrigger).removeClass('active')
    $('.js-trigger-filter-close-mobile').addClass('hidden');
    $('body').removeClass('freeze');
    $(settings.filterWrapper).removeClass('z-50').addClass('z-30')
	// getActiveFiltersOnLoad();

	let currentURLv2 = window.location.href;

    let queryStringv2 = currentURLv2.split('?')[1];
    filterObjectsv2 = [];
    if(queryStringv2 != undefined){
      let queryParamsv2 = queryStringv2.split('&');

      for (let i = 0; i < queryParamsv2.length; i++) {
        let paramv2 = queryParamsv2[i].split('=');
        let paramNamev2 = decodeURIComponent(paramv2[0]);
        let paramValuev2 = decodeURIComponent(paramv2[1]);

        if (paramNamev2.startsWith('filter.')) {
          paramNamev2 = paramNamev2.replace('filter.', ''); 
          paramNamev2 = paramNamev2.replace('p.m.filters.', '');
          var filterObjectv2 = {
            name: paramNamev2,
            value: toTitleCase(paramValuev2)
          };
          filterObjectsv2.push(filterObjectv2);
        }
      }

    }
	console.log("filterObjectsv2",filterObjectsv2,"new");
	$(settings.filterOption).removeClass('active')
	$(settings.filterOptionMob).removeClass('active')
	
	filterObjectsv2.forEach(filter => {
		let filterValue2 = toTitleCase(filter.value);
		// let filterValue2 = filter.value;
		console.log("filterValue2",filterValue2);
		$(settings.filterOption).closest(`[data-value="${filterValue2}"]`).addClass('active')
		$(settings.filterOptionMob).closest(`[data-value="${filterValue2}"]`).addClass('active')
	})
	activeFilters = [...filterObjectsv2];
		$('.filter_count').each(function(elem){
		$(this).text(' ('+ filterObjectsv2.length + ')');
	})
  }

  const handleCollectionSort = function(e){
    let $this = $(this);

    if (!$this.hasClass('active')) {
      sortOption = $this.data('value')

      $this.addClass('active')
      $(settings.sortOptionButton).not($this).removeClass('active')

      getFilteredSection()
    }
  }

  /**
  * Adds or Removes filterValue from activeFilters array
  * @param filterValue [String]
  */
  const addOrRemoveFilterValue = function(filter){
    let filterInArray = activeFilters.find(currentFilter => currentFilter.value === filter.value);

    if (filterInArray) {
      // Removes active filter from filter array
      activeFilters = activeFilters.filter(currentFilter => currentFilter.value !== filter.value);
    } else {
      // Adds active filter to filter array
      activeFilters.push(filter)

    }

  }

  /**
  * Renders a list of <li> items to the activeFilterContainer
  */
  const renderActiveFilterList = function(){
    let filterListHTML = ""

    $(settings.filterOption).removeClass('active')
    $(settings.filterOptionMob).removeClass('active')

	activeFilters.forEach(filter => {
	  $(settings.filterOption).closest(`[data-value="${filter.value}"]`).addClass('active')
	  $(settings.filterOptionMob).closest(`[data-value="${filter.value}"]`).addClass('active')

	  let filterValueHTML = `
		<li class="my-1 flex items-center">
		  <button class="js-remove-filter btn-transparent filter--trigger-btn active text-sm uppercase flex items-center py-1 px-3" data-key="${filter.name}" data-value="${filter.value}">
			<span class="mr-2">${filter.value}</span>

			<svg class="w-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.8314 5.85215L13.4785 0.205025C13.7519 -0.0683413 14.1951 -0.0683425 14.4685 0.205024L15.5999 1.3364C15.8732 1.60976 15.8732 2.05298 15.5999 2.32635L9.95272 7.97347L15.4785 13.4993C15.7519 13.7727 15.7519 14.2159 15.4785 14.4892L14.3472 15.6206C14.0738 15.894 13.6306 15.894 13.3572 15.6206L7.8314 10.0948L2.44767 15.4785C2.1743 15.7519 1.73108 15.7519 1.45772 15.4785L0.326345 14.3472C0.0529781 14.0738 0.0529788 13.6306 0.326346 13.3572L5.71008 7.97347L0.205026 2.46842C-0.0683414 2.19505 -0.0683419 1.75184 0.205025 1.47847L1.3364 0.347099C1.60976 0.0737322 2.05298 0.0737327 2.32635 0.3471L7.8314 5.85215Z" fill="#05043D"/>
			</svg>
		  </button>
		</li>
	  `

	  filterListHTML += filterValueHTML;
	})


    $(settings.activeFilterContainer).html(filterListHTML)
  }

  const updateFilterCount = function(){
    $(settings.filterCount).text(activeFilters.length);
    $('.filter_count').each(function(elem){
		$(this).text(' ('+ activeFilters.length + ')');
	})
	console.log("work...",$('#filter_count'))
    activeFilters.length > 0
      ? $(settings.filterTitle).removeClass('hidden')
      : $(settings.filterTitle).addClass('hidden');
  }

  const getBlogFilterURL = function(){
    let filterParams = ""
    let url = ""

    activeFilters.forEach(filter => {
      filterParams += (filterParams === "" ? filter.value : ("+" + filter.value))
    })

    if (filterParams) {
      url = baseUrl + baseFilterURL + filterParams + "/?" + sectionRenderingURL;
    } else {
      url = baseUrl + "/?" + sectionRenderingURL;
    }

    return url;
  }

  const getCollectionFilterURL = function(){
    let filterParams = ""
    let url = ""

    activeFilters.forEach(filter => {
      if (!filterParams) {
        filterParams += ("?" + baseFilterURL + filter.name.toLowerCase() + "=" + filter.value.toLowerCase());
      } else {
        filterParams += ("&" + baseFilterURL + filter.name.toLowerCase() + "=" + filter.value.toLowerCase());
      }
    })

    if (filterParams) {
      url = baseUrl + filterParams + "&sort_by=" + sortOption + "&" + sectionRenderingURL;
    } else {
      url = baseUrl + "?sort_by=" + sortOption + "&" + sectionRenderingURL;
    }


    //This is the code to add the filter and sort params to the URL
    //let finalURL = filterParams + "&sort_by=" + sortOption
    let finalURL = filterParams  

    updateURLHash(finalURL)

    return url;
  }


  const updateURLHash = function (searchParams) {
    // history.pushState(
    //     { searchParams },
    //     '',
    //     `${window.location.pathname}${searchParams && '/'.concat(searchParams)}`
    // );

    const path = window.location.pathname;
    const newPath = searchParams ? `${path}${path.endsWith('/') ? '' : '/'}${searchParams}` : path;
    history.pushState(
      { searchParams },
      '',
      newPath
    );
  }

  const getFilteredSection = function(){
    let url = "";
    let section = sectionRenderingURL.replace("sections=", "")


    if (baseUrl.includes('/blogs')) {
      url = getBlogFilterURL()
    } else {
      url = getCollectionFilterURL()
    }

    $.ajax(url)
      .then(response => {
        let $htmlResponse = $(response[section])
        let $newCollectionList = $htmlResponse.find(settings.collectionList).eq(0)

        $(settings.collectionList).eq(0).replaceWith($newCollectionList)


        insertSectionsBetweenProducts()
      })
  }


  const getFilteredSectionForSubscription = function(subFilterSelected, subFilterKey = 'coffee-type', subFilterTag = ''){

    let url = "";
    let section = sectionRenderingURL.replace("sections=", "")

    if (subFilterTag) {
      url = `/collections/subscriptions/${encodeURIComponent(subFilterTag)}?sections=collection-grid`
    } else {
      url = `/collections/subscriptions/?filter.p.m.filters.${subFilterKey}=${subFilterSelected}&sections=collection-grid`
    }
    //console.log('url: ', url)

    $.ajax(url)
      .then(response => {

        let $htmlResponse = $(response[section])
        let $newCollectionList = $htmlResponse.find(settings.collectionList).eq(0)

        $(settings.collectionList).eq(0).replaceWith($newCollectionList)

        // The breaker sections lived in the list that was just replaced. Only the
        // "All" tab (no filter) puts them back; other tabs show products only.
        if (!subFilterSelected && !subFilterTag) {
          insertSectionsBetweenProducts()
        }
      })
  }

  const clearFilters = function(e) {
	e.preventDefault();

    activeFilters = []
	console.log("clearFilters");
    renderActiveFilterList()
    updateFilterCount()
    getFilteredSection()
  }

  const applyFilters = function(e) {
	e.preventDefault();
	
    renderActiveFilterList()
	console.log("applyFilters.....");

    updateFilterCount()
    getFilteredSection()

	console.log("this",$(this).hasClass('mobile_apply_filter'));
	if($(this).hasClass('mobile_apply_filter')){
		// $('div.js-filter-container').css('display', 'none');
		// $('body').removeClass('freeze');
		$(settings.filterContainer + '[data-target]').slideUp(300)
		$(settings.filterTrigger).removeClass('active')
		$('.js-trigger-filter-close-mobile').addClass('hidden');
		$('body').removeClass('freeze');
		$(settings.filterWrapper).removeClass('z-50').addClass('z-30')
	}
	else{
		$(settings.filterContainer + '[data-target]').slideUp(200)
		$(settings.filterTrigger).removeClass('active')
		$('.js-trigger-filter-close-mobile').addClass('hidden');
		$('body').removeClass('freeze');
		$(settings.filterWrapper).removeClass('z-50').addClass('z-30')
	}
	
  }

  const handleCollectionFilter = function(e){
    e.preventDefault();

    let filterValue = $(this).data('value');
    let filterGroup = $(this).data('key')


    let filter = {
      name: filterGroup,
      value: filterValue
    }

    addOrRemoveFilterValue(filter)
    renderActiveFilterList()
	console.log("handleCollectionFilter...");
	$('.filter_count').each(function(elem){
		$(this).text(' ('+ activeFilters.length + ')');
	})
    // updateFilterCount();
    // getFilteredSection()
  }

  return { init }
})()


/* harmony default export */ const filterOptions = (FilterOptionList);

;// CONCATENATED MODULE: ./assets/js/quantityBoxGiftSub.js



const QuantityBoxGiftSub = (function(){



  const settings = {
    quantityButton: ".js-change-quantity-gift",
    quantityInput: ".js-quantity-input-gift"

  }

  const init = function(){
   // if (!elementsExist([settings.quantityInput])) return;

    initializeEventListeners()
  }

  const initializeEventListeners = function(){
    jquery_default()(document).on('click', settings.quantityButton, handleQuantityChange);
  }

  const handleQuantityChange = function(e){
    let action = jquery_default()(this).data('action')
    let $input = jquery_default()(this).siblings(settings.quantityInput)
    let quantity = parseInt($input.val())

    let min = parseInt($input.attr('min'));
    let newQty = quantity;

    if (action === "plus") {
      newQty = quantity + 1;
    } else {
      newQty = (quantity === min ? min : quantity - 1);
    }

    $input.val(newQty).change();
  }

  return {
    init
  }
})()

/* harmony default export */ const quantityBoxGiftSub = (QuantityBoxGiftSub);

;// CONCATENATED MODULE: ./assets/js/giftSubscription.js





const GiftSubscription = (function(){
  const settings = {
    buyPanel: ".js-gift-buy-panel",
    giftSelectorContainer: ".js-gift-selector",
    productSelectInputs: '[name="gift_duration"]',
    variantSkuInputs: '[name="variant_sku"]',
    itemQuantity: ".js-item-qty",
    priceElement: ".js-price-gift-guide",
    giftSubDescTitle: ".js-gift-description__title",
    giftSubDesc: ".js-gift-description",
  }

  let product = {};
  let variant = {};
  let handle = "";
  let variantSKU = "";

  let currentVariantPrice = ''

  const init = function(){
    // console.log('giftsub init')
    if (!elementsExist([ jquery_default()(settings.buyPanel) ])) return;

    initializeEventListeners()  
    getInitialValues()
  }

  const getInitialValues = function(){
    jquery_default()(settings.variantSkuInputs).closest(':checked').trigger('change')
    jquery_default()(settings.productSelectInputs).closest(':checked').trigger('change')
  }

  const getProductJSON = function(callback){
    jquery_default().ajax(`/products/${handle}.json`)
      .then(json => {
        if (json.product) {
          product = json.product
        }

      //  console.log('getProductJSON: ', product)

        callback()

       // QuantityBoxGiftSub.init()
      }
        )
  }

  const initializeEventListeners = function(){
    jquery_default()(settings.productSelectInputs).on('change', handleProductSelectChange)
    jquery_default()(settings.variantSkuInputs).on('change', handleVariantSelectChange)

    //HT code - for updated item qty
   // $(settings.itemQuantity).on('change', handleQtyChange)
    jquery_default()(document).on('change', settings.itemQuantity, handleQtyChange);


    //Toggle Product Description
    jquery_default()(document).on('click', settings.giftSubDescTitle, toggleProductDescription);
  }

  const handleQtyChange = function(e){
    let updatedQty = e.target.value;

     let updateVariantPrice = currentVariantPrice*updatedQty;
   //  let formattedPrice = '{{ ' + updateVariantPrice.toFixed(2) + ' | money_without_trailing_zeros }}';
     jquery_default()(settings.priceElement).text('$'+updateVariantPrice);

  }

  const handleProductSelectChange = function(e){
    handle = jquery_default()(this).val()

    getProductJSON(getActiveVariant)
  }

  const handleVariantSelectChange = function(e){
    variantSKU = jquery_default()(this).val()
    getActiveVariant()
  }

  const getActiveVariant = function(){
    if (product && product.variants && variantSKU) {
      variant = product.variants.find(prodVariant => prodVariant.sku === variantSKU);

      currentVariantPrice = variant.price;

      updateProductBuyPanel()
    }
  }

  const updateProductBuyPanel = function(){
    let section = "gift-subscription"

    if (product && product.handle && variant && variant.id) {
      let url = `/products/${product.handle}?variant=${variant.id}&sections=${section}`


      jquery_default().ajax(url).then(response => {
        let responseHTML = response[section];

       // console.log(responseHTML)

        let $newBuyPanel = jquery_default()(responseHTML).find(settings.buyPanel)
      //  console.log('newBuyPanel: ', $newBuyPanel)
        jquery_default()(settings.buyPanel).replaceWith($newBuyPanel)
        jquery_default()(settings.buyPanel).removeClass('hidden')

        //QuantityBoxGiftSub.init()

      })
    }
  }


  const toggleProductDescription = function(){
    // $(selectors.savedAddresses).slideToggle(500)
    // $(this).toggleClass('border-b-transparent bg-lightbeige active')

    jquery_default()(settings.giftSubDesc).slideToggle(500)
  }


  return {
    init
  }

})()

/* harmony default export */ const giftSubscription = (GiftSubscription);

;// CONCATENATED MODULE: ./assets/js/marquee.js




class Marquee {
  constructor({ wrapperSelector, marqueeSelector, initializedClass }) {
    this.$marquee = jquery_default()(marqueeSelector);
    this.$wrapper = jquery_default()(wrapperSelector);

    if ( !elementsExist([this.$wrapper, this.$marquee]) ) return;

    this.$content = this.$marquee.children();

    this.allowedLength = this.$content.length - 1;
    this.animationFrame = null;
    this.initializedClass = initializedClass;
    this.width = this.$marquee[0].scrollWidth;
  }

  init() {
    if ( !elementsExist([this.$wrapper, this.$marquee]) ) return;

    this.initEventListeners();
  }

  initEventListeners() {
    jquery_default()(window).on('resize', () => this.onResize());
    this.onResize();
  }

  onResize() {
    this.destroy();
    this.width = this.$marquee[0].scrollWidth;

    const isOverflowing = this.width >= jquery_default()(window).width();

    if ( isOverflowing ) {
      this.create();
    }
  }

  create() {
    const alreadyExists = this.$wrapper.hasClass(this.initializedClass);
    if ( alreadyExists ) return;

    let speed = 1;
    let progress = 1;

    const loop = () => {
      progress = progress - speed;

      if ( progress <= this.width * -1 ) {
        progress = 0;
      }

      this.$marquee.css({ transform: `translateX(${ progress }px)` });

      this.animationFrame = window.requestAnimationFrame(loop);
    }
    loop();

    this.$wrapper.addClass(this.initializedClass);
  }

  destroy() {
    const alreadyExists = this.$wrapper.hasClass(this.initializedClass);
    if ( !alreadyExists ) return;

    window.cancelAnimationFrame(this.animationFrame);

    this.reset();
  }

  reset() {
    const { allowedLength, $marquee } = this;
    const $content = $marquee.children();

    // remove cloned nodes
    $content.each(function(i) {
      if ( i > allowedLength ) {
        const contentItem = $content[i];
        jquery_default()(contentItem).remove();
      }
    });

    // reset affected elements
    this.$wrapper.removeClass(this.initializedClass);
    this.$marquee.css({ 'transform': 'none' });
  }
}


// +++++++++++++++++++++
// Marquee
// +++++++++++++++++++++
const marquee = {
  settings: {
    marquee: '.js-marquee',
    inner: '.js-marquee-inner',
    responsiveClass: 'js-marquee-responsive',
    initializedClass: 'marquee-initialized'
  },

  init: function() {
    if (elementsExist([settings.marquee])) {
      this.initializeObjects();
      this.initializeAll();
    }
  },

  initializeObjects: function() { // create an object for each marquee
    this.all = {};
    const marquee = this;

    jquery_default()(this.settings.marquee).each(function(i) {
      jquery_default()(this).attr('data-marquee', i);
      const ID = 'marquee' + i;

      const contentQuantity = jquery_default()(this).find(marquee.settings.inner + ' > *').length;
      const marqueeWidth = jquery_default()(this).find(marquee.settings.inner)[0].scrollWidth;

      const obj = {
        animationFrame: null,
        allowedLength: contentQuantity - 1,
        width: marqueeWidth
      };

      marquee.all[ID] = obj;
    });
  },

  getObject: function($marquee) {
    const ID = $marquee.data('marquee');
    return this.all['marquee' + ID];
  },

  initializeAll: function() { // check for responsiveness setting
    const marquee = this;

    jquery_default()(this.settings.marquee).each(function() {
      const $marquee = jquery_default()(this);

      if ( $marquee.hasClass(marquee.settings.responsiveClass) ) {
        marquee.alert($marquee);
      } else {
        marquee.trigger($marquee);
      }
    })
  },

  alert: function($marquee) { // trigger/kill, dependant on screen size/resize
    jquery_default()(window).on('resize', () => this.handleResize($marquee));
    this.handleResize($marquee);
  },

  handleResize: function($marquee) {
    const selfObj = this.getObject($marquee);

    if ( selfObj.width >= jquery_default()(window).width() ) {
      this.trigger($marquee);
    } else {
      this.kill($marquee);
    }
  },

  trigger: function($marquee) {
    if ( $marquee.hasClass(this.settings.initializedClass) ) { return; }

    // Settings
    let speed = 0.5;

    const selfObj = this.getObject($marquee);
    const $inner = $marquee.find(this.settings.inner);
    const $content = $marquee.find(this.settings.inner + ' > *');

    // Duplicate content
    const $clone = $content.clone();
    $clone.appendTo($inner);

    let progress = 1;

    function loop() {
      progress = progress - speed;
      if ( progress <= selfObj.width * -1 ) {
        progress = 0;
      }

      $inner.css({ transform: `translateX(${ progress }px)` });

      selfObj.animationFrame = window.requestAnimationFrame(loop);
    }
    loop();

    $marquee.addClass(this.settings.initializedClass);
  },

  kill: function($marquee) { // Turn off marquee animation
    if ( !$marquee.hasClass(this.settings.initializedClass) ) { return; }

    const selfObj = this.getObject($marquee);
    window.cancelAnimationFrame(selfObj.animationFrame);

    this.cleanUp($marquee);
  },

  cleanUp: function($marquee) {
    const selfObj = this.getObject($marquee);
    const $inner = $marquee.find(this.settings.inner);

    // remove cloned nodes
    $inner.children().each(function(i) {
      if ( i > selfObj.allowedLength ) {
        jquery_default()(this).remove();
      }
    });

    // reset affected elements
    $marquee.removeClass(this.settings.initializedClass);
    $inner.css({ 'transform': 'none' });
  }
}

;// CONCATENATED MODULE: ./assets/js/menu/megaMenu.js



const MegaMenu = function(selectors, activeMenu, setActiveMenu){

  if (!elementsExist([selectors.megaMenuTrigger])) return;

  const initEventListeners = function(){
    jquery_default()(selectors.megaMenuTrigger).on('click', toggleMegaMenu);
    jquery_default()(selectors.overlay).on('click', slideCloseMegaMenu);
  }

  const toggleMegaMenu = function(e){
    e.preventDefault();

    let $this = jquery_default()(this);
    let activeLink = $this.data('link');
    let $activeMegaMenu = jquery_default()(`${selectors.megaMenuContainer}[data-link="${activeLink}"]`);

    if (activeMenu()) {
      // menu is open. Close the active menu and open the new active one.

      if (activeMenu() === activeLink) {
        // Currently open menu got clicked. Close the active menu.
        slideCloseMegaMenu();
      } else {
        closeMegaMenu(e);
        openMegaMenu($activeMegaMenu, $this);
      }
    } else {
      // no menus open. Open the menu with slide out transition
      slideOpenMegaMenu($activeMegaMenu, $this);
    }
  }

  const openMegaMenu = function($activeMegaMenu, $activeLink){
    // Opens the menu without a slide down transition
    $activeMegaMenu.addClass(selectors.activeClass).show();
    $activeLink.addClass(selectors.activeClass);

    jquery_default()(selectors.overlay).show();

    setActiveMenu($activeLink.data('link'))
    disableScroll()
  }

  const slideOpenMegaMenu = function($activeMegaMenu, $activeLink){
    // Opens the menu with a slide down transition

    jquery_default()(selectors.overlay).fadeIn(300);

    $activeMegaMenu.slideDown(300, function(){
      $activeMegaMenu.addClass(selectors.activeClass);
      $activeLink.addClass(selectors.activeClass);

      setActiveMenu($activeLink.data('link'))
      disableScroll()
    })
  }

  const closeMegaMenu = function(e){
    // Closes the menu without a transition
    let $currentlyOpenMenu = jquery_default()(selectors.megaMenuContainer + "." + selectors.activeClass);

    $currentlyOpenMenu.removeClass(selectors.activeClass);
    jquery_default()(selectors.megaMenuTrigger).removeClass(selectors.activeClass);

    $currentlyOpenMenu.hide();

    jquery_default()(selectors.overlay).hide();

    setActiveMenu(undefined)
    enableScroll()
  }

  const slideCloseMegaMenu = function(){
    // Closes the menu with a slide up transition
    let $currentlyOpenMenu = jquery_default()(selectors.megaMenuContainer + "." + selectors.activeClass);

    jquery_default()(selectors.overlay).fadeOut(300);

    jquery_default()(selectors.megaMenuTrigger).removeClass(selectors.activeClass);

    $currentlyOpenMenu.slideUp(300, function(){
      $currentlyOpenMenu.removeClass(selectors.activeClass);

      setActiveMenu(undefined)
      enableScroll()
    });
  }

  initEventListeners()
}

/* harmony default export */ const megaMenu = (MegaMenu);

;// CONCATENATED MODULE: ./assets/js/menu/mobileMegaMenu.js



const MobileMegaMenu = function(selectors, activeMenu, setActiveMenu){

  if (!elementsExist([selectors.mobileMegaMenuTrigger])) return;

  const initEventListeners = function(){
    jquery_default()(selectors.mobileMegaMenuTrigger).on('click', toggleMegaMenu);
    jquery_default()(selectors.mobileMegaMenuClose).on('click', closeMegaMenu);
  }

  const getActiveElements = function($this){
    let activeLink = $this.data('link');
    let $activeMegaMenu = jquery_default()(`${selectors.mobileMegaMenuContainer}[data-link="${activeLink}"]`);
    let $activeTrigger = jquery_default()(`${selectors.mobileMegaMenuTrigger}[data-link="${activeLink}"]`);

    return { activeLink, $activeMegaMenu, $activeTrigger }
  }

  const toggleMegaMenu = function(e){
    e.preventDefault();

    let $this = jquery_default()(this);
    let { activeLink, $activeMegaMenu, $activeTrigger } = getActiveElements($this)

    if (activeMenu()) {
      // menu is open. Close the active menu and open the new active one.
      if (activeMenu() === activeLink) {
        // Currently open menu got clicked. Close the active menu.
        slideCloseMegaMenu($activeMegaMenu, $activeTrigger);
      } else {
        slideOpenMegaMenu($activeMegaMenu, $this);
      }
    } else {
      // no menus open. Open the menu with slide out transition
      slideOpenMegaMenu($activeMegaMenu, $this);
    }
  }

  const closeMegaMenu = function(e){
    e.preventDefault()
    let $this = jquery_default()(this);

    let { activeLink, $activeMegaMenu, $activeTrigger } = getActiveElements($this);

    slideCloseMegaMenu($activeMegaMenu, $activeTrigger);
  }

  const slideOpenMegaMenu = function($activeMegaMenu, $activeLink){
    // Opens the menu with a slide right transition

    jquery_default()(selectors.overlay).fadeIn(300)

    $activeMegaMenu.addClass(selectors.activeClass)

    $activeMegaMenu.removeClass('invisible')

    $activeLink.addClass(selectors.activeClass)

    setActiveMenu($activeLink.data('link'))

    disableScroll()
  }

  const slideCloseMegaMenu = function($activeMegaMenu, $this){
    // Closes the menu with a slide left transition

    jquery_default()(selectors.overlay).fadeOut(300)

    $this.removeClass(selectors.activeClass)

    $activeMegaMenu.removeClass(selectors.activeClass)

    setActiveMenu(undefined)

    enableScroll()

    setTimeout(function(){
      $activeMegaMenu.addClass('invisible')
    }, 300)
  }

  initEventListeners()
}

/* harmony default export */ const mobileMegaMenu = (MobileMegaMenu);

;// CONCATENATED MODULE: ./assets/js/menu/announcementBar.js



const AnnouncementBar = function(selectors){
  const cache = {
    $announcementBar: jquery_default()(selectors.announcementBar),
    $announcementCloseBtn: jquery_default()(selectors.announcementClose)
  }

  const init = function(){
    if (!elementsExist([ cache.$announcementBar, cache.$announcementCloseBtn])) return;

    checkClosedSession()
    cache.$announcementCloseBtn.on('click', closeAnnouncementBar);
  }

  const checkClosedSession = function(){
    let closedBar = sessionStorage.getItem('announcementClosed')

    if (closedBar) {
      closeAnnouncementBar()
    } else {
      showAnnouncementBar()
    }
  }

  const showAnnouncementBar = function(){
    cache.$announcementBar.slideDown(200)
  }

  const closeAnnouncementBar = function(){
    sessionStorage.setItem('announcementClosed', true)
    cache.$announcementBar.slideUp(200)
  }

  init()
}

/* harmony default export */ const announcementBar = (AnnouncementBar);

;// CONCATENATED MODULE: ./assets/js/menu/menu.js






const Menu = (function(){
  let [activeMenu, setActiveMenu] = useState(undefined);

  const selectors = {
    megaMenuTrigger: ".js-mega-link",
    megaMenuContainer: ".js-mega-menu",
    mobileMegaMenuTrigger: ".js-mobile-mega-link",
    mobileMegaMenuClose: ".js-mobile-mega-close",
    mobileMegaMenuContainer: ".js-mobile-mega-menu",
    overlay: ".js-overlay",
    activeClass: "active",
    mainNav: ".js-main-nav",
    announcementBar: ".js-announcement",
    announcementClose: ".js-close-announcement",
    mainLogo: ".js-main-logo svg"
  }

  const init = function(){
    megaMenu(selectors, activeMenu, setActiveMenu)
    mobileMegaMenu(selectors, activeMenu, setActiveMenu)
    announcementBar(selectors)

    $(window).on('scroll', handlePageScroll);
  }

  const handlePageScroll = function(e){
    let docHeight = $(document).height();
    let { scrollY } = window;

    let rotationAmount = 720 * scrollY / docHeight;

    $(selectors.mainLogo).css({
      transform: `rotate(${rotationAmount}deg)`
    })
  }

  return {
    init
  }
})()

/* harmony default export */ const menu = (Menu);

;// CONCATENATED MODULE: ./assets/js/pagination.js




// ++++++++++++++++
//  Custom Pagination
//  w/ Section Rendering
// ++++++++++++++++

const Pagination = (function($el){
  const settings = {
    container: '.js-pagination',
    link: '.js-pagination a',
    target: '.js-pagination-target'
  }

  const cache = {
    $container: jquery_default()(settings.container),
    section: ""
  }

  const init = function($container) {
    if ( !$container.length ) return;

    cache.$container = $container;
    cache.section = $container.data('section');

    let $links = $container.find('a')

    $links.on('click', (e) => handleClick(e));
  }

  const handleClick = function(e) {
    e.preventDefault();

    const $link = jquery_default()(e.currentTarget)
    const href = $link.attr('href')

    replaceHistory(href)
    updateSection(href)
  }

  const updateSection = function(href) {
    let operator = href.includes("?") ? "&" : "?";
    const url = `${href}${operator}sections=${cache.section}`

    jquery_default().ajax(url).then(response => {
      if (response && response[cache.section]) {
        let $responseHTML = jquery_default()(response[cache.section]).find(settings.target)

        let $target = jquery_default()(settings.target)
        $target.replaceWith($responseHTML)
      }
    });

  }

  return { init }
})()

/* harmony default export */ const pagination = (Pagination);

;// CONCATENATED MODULE: ./assets/js/predictiveSearch.js



const PredictiveSearch = (function(){
  const cache = {
    $searchBar: jquery_default()(".js-predictive-search-bar"),
    $searchDrawer: jquery_default()(".search-bar"),
    $searchForm: jquery_default()('.js-predictive-search-form')
  }

  const settings = {
    searchURL: "/search/?q=<QUERY>",
    searchResults: ".js-search-results",
    searchTab: ".search_tab",
    searchResultTab: '.search-results',
    searchIcon: '[data-search-icon]',
    slideSearchDrawer: '.slide--search-container',
    searchOverlay: ".js-search--overlay",
    closeSearchDrawer: '.js-search--close',
    openDrawer: false,
  }

  const init = function(){
    // console.log(cache, settings, settings.collectionTab, 'settings.collectionTab');
    if (!elementsExist([cache.$searchBar]) && !elementsExist([cache.$searchDrawer])) return;
    initializeEventListeners()
    initializeDrawerEventListeners();
  }

  const initializeDrawerEventListeners = function(){
    document.querySelectorAll('[data-search-bar]').forEach((form) => {
      form.addEventListener("click", (event) => {
        let inputQuery = event.target.closest(".search-bar-form").querySelector("input[name='q']").value; 
        if(inputQuery != "") {
          event.target.closest("form[action='/search']").submit();
        }
      });
    });
    
    jquery_default()('.suggested-keywords').on('click', '.suggested-keyword', handleSuggestedKeywordDrawerClick);
    document.addEventListener('click', function (event) {           
      if(!event.target.closest('.slide--search-container') && settings.openDrawer) {
        closeSearchDrawer();
      }
     });
       
     jquery_default()(settings.searchIcon).on('click', openSearchDrawer);
     jquery_default()(settings.closeSearchDrawer).on('click', closeSearchDrawer);
    //Suggested Keywords:
  }

  const openSearchDrawer = function(e) {   
    e.preventDefault();
    setTimeout(() => {      
      jquery_default()(settings.slideSearchDrawer).addClass("js-search-drawer-open");
      jquery_default()('body').css("overflow", "hidden");
      jquery_default()(settings.searchOverlay).removeClass("hidden");
      settings.openDrawer = true;
    }, 100);    
  }

  const closeSearchDrawer = function(e) { 
    jquery_default()(settings.slideSearchDrawer).removeClass("js-search-drawer-open");
    jquery_default()('body').css("overflow", "unset");
    jquery_default()(settings.searchOverlay).addClass("hidden");
    settings.openDrawer = false;
  }

  const initializeEventListeners = function(){
    cache.$searchBar.on('key').on('keyup', handleSearchTerms);
    //Suggested Keywords:
    // $('.suggested-keywords').on('click', '.suggested-keyword', handleSuggestedKeywordClick);
    jquery_default()(settings.searchTab).on('click', loadSelectedSearchResults)
  }

  const handleSuggestedKeywordDrawerClick = function() {
    const keyword = jquery_default()(this).data('keyword');
    document.querySelector("#drawer-predictive-search").value = keyword;
    // Trigger form submission
    document.querySelector(".drawer-search-form").submit();
  }

  const handleSuggestedKeywordClick = function() {
    const keyword = jquery_default()(this).data('keyword');
    cache.$searchBar.val(keyword);
    getSearchResults(keyword);

    // Trigger form submission
    cache.$searchForm.submit();
  }

  const loadSelectedSearchResults = function() {
    let searchTabName = jquery_default()(this).attr('data-value');
    let searchResultsToDisplay = `[data-search-type="${searchTabName}"]`;
    jquery_default()(settings.searchResultTab).addClass("hidden");
    jquery_default()(searchResultsToDisplay).removeClass("hidden");
    jquery_default()(settings.searchTab).removeClass("search_tab_active");
    jquery_default()(this).addClass("search_tab_active")
  }
  const getSearchURL = function(value){
    let types = []
    let formData = cache.$searchForm.data()

    if (formData.showProducts) {
      types.push('product')
    }

    if (formData.showArticles) {
      types.push('article')
    }

    if (formData.showPages) {
      types.push('page')
    }

    return `${settings.searchURL.replace("<QUERY>", value)}&type=${types.join(',')}&limit=12`
  }

  const handleSearchTerms = function(e){
    var code = e.code;
    if (code === "Enter") {
      // Don't submit while someone's typing
      e.preventDefault();
    }

    var $this = jquery_default()(this);
    var value = $this.val();

    if (value) {
      getSearchResults(value); 

      // Use POST-REDIRECT-GET pattern to prevent form resubmission
      // var $form = $this.closest('form');
      // var url = getSearchURL(value);
      // var method = $form.attr('method');
      // $.ajax({
      //   type: method,
      //   url: url,
      //   data: $form.serialize(),
      //   success: function(response) {
          
      //     renderPredictiveSearch(response, value);
      //     window.location.href = url;
      //   },
      //   error: console.warn
      // });


      
    } else {
      // resetSearchResults();
    }
  }

  const resetSearchResults = function(){
    jquery_default()(settings.searchResults).hide()
  }

  const getSearchResults = function(value){
    var url = getSearchURL(value);
    //console.log(url, 'url');
    var params = {
      url: url,
      dataType: "json",
      success: function(response){
        renderPredictiveSearch(response, value);
      },
      error: console.warn
    }

    jquery_default().ajax(params);
  }

  var renderPredictiveSearch = function(response, query){
    if (response['predictive-search']) {
      let $newResults = jquery_default()(response['predictive-search']).find(settings.searchResults);
      jquery_default()(settings.searchResults).replaceWith($newResults)
    }
  }

  return {
    init
  }
})()

/* harmony default export */ const predictiveSearch = (PredictiveSearch);


;// CONCATENATED MODULE: ./assets/js/productBuyPanel.js



// Handles anything in the PDP buy panel:
// - Variant changes
// - Image filtering

const ProductBuyPanel = (function(){
  const selectors = {
    productImages: ".js-product-images",
    productImageSlider: ".js-product-image-slider",
    imageSlides: ".js-image-slide",
    classRegisterBtn: ".js-class-register-btn",
    classInstructorContent: ".js-instructor-content",
    classInstructorPanel: ".js-instructor-panel",
    notifyMeFormContainer: ".js-notify-form"
  }

  const cache = {
    $productImageSlider: jquery_default()(selectors.productImageSlider),
  }

  const init = function(){
    if (!elementsExist( [selectors.productImages] )) return;

    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(document).on('variant:change', handleVariantChange)
  }

  const handleVariantChange = function(e){
    let { variant } = e.detail;

    filterSlickSlides(variant)
    updateClassButton(variant)
    updateClassInstructor(variant)
    toggleNotifyForm(variant);
  }

  const toggleNotifyForm = function(variant){
    if (variant.available){
      jquery_default()(selectors.notifyMeFormContainer).addClass('hidden')
    } else {
      jquery_default()(selectors.notifyMeFormContainer).removeClass('hidden')
    }
  }

  const updateClassInstructor = function(variant){
    let $allInstructorContent = jquery_default()(`${selectors.classInstructorContent}`)
    let $variantInstructorContent = $allInstructorContent.closest(`[data-variant="${variant.id}"]`)

    if ($variantInstructorContent.length) {
      jquery_default()(selectors.classInstructorPanel).removeClass('hidden')
      $allInstructorContent.not($variantInstructorContent).addClass('hidden')
      $variantInstructorContent.removeClass('hidden')
    } else {
      jquery_default()(selectors.classInstructorPanel).addClass('hidden')
      $allInstructorContent.addClass('hidden')
    }
  }

  const updateClassButton = function(variant){
    let $allRegisterBtns = jquery_default()(`${selectors.classRegisterBtn}`)
    let $defaultRegisterBtn = $allRegisterBtns.closest(`[data-variant=""]`)
    let $variantRegisterBtn = $allRegisterBtns.closest(`[data-variant="${variant.id}"]`)

    if ($variantRegisterBtn.length) {
      $variantRegisterBtn.removeClass('hidden')
      $allRegisterBtns.not($variantRegisterBtn).addClass('hidden')
    } else {
      $defaultRegisterBtn.removeClass('hidden')
      $allRegisterBtns.not($defaultRegisterBtn).addClass('hidden')
    }
  }

  const filterSlickSlides = function(variant){
    var mainImageSlider = jquery_default()('.js-product-image-slider').first();

    if (mainImageSlider.hasClass('slick-initialized')) {

      let { id } = variant;

      mainImageSlider.slick('slickUnfilter') 

      mainImageSlider.slick('slickFilter', function(index, slide){
        let $slideItem = jquery_default()(slide).find(selectors.imageSlides)
        let attachedVariantId = $slideItem.data('variant');

        if (attachedVariantId) {
          return id === parseInt(attachedVariantId);
        } else {
          return true
        }
      })

      mainImageSlider.slick("slickGoTo", 0, false);
    }

  }

  return {
    init
  }
})()


/* harmony default export */ const productBuyPanel = (ProductBuyPanel);

;// CONCATENATED MODULE: ./assets/js/productCard.js



const ProductCard = (function(){
  const selectors = {
    productCard: ".js-product-card",
    productCardContent: ".js-product-card-content",
    productCardForm: ".js-product-card-form",
    mobileButtonTrigger: ".js-product-card-form-trigger",
  }

  const init = function(){
    if (!elementsExist([selectors.productCard])) return;

    initEvents()

    jquery_default()(window).on('resize', function(){
      removeEvents()
      initEvents()
    })
  }

  const initEvents = function(){
    if (isMobile()) {
      initMobileEvents()
    } else {
      initDesktopEvents()
    }
  }

  const removeEvents = function(){
    jquery_default()(document).off('click', selectors.mobileButtonTrigger, handleProductCardEnter);
    jquery_default()(document).off('mouseenter', selectors.productCard, handleProductCardEnter);
    jquery_default()(document).off('focusin', selectors.productCard, handleProductCardEnter);
    jquery_default()(document).off('mouseleave', selectors.productCard, handleProductCardLeave);
    jquery_default()(document).off('focusout', selectors.productCard, handleProductCardLeaveFocus);
    jquery_default()(document).off('submit', selectors.productCardForm, handleCardFormSubmit);
  }

  const initMobileEvents = function(){
    jquery_default()(document).on('click', selectors.mobileButtonTrigger, handleMobileCardEnter);
    jquery_default()(document).on('submit', selectors.productCardForm, handleCardFormSubmit);
  }

  const initDesktopEvents = function(){
    jquery_default()(document).on('mouseenter', selectors.productCard, handleProductCardEnter);
    jquery_default()(document).on('focusin', selectors.productCard, handleProductCardEnter);
    jquery_default()(document).on('mouseleave', selectors.productCard, handleProductCardLeave);
    jquery_default()(document).on('focusout', selectors.productCard, handleProductCardLeaveFocus);
    jquery_default()(document).on('submit', selectors.productCardForm, handleCardFormSubmit);
  }

  const slideDownForm = function($card){
    let $form = $card.find(selectors.productCardForm)
    let $otherForms = jquery_default()(selectors.productCardForm).not($form);

    $form.slideDown(300)
    $otherForms.slideUp(300)
  }

  const slideUpForm = function($card){
    let $form = $card.find(selectors.productCardForm)

    $form.slideUp(300)
  }

  const handleMobileCardEnter = function(e){
    e.preventDefault()
    let $this = jquery_default()(this)
    let $card = $this.parents(selectors.productCard)

    slideDownForm($card)

    $this.hide();
  }

  const handleProductCardEnter = function(e){
    let $this = jquery_default()(this)
    slideDownForm($this);
  }

  const handleProductCardLeave = function(e){
    let $this = jquery_default()(this)
    slideUpForm($this)
  }

  const handleProductCardLeaveFocus = function(e){
    let $this = jquery_default()(this)
    let $target = jquery_default()(e.target)

    if (!$target.parents($this).length) {
      slideUpForm($this)
    }
  }

  const handleCardFormSubmit = function(e){
    let $this = jquery_default()(this)
    let $card = $this.parents(selectors.productCard)

    slideUpForm($card)

    if (isMobile()) {
      $card.find(selectors.mobileButtonTrigger).show()
    }
  }

  return {
    init
  }

})()

/* harmony default export */ const productCard = (ProductCard);

;// CONCATENATED MODULE: ./assets/js/productForm.js



const ProductForm = function($form){

  const cache = {
    $quantityInput: $form.find('[name="quantity"]'),
    $idInput: $form.find('[name="id"]'),
    $productScript: $form.find('.js-product-script'),
    $swatches: $form.find('.js-option-swatch'),
    $swatchLabel: $form.find('.js-option-label'),
    $hiddenOptionSelects: $form.find('.js-hidden-option-select'),
    $addToCart: $form.find('.js-product-form-atc'),
    $deliveryOption: $form.find('[name="delivery_option"]'),
    $deliveryOptionPDP: $form.find('[name="delivery_option_pdp"]'),
    $frequencyContainer: $form.find('.js-selling-plan-group'),
    $sellingPlan: $form.find('[name="selling_plan"]'),
    $price: $form.find(".js-price"),
    $stickyPrice: $form.find(".js-pdp-sticky-price"),
    $comparePrice: $form.find(".js-compare-price"),
    $subscriptionSavings: $form.find("[data-subscription-savings]"),
  }

  let translations = {
    addToCart: "Add to Cart",
    outOfStock: "Out of Stock",
  }

  let product;
  let variants;
  let currentVariant;

  // Size: "4 Pack"
  // Flavor: "Elderberry Shots"
  let options = {};

  const initEventListeners = function(){
    cache.$swatches.on('change', handleSwatchChange); // TODO: change from button click to input change
    cache.$hiddenOptionSelects.on('change', setCurrentVariant);
    cache.$idInput.on('change', handleVariantChange);
    cache.$deliveryOption.on('change', handleDeliveryChange);
    cache.$deliveryOptionPDP.on('change', handleDeliveryChangePDP);
  }

  const parseVariants = function(){
    product = JSON.parse(cache.$productScript.text());

    variants = product.variants;
  }

  const parseOptions = function(){
    cache.$hiddenOptionSelects.each(function(index, select){
      let name = jquery_default()(select).data("name")
      let value = jquery_default()(select).val()
      setActiveOption(name, value)
    })
  }

  const setActiveOption = function(name, value) {
    options[name] = value;
  }

  const updateAddToCart = function(){
    if (currentVariant && currentVariant.available) {
      cache.$addToCart.text(translations.addToCart)
      cache.$addToCart.attr('disabled', false)
    } else {
      cache.$addToCart.text(translations.outOfStock)
      cache.$addToCart.attr('disabled', true)
    }
  }

  const updateOneTimePrice = function(){
    let formattedPrice = formatMoney(currentVariant.price, "amount")

    if (currentVariant.price === 0) {
      cache.$price.text("Free!")
      cache.$stickyPrice.text("Free!")
    } else {
      cache.$price.text(`$${formattedPrice}`)
      cache.$stickyPrice.text(`$${formattedPrice}`)
    }

    // Updates pricing in Buy Panel - COMPARE AT
    let formattedComparePrice = formatMoney(currentVariant.compare_at_price, "amount")
    cache.$comparePrice.text(`$${formattedComparePrice}`)

    if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
      cache.$comparePrice.removeClass('hidden').show()
    } else {
      cache.$comparePrice.addClass('hidden').hide()
    }
  }

  const updateSubscriptionPrice = function(){
    // Add original price to compare at widget
    let formattedComparePrice = formatMoney(currentVariant.price, "amount")
    cache.$comparePrice.text(`$${formattedComparePrice}`)

    // Updates pricing for selling_plan
    let subscribePriceCents = (currentVariant.selling_plan_allocations.length ? currentVariant.selling_plan_allocations[0].price : 0);
    let formattedPrice = formatMoney(subscribePriceCents, "amount")

    cache.$price.text(`$${formattedPrice}`)
    cache.$stickyPrice.text(`$${formattedPrice}`)

    if (subscribePriceCents && subscribePriceCents < currentVariant.price) {
      cache.$comparePrice.removeClass('hidden').show()
    } else {
      cache.$comparePrice.addClass('hidden').hide()
    }
  }

  const updateSubscriptionSavings = function(){

    if ( currentVariant.selling_plan_allocations ) {
      let sellingPlan = currentVariant.selling_plan_allocations[0]

      if (sellingPlan) {
        let subscriptionSavings = sellingPlan.compare_at_price - sellingPlan.price;
        let formattedSavings = "$" + formatMoney(subscriptionSavings, "amount");

        cache.$subscriptionSavings.text(formattedSavings)
      }
    }    
  }

  const updateProductPrice = function(){
    let subscriptionOptionSelected = cache.$deliveryOption.closest(":checked").val() === "subscribe"

    if (subscriptionOptionSelected) {
      updateSubscriptionPrice()
    } else {
      updateOneTimePrice()
    }




    //Updated PDP
    let subscriptionOptionSelectedPDP = cache.$deliveryOptionPDP.closest(":checked").val() === "subscribe"

    if (subscriptionOptionSelectedPDP) {
      updateSubscriptionPrice()
    } else {
      updateOneTimePrice()
    }
  }

  // -------
  // Events
  // -------

  const setCurrentVariant = function(e) {
    // findVariant by matching activeOptions[0] / activeOptions[1] etc
    if (!variants) return;

    let name = jquery_default()(this).data("name")
    let value = jquery_default()(this).val()

    setActiveOption(name, value)

    currentVariant = variants.find(variant => {
      let filteredOptions = product.options.filter((option, index) => {
        let optionName = `option${index + 1}`
        return variant[optionName] === options[option]
      })

      return filteredOptions.length === product.options.length
    })

    if (currentVariant) {
      cache.$idInput
        .val(currentVariant.id)
        .change()
    }

    return currentVariant;
  }

  const handleVariantChange = function(e){
    // updateVariant(currentVariant)
    // updates anything on the form UI
    // Dispatches "variant:change" event that can capture any other changes in other files.
    // add to cart / availability
    updateAddToCart()
    updateProductPrice()
    updateSubscriptionSavings()
    // price
    // images?

    let event = new CustomEvent('variant:change', {
      detail: { variant: currentVariant }
    });
    document.dispatchEvent(event);
  }

  const handleSwatchChange = function(e){
    e.preventDefault()
    e.stopPropagation()

    let $this = jquery_default()(this)
    let name = $this.data('option')
    let value = $this.data('value')

    cache.$hiddenOptionSelects
      .closest(`[data-name=${name}]`)
      .val(value)
      .change()
  }

  const handleDeliveryChange = function(e){
    let $this = jquery_default()(this)
    if ($this.val() === "subscribe") {
      // Expand the Frequency group
      cache.$frequencyContainer.slideDown(300)
      cache.$sellingPlan.attr('disabled', false)
    } else {
      cache.$frequencyContainer.slideUp(300)
      cache.$sellingPlan.attr('disabled', true)
    }

    updateProductPrice()
  }

  const handleDeliveryChangePDP = function(e){
    let $this = jquery_default()(this)

    jquery_default()('.pdp-custom-checkbox').each(function(){
      jquery_default()(this).removeClass('tab__active')
    })


    $this.closest('.pdp-custom-checkbox').addClass('tab__active')


    if ($this.val() === "subscribe") {
      // Expand the Frequency group
      cache.$frequencyContainer.slideDown(300)


      cache.$sellingPlan.attr('disabled', false)

      jquery_default()('.js-one-time-group').css('display','none')
      jquery_default()('.js-selling-plan-div').css('display','block')

      jquery_default()('.ot__prod-var-select>div').appendTo(jquery_default()('.sub__prod-var-select'));
      jquery_default()('.ot__quantity-box>div').appendTo(jquery_default()('.sub__quantity-box'));


    } else {
      cache.$frequencyContainer.slideUp(300)
      cache.$sellingPlan.attr('disabled', true)


      //Display One time section
      jquery_default()('.js-one-time-group').css('display','block')
      jquery_default()('.js-selling-plan-div').css('display','none')


      jquery_default()('.sub__prod-var-select>div').appendTo(jquery_default()('.ot__prod-var-select'));
      jquery_default()('.sub__quantity-box>div').appendTo(jquery_default()('.ot__quantity-box'));
    }

    updateProductPrice()
  }


  const accordionStoryShowMore = function(){
    var paragraphs = document.querySelectorAll('.story_text_desc p:not(:first-of-type)');

    if(paragraphs.length != 0){
        document.getElementById('story-show-more-button').classList.remove('hidden')
    }

    if(document.getElementById('story-show-more-button')){
      document.getElementById('story-show-more-button').addEventListener('click', function() {
    
        for (var i = 0; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'block';
        }
  
  
        this.style.display = 'none'; // Hide the button after clicking
      });
    }
    
  }

  const init = function(){

    initEventListeners()
    parseVariants()
    parseOptions()

    cache.$hiddenOptionSelects.change()

    accordionStoryShowMore()


    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }


    // Check if 'subscribe' parameter is present and set to 'true' (for Meta Ads)
    if (getUrlParameter('subscribe') !== 'true') {
        jquery_default()('.pdp-custom-checkbox__onetime').trigger('click');
    }



  }

  init()
}

/* harmony default export */ const productForm = (ProductForm);

;// CONCATENATED MODULE: ./assets/js/productFormsInit.js




const ProductFormsInit = (function(){
  const selectors = {
    form: ".js-product-form"
  }

  const init = function(){
    if (!elementsExist([selectors.form])) return;
    initializeProductForms();
  }

  const initializeProductForms = function(){
    jquery_default()(selectors.form).each(function(index, form){
      productForm(jquery_default()(form))
    })
  }

  return {
    init
  }

})()

/* harmony default export */ const productFormsInit = (ProductFormsInit);

;// CONCATENATED MODULE: ./assets/js/productRecommendations.js



const ProductRecommendations = (function(){
  const selectors = {
    recommendedProductContainer: ".js-recommended-products"
  }

  let slickSettings={
    "dots": false,
    "arrows": true,
    "infinite": true,
    "speed": 300,
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "mobileFirst": false,
    "nextArrow": ".recommended-products .js-next",
    "prevArrow": ".recommended-products .js-prev",
    "responsive": [
      {
        "breakpoint": 1024,
        "settings": {
          "slidesToShow": 2
        }
      },
      {
        "breakpoint": 767,
        "settings": {
          "slidesToShow": 1
        }
      }
    ]
  }

  const baseURL = "/recommendations/products?product_id=<product-id>&section_id=related-products&limit=<limit>"


  const init = function(){
    if (!elementsExist([selectors.recommendedProductContainer])) return;
    getProductRecommendations()
  }

  const getProductRecommendations = function(){
    let $recommendedProductContainer = jquery_default()(selectors.recommendedProductContainer)

    let { productId, limit, mobileLimit } = $recommendedProductContainer.data()

    if (isTablet()) {
      limit = mobileLimit
    }


    let url = baseURL.replace("<product-id>", productId).replace("<limit>", limit);

    jquery_default().ajax(url)
      .then(html => {
        let $html = jquery_default()(html);

        
        $recommendedProductContainer.replaceWith($html);

        jquery_default()('.rec-ul').slick(slickSettings)




        $html.find('.animate')
          .addClass('animate-animated')
          .removeClass('animate');
      })
  }

  return {
    init
  }
})()

/* harmony default export */ const productRecommendations = (ProductRecommendations);

;// CONCATENATED MODULE: ./assets/js/quantityBox.js



const QuantityBox = (function(){

  const settings = {
    quantityButton: ".js-change-quantity",
    quantityInput: ".js-quantity-input"
  }

  const init = function(){
    if (!elementsExist([settings.quantityInput])) return;

    initializeEventListeners()
  }

  const initializeEventListeners = function(){
    jquery_default()(document).on('click', settings.quantityButton, handleQuantityChange);
  }

  const handleQuantityChange = function(e){
    let action = jquery_default()(this).data('action')
    let $input = jquery_default()(this).siblings(settings.quantityInput)
    let quantity = parseInt($input.val())

    let min = parseInt($input.attr('min'));
    let newQty = quantity;

    if (action === "plus") {
      newQty = quantity + 1;
    } else {
      newQty = (quantity === min ? min : quantity - 1);
    }

    $input.val(newQty).change();
  }

  return {
    init
  }
})()

/* harmony default export */ const quantityBox = (QuantityBox);

;// CONCATENATED MODULE: ./assets/js/animation.js




/**
 * Watches for & triggers reveal animations when elements enter view
 */
class RevealAnimation {
  constructor(target) {
    this.$target = jquery_default()(target);
    this.triggerClass = 'animate-animated';
  }

  init() {
    if ( !elementsExist([this.$target]) ) return;

    this.initAnimationsObserver();
  }

  initAnimationsObserver(){
    if ( typeof IntersectionObserver === 'function' ) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: .05
      };

      const observer = new IntersectionObserver((e) => this.observeAnimations(e), options);
      observer.observe(this.$target[0]);
    } 
    
    if ( typeof IntersectionObserver !== 'function' ) {
      this.$target.addClass(this.triggerClass);
      // this.$target.removeClass(this.targetClass);
    }
  }

  observeAnimations(entries) {
    entries.forEach((entry) => {
      let $target = jquery_default()(entry.target);

      if (!$target.hasClass(this.triggerClass) && entry.isIntersecting) {
        const delay = screen.availWidth < 567 && $target.data('mobileDelay')
          ? $target.data('mobileDelay')
          : $target.data('delay');

        this.triggerAnimation($target, delay);
      }
    });
  }

  triggerAnimation($target, delay = 0) {
    setTimeout(function() {
      $target.addClass('animate-animated');
      $target.removeClass('animate');
    }, parseInt(delay));
  }
}

// EXTERNAL MODULE: ./node_modules/@accessible360/accessible-slick/slick/slick.js
var slick = __webpack_require__(475);
;// CONCATENATED MODULE: ./assets/js/slider.js



window.jQuery = window.$ = (jquery_default());




class Slider {
  constructor(slider) {
    this.$slider = jquery_default()(slider);
  }

  init() {
    if ( !elementsExist([this.$slider]) ) return;

    this.$slider.slick();

    jquery_default()(window).on('resize', () => {
      this.$slider.slick('setPosition');

      if (!this.$slider.hasClass('slick-initialized')) {
        this.$slider.slick();
      }
    });

    if (this.$slider.data('syncHeights')) {

      this.$slider.on('setPosition', this.syncSlideHeights.bind(this))

      this.$slider.slick('setPosition');

      this.$slider.find('img').on('lazyloaded', this.syncSlideHeights.bind(this))
    }
  }

  syncSlideHeights(){
    let $elements = this.$slider.find('.js-slide-inner')
    let maxHeight = syncElementsHeight($elements);

    this.$slider.height(maxHeight);
  }

}

;// CONCATENATED MODULE: ./assets/js/video.js


const Video = (function(){
  const selectors = {
    toggleVideoBtn: '.js-toggle-video',
    videoWrapper: '.js-video-wrapper',
    videoIFrame: ".js-video"
  }

  const init = function(){
    if (!elementsExist([ selectors.videoWrapper, selectors.toggleVideoBtn ])) return;

    initializeEventListeners()
  }

  const initializeEventListeners = function(){
    $(selectors.toggleVideoBtn).on('click', toggleAndAutoplayVideo)
  }

  const toggleAndAutoplayVideo = function(e){
    let $this = $(this);
    let { videoId } = $this.data()

    if (videoId) {
      let $videoWrapper = $(selectors.videoWrapper).closest(`[data-video-id="${videoId}"]`);
      let $iFrameVideo = $videoWrapper.find(selectors.videoIFrame);

      $this.fadeOut(200)
      $videoWrapper.removeClass('hidden');
      if (Vimeo && Vimeo.Player) {
        let player = new Vimeo.Player($iFrameVideo[0])

        player.play()
      }
    }
  }

  return {
    init
  }
})()

/* harmony default export */ const video = (Video);

;// CONCATENATED MODULE: ./assets/js/contactForm.js


const contactForm = (function() {


    const selectors = {
        contactFirstNameError: ".contact-first-name-error",
        contactLastNameError: ".contact-last-name-error",
        contactEmailError: ".contact-email-error",
        contactTextboxError: ".contact-textbox-error",
        firstNameInputID: "#contact-first-name",
        lastNameInputID: "#contact-last-name",
        emailInputID: "#contact-email",
        textboxInputID: "#contact-body",
        contactSubmitBtn: ".contact-form-submit",
    }


  const init = function(){
    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.contactSubmitBtn).on('click', validateContactForm)
  }

  const validateContactForm = function(e){
    e.preventDefault();


    let firstNameVal = jquery_default()(selectors.firstNameInputID).val();
    let lastNameVal = jquery_default()(selectors.lastNameInputID).val();
    let emailVal = jquery_default()(selectors.emailInputID).val();
    let textboxVal = jquery_default()(selectors.textboxInputID).val();
    const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;




    if(firstNameVal.length === 0 || lastNameVal.length === 0 || emailVal.length === 0 || textboxVal.length === 0){
        if(firstNameVal.length === 0){
            jquery_default()(selectors.contactFirstNameError).removeClass('hidden')
        }
        else{
            jquery_default()(selectors.contactFirstNameError).addClass('hidden')
        }


        if(lastNameVal.length === 0){
            jquery_default()(selectors.contactLastNameError).removeClass('hidden')
        }else{
            jquery_default()(selectors.contactLastNameError).addClass('hidden')
        }


        if(emailVal.length === 0){
            jquery_default()(selectors.contactEmailError).removeClass('hidden')
        }
        else{
            jquery_default()(selectors.contactEmailError).addClass('hidden')
        }


        if(textboxVal.length === 0){
            jquery_default()(selectors.contactTextboxError).removeClass('hidden')
        }
        else{
            jquery_default()(selectors.contactTextboxError).addClass('hidden')
        }



        return;
    }
    else{

        //pattern test email
        if (!pattern.test(emailVal)){
            jquery_default()(selectors.contactEmailError).text('Please enter correct email')
            jquery_default()(selectors.contactEmailError).removeClass('hidden')
            return false;
        }
        jquery_default()('#contact_form').trigger('submit');
    }
    

  } 


  return { init }
})()


/* harmony default export */ const js_contactForm = (contactForm);  

;// CONCATENATED MODULE: ./assets/js/largeOrderInquiryForm.js


const largeOrderInquiryForm = (function() {


    const selectors = {
        contactNameError: ".error__contact[name]",
        contactPhoneError: ".error__contact[phone]",
        contactEmailError: ".error__contact[email]",

        nameInputID: '[name="contact[name]"]',
        phoneInputID: '[name="contact[phone]"]',
        emailInputID: '[name="contact[email]"]',


        contactSubmitBtn: ".form-builder-submit",
    }


  const init = function(){
    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.contactSubmitBtn).on('click', validateContactForm)
  }

  const validateContactForm = function(e){
    e.preventDefault();


    let contactNameVal = jquery_default()(selectors.nameInputID).val();
    let emailVal = jquery_default()(selectors.emailInputID).val();
    let phoneVal = jquery_default()(selectors.phoneInputID).val();


    const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;




    if(contactNameVal.length == 0 || emailVal.length == 0 || phoneVal.length == 0){
        

        if(contactNameVal.length == 0){
            jquery_default()(selectors.nameInputID).parents('.w-full').prev('.contact-form-error').removeClass('hidden')
        }
        else{
            jquery_default()(selectors.nameInputID).parents('.w-full').prev('.contact-form-error').addClass('hidden')
        }



        if(emailVal.length == 0){
            jquery_default()(selectors.emailInputID).parents('.w-full').prev('.contact-form-error').removeClass('hidden')
        }
        else{
            jquery_default()(selectors.emailInputID).parents('.w-full').prev('.contact-form-error').addClass('hidden')
        }



        if(phoneVal.length == 0){
            jquery_default()(selectors.phoneInputID).parents('.w-full').prev('.contact-form-error').removeClass('hidden')
        }
        else{
            jquery_default()(selectors.phoneInputID).parents('.w-full').prev('.contact-form-error').addClass('hidden')
        }
 


        return;
    }
    else{

        //pattern test email
        if (!pattern.test(emailVal)){
           // $(selectors.emailInputID).parents('.w-full').prev('.contact-form-error').text('Please enter correct email')
            jquery_default()(selectors.emailInputID).parents('.w-full').prev('.contact-form-error').removeClass('hidden')
            return false;
        }else{
            jquery_default()(selectors.emailInputID).parents('.w-full').prev('.contact-form-error').addClass('hidden')
        }

        //pattern test phone number
        if(phoneVal.length < 10){
            jquery_default()(selectors.phoneInputID).parents('.w-full').prev('.contact-form-error').removeClass('hidden')
            return false;
        }
        else{
            jquery_default()(selectors.phoneInputID).parents('.w-full').prev('.contact-form-error').addClass('hidden')
        }


        jquery_default()('#contact_form_builder').trigger('submit');
    }
    

  } 


  return { init }
})()


/* harmony default export */ const js_largeOrderInquiryForm = (largeOrderInquiryForm);  

;// CONCATENATED MODULE: ./assets/js/loginForm.js


const loginForm = (function() {


    const selectors = {
        loginEmailError: ".login-email-error",
        loginPasswordError: ".login-password-error",
        emailInputID: "#login-email",
        passwordInputID: "#login-password",
        loginSubmitBtn: ".login-form-submit",
        emailErrorIcon: ".email-input-error-icon",
        passwordErrorIcon: ".pw-input-error-icon",
        passwordEye: "#login_pass_eye"
    }


  const init = function(){
    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.loginSubmitBtn).on('click', validateLoginForm)
    jquery_default()(selectors.passwordEye).on('click', toggleDisplayPassword)
    
    displayForgotPW()
    resetPasswordSuccess()
  }


  const displayForgotPW = function(){
    jquery_default()('#displayForgotPW').on('click', function(){
        jquery_default()('#login').addClass('hidden')
        jquery_default()('#recover').removeClass('hidden')
    })
  }


  const resetPasswordSuccess = function() {
    var formState = jquery_default()(".reset-password-success"); 
    // check if reset password form was successfully submited.
    if (!formState.length) {
      return;
    } 
    // show success message
    jquery_default()("#ResetSuccess").removeClass("hidden");
  }

  const toggleDisplayPassword = function(){

    if(jquery_default()(selectors.passwordInputID).attr('type') == 'password')
        jquery_default()(selectors.passwordInputID).attr('type', 'text')
    else
        jquery_default()(selectors.passwordInputID).attr('type', 'password')
  }

  const validateLoginForm = function(e){
    e.preventDefault();


    let emailVal = jquery_default()(selectors.emailInputID).val();
    let passwordVal = jquery_default()(selectors.passwordInputID).val();
    const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;




    if(emailVal.length === 0 && passwordVal.length === 0){
        if(emailVal.length === 0){
            jquery_default()(selectors.loginEmailError).removeClass('hidden')
            jquery_default()(selectors.emailErrorIcon).removeClass('hidden')
            jquery_default()(selectors.emailInputID).addClass('input-error')
        }
       

        if(passwordVal.length === 0){
            jquery_default()(selectors.loginPasswordError).removeClass('hidden')
            jquery_default()(selectors.passwordErrorIcon).removeClass('hidden')
            jquery_default()(selectors.passwordInputID).addClass('input-error')
            jquery_default()(selectors.passwordEye).addClass('hidden')
        }
        
        return;
    }
    else{


        if(emailVal.length === 0){
            jquery_default()(selectors.loginEmailError).removeClass('hidden')
            jquery_default()(selectors.emailErrorIcon).removeClass('hidden')
            jquery_default()(selectors.emailInputID).addClass('input-error')
        }
        else{
            jquery_default()(selectors.loginEmailError).addClass('hidden')
            jquery_default()(selectors.emailErrorIcon).addClass('hidden')
            jquery_default()(selectors.emailInputID).removeClass('input-error')
        }

        if(passwordVal.length === 0){
            jquery_default()(selectors.loginPasswordError).removeClass('hidden')
            jquery_default()(selectors.passwordErrorIcon).removeClass('hidden')
            jquery_default()(selectors.passwordInputID).addClass('input-error')
            jquery_default()(selectors.passwordEye).addClass('hidden')
        }
        else{
            jquery_default()(selectors.loginPasswordError).addClass('hidden')
            jquery_default()(selectors.passwordErrorIcon).addClass('hidden')
            jquery_default()(selectors.passwordInputID).removeClass('input-error')
            jquery_default()(selectors.passwordEye).removeClass('hidden')
        }



        //pattern test email 
        if (!pattern.test(emailVal)){
            jquery_default()(selectors.loginEmailError).removeClass('hidden')
            return false;
        }
        jquery_default()('#customer_login').trigger('submit');        
    }
  } 
  return { init }
})()


/* harmony default export */ const js_loginForm = (loginForm);  

;// CONCATENATED MODULE: ./assets/js/registerForm.js


const registerForm = (function() {


    const selectors = {
        registerEmailError: ".register-email-error",
        registerPasswordError: ".register-password-error",
        emailInputID: "#register-email",
        passwordInputID: "#register-password",
        registerSubmitBtn: ".register-form-submit",
        emailErrorIcon: ".email-input-error-icon",
        passwordErrorIcon: ".pw-input-error-icon",
        passwordEye: "#login_pass_eye"
    }


  const init = function(){
    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.registerSubmitBtn).on('click', validateRegisterForm)
    jquery_default()(selectors.passwordEye).on('click', toggleDisplayPassword)
  }

  const toggleDisplayPassword = function(){

    if(jquery_default()(selectors.passwordInputID).attr('type') == 'password')
        jquery_default()(selectors.passwordInputID).attr('type', 'text')
    else
        jquery_default()(selectors.passwordInputID).attr('type', 'password')
  }

  const validateRegisterForm = function(e){
    e.preventDefault();


    let emailVal = jquery_default()(selectors.emailInputID).val();
    let passwordVal = jquery_default()(selectors.passwordInputID).val();
    const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;




    if(emailVal.length === 0 || passwordVal.length === 0){
        if(emailVal.length === 0){
            jquery_default()(selectors.registerEmailError).removeClass('hidden')
            jquery_default()(selectors.emailErrorIcon).removeClass('hidden')
            jquery_default()(selectors.emailInputID).addClass('input-error')
        }
        else{
            jquery_default()(selectors.registerEmailError).addClass('hidden')
            jquery_default()(selectors.emailErrorIcon).addClass('hidden')
            jquery_default()(selectors.emailInputID).removeClass('input-error')
        }


        if(passwordVal.length === 0){
            jquery_default()(selectors.registerPasswordError).removeClass('hidden')
            jquery_default()(selectors.passwordErrorIcon).removeClass('hidden')
            jquery_default()(selectors.passwordInputID).addClass('input-error')
            jquery_default()(selectors.passwordEye).addClass('hidden')
        }
        else{
            jquery_default()(selectors.registerPasswordError).addClass('hidden')
            jquery_default()(selectors.passwordErrorIcon).addClass('hidden')
            jquery_default()(selectors.passwordInputID).removeClass('input-error')
            jquery_default()(selectors.passwordEye).removeClass('hidden')
        }
        return;
    }
    else{

        //pattern test email
        if (!pattern.test(emailVal)){
            jquery_default()(selectors.registerEmailError).removeClass('hidden')
            jquery_default()(selectors.emailInputID).addClass('input-error')
            jquery_default()(selectors.emailErrorIcon).removeClass('hidden')
            return false;
        }
        else{
            jquery_default()(selectors.registerEmailError).addClass('hidden')
            jquery_default()(selectors.emailErrorIcon).addClass('hidden')
            jquery_default()(selectors.emailInputID).removeClass('input-error')
        }

        //password length check
        if (passwordVal.length < 5){
            jquery_default()(selectors.registerPasswordError).text('Password is too short (minimum is 5 characters)')
            jquery_default()(selectors.registerPasswordError).removeClass('hidden')
            return false;
        }
        else{
            jquery_default()(selectors.registerPasswordError).addClass('hidden')
        }


        jquery_default()('#create_customer').trigger('submit'); 

         
    }
    

  } 



  return { init }
})()


/* harmony default export */ const js_registerForm = (registerForm);  

;// CONCATENATED MODULE: ./assets/js/allCollection.js


const allCollection = (function() {


    const selectors = {
        collectionTab: ".collection_tab",
        collectionBox: ".collection_box"
    }


  const init = function(){
    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.collectionTab).on('click', loadSelectedCollectionProducts)
  }

  const loadSelectedCollectionProducts = function(e){

    let collectionName = jquery_default()(this).attr('data-col-tab-name')

    jquery_default()(this).addClass('tab__active');
    jquery_default()(this).siblings().removeClass('tab__active')

    let collectionToDisplay = `[data-col-title=${collectionName}]`;

    // $(selectors.collectionBox).children().children().fadeOut('slow')
    // $(collectionToDisplay).children().fadeIn('slow').slick()


    // if($(selectors.collectionBox).children().children().hasClass('slick-initialized')){
    //   $(selectors.collectionBox).children().children().css('display','none').slick("unslick")
    // }
    // else{
      jquery_default()(selectors.collectionBox).children().children().css('display','none')
    // }

    jquery_default()('[data-slicked-tab]').each(function(){
      if(jquery_default()(this).hasClass('slick-initialized')){
        jquery_default()(this).slick('unslick')
      }  
    })



    if(collectionName == 'all'){
      //console.log('Making All collections visible')
      jquery_default()('[data-col-title=all]').children().css('display', 'flex').slick()
    }
    else{

      //if already slicked, don't slick again
      if(jquery_default()(collectionToDisplay).children().hasClass('slick-initialized')){
        //console.log('Slick is already initialized. Do not slick again')
        jquery_default()(collectionToDisplay).children().css('display', 'flex')
      }
      else{
       // console.log('Slick is not initialized. Slick again')
        jquery_default()(collectionToDisplay).children().css('display', 'flex').slick()
      }
    }
   
    


  } 


  return { init }
})()


/* harmony default export */ const js_allCollection = (allCollection);  

;// CONCATENATED MODULE: ./assets/js/account.js


const account = (function() {


    const selectors = {
        saveAddressAccordion: ".saveAddressAccordion",
        savedAddresses: ".savedAddresses",
        navToggleOpen: "#open__nav",
        navToggleClose: "#close__nav",
        navToggle: ".nav_toggle",
        navDrawerBody: ".nav-drawer__body",
        navOverlay: ".nav_overlay"
    }


  const init = function(){
    initEventListeners()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.saveAddressAccordion).on('click', toggleSavedAddresses)
    jquery_default()(selectors.navToggle).on('click', toggleNavBody)
  }

  const toggleSavedAddresses = function(e){
    jquery_default()(selectors.savedAddresses).slideToggle(500)
    jquery_default()(this).toggleClass('border-b-transparent bg-lightbeige active')
  }


  const toggleNavBody = function(e){
    jquery_default()(selectors.navDrawerBody).slideToggle(400)
    // $(selectors.navToggleOpen).slideToggle(100)
    jquery_default()(selectors.navOverlay).fadeToggle(300)
  }


  return { init }
})()


/* harmony default export */ const js_account = (account);  

;// CONCATENATED MODULE: ./assets/js/giftGuide.js


const giftGuide = (function() {


    const selectors = {
        collectionTab: ".gift-filter_tab",
        collectionBox: ".gift-filter_box",
        giftGuideProdContainer: ".gift_guide_prod_container"
    }


  const init = function(){

    initEventListeners()
    loadPreSelectedCategories()
  }

  const initEventListeners = function(){
    jquery_default()(selectors.collectionTab).on('click', loadSelectedFilterProducts)
  }

  const loadPreSelectedCategories = function() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('gift-tab')) {
        const giftTabValue = urlParams.get('gift-tab');

        const selectedCategory = jquery_default()(selectors.collectionTab).filter(function() {
            return jquery_default()(this).data('col-tag-name') === giftTabValue;
        });        

        
       

        // $('.gift-filter_box').on('init', function() {
          // Ensure the scroll happens after everything is initialized
          setTimeout(function() {
              const headerHeight = jquery_default()('header').outerHeight() || 0;
              const topOffset = jquery_default()('.gift-guide-prod-header').offset().top - headerHeight;
              
              // Add 400px to the calculated scroll position
              const adjustedTopOffset = topOffset + 300;
      
              jquery_default()('html, body').animate({
                  scrollTop: adjustedTopOffset
              }, 800);
          }, 0); // Run immediately after the Slick initialization
        // });
      

        selectedCategory.trigger('click');
    
    }
  };


  const loadSelectedFilterProducts = function(e){

    let tagName = jquery_default()(this).attr('data-col-tag-name')


    //class for the tabs
    jquery_default()(this).addClass('tab__active');
    jquery_default()(this).siblings().removeClass('tab__active')



    let tagToDisplay = `[data-tag-title=${tagName}]`;

    jquery_default()(selectors.collectionBox).children().children().css('display','none')



    jquery_default()('[data-slicked-tab]').each(function(){
      if(jquery_default()(this).hasClass('slick-initialized')){
        jquery_default()(this).slick('unslick')
      }  
    })



    if(tagName == 'all'){

     // $('[data-col-title=all]').children().css('display', 'flex').slick()

      jquery_default()(selectors.giftGuideProdContainer).removeClass('remove__arrows')
          if (jquery_default()('[data-col-title=all]').children().hasClass('slick-initialized')) {

            jquery_default()('[data-col-title=all]').children().css('display', 'flex');
          } else {

            jquery_default()('[data-col-title=all]').children().css('display', 'flex').slick();
          }
    }
    else{

      const numberOfProducts = jquery_default()(tagToDisplay).children().children().length;



      if (isMobileDevice()) {
        // Check if it's a mobile device
        if (numberOfProducts > 1) {
          // console.log('Slick for mobile because there are more than 1 product');
          jquery_default()(tagToDisplay).children().css('display', 'flex').slick();
          jquery_default()(selectors.giftGuideProdContainer).removeClass('remove__arrows')
        } else {
          // console.log('No slick for mobile because there is only 1 product');
          jquery_default()(tagToDisplay).children().css('display', 'grid').css('grid-template-columns','1fr');
          jquery_default()(selectors.giftGuideProdContainer).addClass('remove__arrows')
        }
      }

      else{
        if (numberOfProducts < 4) {
          // console.log('Slick is not needed because there are fewer than 4 products');
          jquery_default()(tagToDisplay).children().css('display', 'grid').css('grid-template-columns','1fr 1fr 1fr');
          jquery_default()(selectors.giftGuideProdContainer).addClass('remove__arrows')
        } else {
          // If already slicked, don't slick again
          jquery_default()(selectors.giftGuideProdContainer).removeClass('remove__arrows')
          if (jquery_default()(tagToDisplay).children().hasClass('slick-initialized')) {
            // console.log('Slick is already initialized. Do not slick again');
            jquery_default()(tagToDisplay).children().css('display', 'flex');
          } else {
            // console.log('Slick is not initialized. Slick again');
            jquery_default()(tagToDisplay).children().css('display', 'flex').slick();
          }
        }
      }

      
     
    }

  } 


  function isMobileDevice() {
    return window.innerWidth < 768;
  }


  return { init }
})()


/* harmony default export */ const js_giftGuide = (giftGuide);  

;// CONCATENATED MODULE: ./assets/js/quiz.js


const quiz = (function() {
    
  const init = function() {
    
    let introPage = setInterval(() => {
        if(document.querySelector("#quiz-kit-content")) {  
          let quizIntroDiv = document.getElementById("quiz-kit-intro");
          let quizContainerDiv = document.getElementById("quiz-kit-container");
          var quizStartBtn = document.querySelector("#quiz-kit-intro-button");
      
          // To create and append new image tag     
          let imageElement = document.createElement("img");
          imageElement.src = 'https://cdn.shopify.com/s/files/1/0249/4283/7837/files/Group_48095795.png?v=1705470450';
          imageElement.classList.add('custom-image-class'); 
      
          // To append created element to main element
          let imageEle = document.createElement("div");
          imageEle.classList.add('intial-image-wrapper');     
          
      
          // To append new content after submit button
          // let contentEle = document.createElement("p");
          // contentEle.classList.add('info-content');    
         
          // To create a new content below submit button
          let newContentEle = document.createElement("p");
          newContentEle.classList.add('quiz-start-intro-content'); 
          newContentEle.classList.add('font-freight-sans'); 
          newContentEle.textContent = "Takes 30 Sec";
          imageEle.appendChild(imageElement);
          //quizIntroDiv.appendChild(imageEle);  

          // Quiz Kit can render #quiz-kit-content before the start button (and
          // #quiz-kit-container may not exist at all), which threw on every tick.
          // Wait for the button and insert next to it instead.
          if (!quizStartBtn) return;
          quizStartBtn.insertAdjacentElement("afterend", newContentEle);
          ["#quiz-kit-intro-title", "#quiz-kit-intro-text", "#quiz-kit-intro-button"].forEach((selector) => {
            const el = document.querySelector(selector);
            if (el) el.classList.add("aos-animate");
          });
          document.querySelector("#quiz-kit-content").classList.add("main-intro-page", "block-section");   
          clearInterval(introPage); 
 
        }  
    }, 1);
      
    let initialCheck = setInterval(() => {
        if(document.querySelector("#quiz-kit-intro-button")) {    
            document.querySelector("#quiz-kit-intro-button").addEventListener("click", () => {      
            initialCollGrid();   
            });
            clearInterval(initialCheck);  
        }  
    }, 1);
    const initialCollGrid = function(){
        let getColGrid; 
        getCollGrid(getColGrid); 
    }

    const getCollGrid = function(getColGrid){
        getColGrid = setInterval(() => {
            if (document.querySelector('[id^="quiz-kit-question-grid"]')) {
              document.querySelector('[id^="quiz-kit-question-grid"]').classList.add("aos-animate");
              document.querySelector("#quiz-kit-content").classList.add("question-page", "block-section");   
              let getAllBtns = document.querySelectorAll('[id^="quiz-kit-question-image-text-item"]');
              let getAllradios = document.querySelectorAll('[id^="quiz-kit-question-radio-box"]');
              let nextSlideBtn = document.querySelector('[id^="quiz-kit-question-next-button"]'); 
              let prevSlideBtn = document.querySelector('[id^="quiz-kit-question-prev-button"]'); 
              let quiContent = document.querySelector("#quiz-kit-content");
              if(quiContent.classList.contains("main-intro-page")) {
                // quiContent.classList.remove("main-intro-page");
              }
              if(nextSlideBtn) {
                nextSlideBtn.addEventListener("click", (event) => {
                  getCollGrid(getColGrid);
                });
              }
              if(prevSlideBtn) {
                prevSlideBtn.addEventListener("click", (event) => {
                  getCollGrid(getColGrid);
                });
              }
             
              getAllBtns.forEach((btn) => {
                btn.addEventListener("click", (event) => {
                  getCollGrid(getColGrid);
                });
              });
              getAllradios.forEach((btn) => {
                btn.addEventListener("click", (event) => {
                  getCollGrid(getColGrid);
                });
              });
              window.scrollTo({
                top: 0,
                behavior: 'smooth' // Use 'auto' for instant scrolling
              });
              clearInterval(getColGrid);
            } else {
              setTimeout(() => {           
                let emailBtn = setInterval(() => {
                  let getQuizKitKey = document.querySelector("[data-quiz-kit-key]").dataset.quizKitKey;                 
                  if(document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-button"]`) || document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-decline-button"]`)) {
                    let declineBtn = document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-decline-button"]`);  
                    let descriptionEle = document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-description"]`);  
                    let headingEle = document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-heading"]`);  
                    let subHeadingEle = document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-subheading"]`);  
                    let submitForm = document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-submit-form`);  
                    let submitBtn = document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-button`);  
                    if(headingEle || descriptionEle || subHeadingEle || submitForm || submitBtn) {
                      submitForm.classList.add("submit-form");
                      headingEle.classList.add("email-heading");
                      descriptionEle.classList.add("email-description");
                      subHeadingEle.classList.add("email-subheading");
                      submitBtn.classList.add("submit-btn");
                    }
                    document.querySelector(`[id^="quiz-kit-subscribe-${getQuizKitKey}-decline-button"]`).classList.add("decline-btn");
                    submitBtn.addEventListener("click", () => {
                      document.querySelector("#quiz-kit-content").classList.add("hidden");
                      showResult();
                    });
                    declineBtn.addEventListener("click", () => {
                      document.querySelector("#quiz-kit-content").classList.add("hidden");
                      showResult();
                    }); 
                    clearInterval(emailBtn);
                  }
                }, 10); 
                clearInterval(getColGrid);
              }, 2000);
            }
        }, 10);
    }
    const showResult = function() {
        let getResults = setInterval(() => {    
            document.querySelector("#quiz-kit-content").classList.add("last-step");
            let getQuizKitKey = document.querySelector("[data-quiz-kit-key]").dataset.quizKitKey;
            if(document.querySelector(`[id^="quiz-kit-results-wrapper-${getQuizKitKey}"]`)) {   
              document.querySelector(`[id^="quiz-kit-results-wrapper-${getQuizKitKey}"]`).classList.add("hidden");
              // document.querySelector(`[id^="quiz-kit-results-subtitle-${getQuizKitKey}`).textContent = "Meet your new favourite coffees ☕ ";
              // document.querySelector(`[id^="quiz-kit-results-title-${getQuizKitKey}`).textContent = "Here’s what we recommend for your busy days, quiet moments and adventures.";
              
              document.querySelectorAll('[id^=quiz-kit-results-product]').forEach((ele) => {
                ele.classList.add("product-grid");
                ele.querySelector("button").classList.add("submit-btn");
                ele.querySelector("h4").classList.add("product-price");
                ele.querySelector("h4").classList.add("font-acorn-medium");
              });  
              document.querySelector('[id^=quiz-kit-results-grid]').classList.add("product-grid-container");  
              document.querySelector('#quiz-kit-results-buttons [id^=quiz-kit-results-retake-quiz-button]').classList.add("btn-retake-quiz");  
              document.querySelector("#quiz-kit-content").classList.remove("hidden");
              clearInterval(getResults);
              triggerSlick();          
              jquery_default()(".quiz-section").removeClass("hidden");
              document.querySelector('[id^=quiz-kit-results-retake-quiz-button]').addEventListener("click", () => {
                jquery_default()(".quiz-section").addClass("hidden");
                let getColGrid; 
                getCollGrid(getColGrid);   
              });
            }    
        }, 1);
    }
    const triggerSlick = () => {
        const config = { 
          slickSelector: '.js-slick:visible'
        };      
        let $sliders = jquery_default()(config.slickSelector)
         $sliders.each(function(index, slider){    
           const slickSlider = new Slider(slider);           
           slickSlider.init();
         })
      };
}
  return { init }
})();
/* harmony default export */ const js_quiz = (quiz);  
;// CONCATENATED MODULE: ./assets/js/productBundleForm.js



 


const ProductBundleForm = (function() {


    const init = function(){
                // Bundle code
                // Retrieve the script element
                let bundleVariantIDsElement = document.querySelector('[data-bundle-variant-ids]');
                let bundleVariantIDs = []

                // Check if the script element is found
                if (bundleVariantIDsElement) {
                    // Parse the content of the script element into a JavaScript array
                    let bundleVariantIDsString = bundleVariantIDsElement.textContent;
                    bundleVariantIDs = JSON.parse(bundleVariantIDsString);

                    // Now 'bundleVariantIDs' contains the array of variant IDs
                } else {
                    console.error('Bundle variant IDs script tag not found.');
                }


                //ADD TO CART
                if(document.querySelector('.js-product-form-atc-bundle')){
                    let bundleProductName = document.querySelector('.js-product-form-atc-bundle').getAttribute('data-bundle-product-name')
                    let bundleProductImg = document.querySelector('.js-product-form-atc-bundle').getAttribute('data-bundle-product-img')
                    let bundleProductGradient = document.querySelector('.js-product-form-atc-bundle').getAttribute('data-bundle-gradient')
                    let bundlePrice = document.querySelector('.js-product-form-atc-bundle').getAttribute('data-bundle-total-price')
                    let bundleDiscount = document.querySelector('.js-product-form-atc-bundle').getAttribute('data-bundle-discount-percent')
                    let numberOfBundleProducts = document.querySelector('.js-product-form-atc-bundle').getAttribute('data-total-variants')
                    

                    jquery_default()('.js-product-form-atc-bundle').on('click', function() {
                        const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
                        
                        const bundleCode = genRanHex(6);

                        const bundleQty = jquery_default()(this).parent('.atc-qty-box__bundle').find('.js-quantity-input').val()
    
                
                        // Prepare the line items array
                        const lineItems = bundleVariantIDs.map(variantID => {
                            return {
                                id: `${variantID}`,
                                quantity: bundleQty ? bundleQty : 1,
                                properties: {
                                    '_bundleCode': bundleCode,
                                    '_cart_Discount': `${bundleDiscount}_${bundleCode}_${numberOfBundleProducts}`,
                                    '_bundleProductName': bundleProductName,
                                    '_bundleProductImg': bundleProductImg,
                                    '_bundleProductGradient': bundleProductGradient,
                                    '_bundlePrice': bundlePrice,
                                    'PART OF': bundleProductName
                                }
                            };
                        });
                
                        // Create the cart object
                        const cart = {
                            items: lineItems,
                        };
                

                
                        // Make an AJAX request to add items to the cart
                        fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest',
                                },
                                body: JSON.stringify(cart),
                            })
                            .then(response => response.json())
                            .then(data => {
                                // console.log('Added to cart:', data);
                
								setTimeout(function(){
                                // Open AJAX Cart
                                //this.openAJAXCart();
							}, 1500)
							Cart.openCart();
                
                        // Optionally, you can also call other methods, such as rebuilding the cart
                        // if you need to update its contents or UI.
                        Cart.buildCart();
                
                                })
                                .catch(error => {
                                    console.error('Error adding to cart:', error);
                                });
                
                
                    })
                }
                
    
      }

return { init } 

})()

/* harmony default export */ const productBundleForm = (ProductBundleForm);
;// CONCATENATED MODULE: ./assets/js/accordion-bundle.js



const AccordionBundle = (function(){
  const cache = {
    $toggle: jquery_default()(".js-expandable-toggle-bundle"),
    $content: jquery_default()(".js-expandable-content-bundle"),
    $group: jquery_default()(".js-expandable-group-bundle"),
    $prodImg: jquery_default()(".js-expandable-bundle-prod-img")
  }

  const settings = {
    activeClass: "active"
  }

  const init = function(){

    if (!elementsExist([cache.$toggle])) return;

    cache.$toggle.on('click', toggleContent);
  }

  const hideContent = function($content, $toggle){
    $content.removeClass(settings.activeClass)
    $toggle.removeClass(settings.activeClass)

    $content.slideUp(300)
    $content.attr( 'aria-expanded', false )

    $toggle.find('.icon-plus').removeClass('hidden')
    $toggle.find('.icon-minus').addClass('hidden')
  }

  const showContent = function($content, $toggle){
    $content.addClass(settings.activeClass)
    $toggle.addClass(settings.activeClass)

    $content.slideDown(300)
    $content.attr( 'aria-expanded', true )

    $toggle.find('.icon-plus').addClass('hidden')
    $toggle.find('.icon-minus').removeClass('hidden')

    $content.find('.js-slick').slick()
  }

  const toggleContent = function(e){
    let $this = jquery_default()(this)
    let toggleReference = $this.data('toggle')
    let $content = cache.$content.closest(`#${toggleReference}`)

    let toggleItemProductImage = $this.data('bundle-item-prod-image')
    let toggleItemProductBG = $this.data('bundle-item-bg-color')
    cache.$prodImg.attr('src', toggleItemProductImage)
    cache.$prodImg.attr('style', `background-color: ${toggleItemProductBG}50`)


    if ($content.hasClass(settings.activeClass)) {
      hideContent($content, $this)
    } else {
      showContent($content, $this)

      let $group = $this.parents(".js-expandable-group-bundle")
      let $groupContent = $group.find(".js-expandable-content-bundle").not($content)
      let $groupToggle = $group.find(".js-expandable-toggle-bundle").not($this)

      hideContent(
        $groupContent, 
        $groupToggle
      )
    }

    return false;
  }

  return {
    init
  }
})()

/* harmony default export */ const accordion_bundle = (AccordionBundle);

;// CONCATENATED MODULE: ./assets/js/accordion-brew.js



const AccordionBrew = (function(){
  const cache = {
    $brewInfoMethods: jquery_default()('.brew-info-methods'),
    $brewInfoOpen: jquery_default()(".brew-info__open"),
    $brewInfoClose: jquery_default()(".brew-info__close"),
    $brewInfoContainer: jquery_default()(".brew-info__container"),
  }

  const init = function(){
    if (!elementsExist([cache.$brewInfoOpen])) return;

    // cache.$brewInfoOpen.on('click', showInfo.bind(this, cache.$brewInfoOpen));
    // cache.$brewInfoClose.on('click', hideInfo.bind(this, cache.$brewInfoClose));
    cache.$brewInfoMethods.on('click', '.brew-info__open', function(event) {
        showInfo(event.target);
    });

    cache.$brewInfoMethods.on('click', '.brew-info__close', function(event) {
        hideInfo(event.target);
    });
   
  } 


  const showInfo = function(clickedElement){
    const $brewInfoOpen = jquery_default()(clickedElement);
    $brewInfoOpen.slideUp(300)

    $brewInfoOpen.siblings('.brew-info__container').slideDown(300)
    $brewInfoOpen.siblings('.brew-info__container').attr( 'aria-expanded', true )


    if($brewInfoOpen.siblings('.brew-info__container')){
        //console.log($brewInfoOpen.siblings('.brew-info__container'))

        $brewInfoOpen.siblings('.brew-info__container').children('.js-slick').slick('setPosition'); 
    }
  }

  const hideInfo = function(clickedElement){
    const $brewInfoClose = jquery_default()(clickedElement);
    $brewInfoClose.parent('.brew-info__container').siblings('.brew-info__open').slideDown(300)


    $brewInfoClose.parent('.brew-info__container').slideUp(300)
    $brewInfoClose.parent('.brew-info__container').attr( 'aria-expanded', false )

  }
 
  return {
    init
  }
})()

/* harmony default export */ const accordion_brew = (AccordionBrew);

;// CONCATENATED MODULE: ./assets/js/2bagSubscriptionLP.js



const TwoBagSubLP = (function() {
    const cache = {
        $brewInfoMethods: jquery_default()('.lp-brew-info-methods'),
        $brewInfoMethod: jquery_default()('.lp-brew-info-method'),
        $brewMethodInfo: jquery_default()('.brewMethod-info'),
        $lpHeader: jquery_default()('.2bag-lp--hero'),
        $scrollLinks: jquery_default()('a[href^="#"]'),
        $productForm: jquery_default()('.js-product-form-lp'),
        $twoBagScrollTo: jquery_default()('.two-bg-scroll-to'),
        $addToCartButton: jquery_default()('.lp--add-to-cart button[type="submit"]')
      }
    

    const init = function(){
        if (!elementsExist([cache.$brewInfoMethods])) return;

        console.log(`2 bag Sub LP loaded`, cache.$brewInfoMethod[0]);


        cache.$brewInfoMethod.each(function(e) {
            jquery_default()(this).on('click',function(e){
                // console.log('brewInfo Method =>' , $(this))
                // console.log(e.target)
                handleBrewMethodClick(jquery_default()(this))
            })
        });


        // Add smooth scrolling with offset
        cache.$scrollLinks.each(function() {
            jquery_default()(this).on('click', function(e) {
                e.preventDefault();

                const targetId = jquery_default()(this).attr('href');
                const targetElement = jquery_default()(targetId);
                const offset = 78;

                const elementPosition = targetElement.offset().top;
                const offsetPosition = elementPosition - offset;

                jquery_default()('html, body').animate({
                    scrollTop: offsetPosition
                }, 500);
            });
        });


        //Handle Scroll to 
        jquery_default()('.two-bg-scroll-to').each(function() {
            console.log(jquery_default()(this))
            jquery_default()(this).on('click', function(e) {
                e.preventDefault();
                const targetElement = jquery_default()("#2bag-lp--subscription");
                const offset = 120;

                const elementPosition = targetElement.offset().top;
                const offsetPosition = elementPosition - offset;

                jquery_default()('html, body').animate({
                    scrollTop: offsetPosition
                }, 500);
            })
        });

 
        //Handle ATC
        // cache.$productForm.on('submit', function(e) {
        //     e.preventDefault();
        
        //     const formData = $(this).serialize(); // Serialize the form data
        
        //     // Perform an Ajax POST request to add the item to the cart
        //     $.post('/cart/add.js', formData)
        //         .done(function() {
        //             // Redirect to checkout after the item has been added to the cart
        //             window.location.href = '/checkout';
        //         })
        //         .fail(function(response) {
        //             console.error("Add to Cart failed:", response);
        //             alert("There was an issue adding the item to your cart. Please try again.");
        //         });
        // });




    }

    const handleBrewMethodClick = function(currentBrewMethod){
        console.log(currentBrewMethod)
        const brewMethodSelected = currentBrewMethod.data('brew-method');
        console.log(`${brewMethodSelected} clicked`);

        cache.$brewInfoMethod.each(function(){
            jquery_default()(this).removeClass('brew--active')
        })
        currentBrewMethod.addClass('brew--active')

        cache.$brewMethodInfo.each(function(){
            jquery_default()(this).removeClass('block').addClass('hidden')
        })

        console.log(jquery_default()(`[data-brew-details="${brewMethodSelected}"]`))

        jquery_default()(`[data-brew-details="${brewMethodSelected}"]`).removeClass('hidden').fadeIn(300).slick();


    }

    const handleAddToCart = function(button) {
        // Assuming you have some way to add the item to the cart via AJAX or Shopify API
        const addToCartUrl = '/cart/add.js'; // Replace with actual endpoint if needed
        const checkoutUrl = '/checkout';

        // Example AJAX call to add the item to the cart
        jquery_default().post(addToCartUrl, {
            // Assuming button has data attributes for the variant ID, quantity, etc.
            id: button.data('variant-id'),
            quantity: button.data('quantity') || 1
        }).done(function() {
            // Redirect to checkout after adding to cart
            window.location.href = checkoutUrl;
        }).fail(function() {
            console.error('Failed to add item to cart.');
        });
    }




    return { init }
})()


/* harmony default export */ const _2bagSubscriptionLP = (TwoBagSubLP);  
;// CONCATENATED MODULE: ./assets/js/productFormQV.js



const ProductFormQV = function($form){


    const cache = {
        $qvSwatches: $form.find('.js-option-swatch-qv'),
        $hiddenOptionSelects: $form.find('.js-hidden-option-select-qv'),
        $productScript: $form.find('.js-product-script-qv'),
        $idInput: $form.find('[name="id"]'),
        $addToCart: $form.find('.atc-text-qv'),
        $prodPrice: $form.find('.js-price-qv'),
        $deliveryOptionQV: $form.find('[name="delivery_option_qv"]'),
        $subscriptionSavings: $form.find("[data-subscription-savings]"),
        $frequencyContainer: $form.find('.js-selling-plan-group'),
        $sellingPlan: $form.find('[name="selling_plan"]'),
    }

    let translations = {
        addToCart: "Add to Cart",
        outOfStock: "Out of Stock",
    }

    let product;
    let variants;
    let currentVariant;

    // Size: "4 Pack"
    // Flavor: "Elderberry Shots"
    let options = {};


    const initEventListeners = function(){
        cache.$qvSwatches.on('change', handleQVSwatchChange);
        cache.$hiddenOptionSelects.on('change', setQVCurrentVariant);
        cache.$idInput.on('change', handleQVVariantChange);
        cache.$deliveryOptionQV.on('change', handleDeliveryChangeQV);
    }

    const parseVariants = function(){
        //console.log('Prod QV: parsing variants')
        if(cache.$productScript){
          product = JSON.parse(cache.$productScript.text());
        }
    
        variants = product.variants;
    
        //console.log('Prod QV: variants =====>',variants)
    }

    const parseOptions = function(){
      cache.$hiddenOptionSelects.each(function(index, select){
        let name = jquery_default()(select).data("name")
        let value = jquery_default()(select).val()


  
        //console.log('Prod QV: parseOptions ===> ', name, value)
        setActiveOption(name, value)
      })
    }
  
    const setActiveOption = function(name, value) {
      options[name] = value;
    }

    const handleQVVariantChange = function(e){
      updateQVAddToCart()
      updateQVProductPrice()
      updateQVSubscriptionSavings()

  
      let event = new CustomEvent('variant:change', {
        detail: { variant: currentVariant }
      });

      //console.log(event)
      document.dispatchEvent(event);
    }

    const updateQVAddToCart = function(){
      if (currentVariant && currentVariant.available) {
        cache.$addToCart.text(translations.addToCart)
        cache.$addToCart.attr('disabled', false)
      } else {
        cache.$addToCart.text(translations.outOfStock)
        cache.$addToCart.attr('disabled', true)
      }
    }

    const updateQVOneTimePrice = function(){
      let formattedPrice = formatMoney(currentVariant.price, "amount")
  
      if (currentVariant.price === 0) {
        cache.$prodPrice.text("Free!")
      } else {
        cache.$prodPrice.text(`$${formattedPrice}`)
      }

    }

    const updateQVSubscriptionPrice = function(){
      // Updates pricing for selling_plan
      let subscribePriceCents = (currentVariant.selling_plan_allocations.length ? currentVariant.selling_plan_allocations[0].price : 0);
      let formattedPrice = formatMoney(subscribePriceCents, "amount")
      // console.log(formattedPrice)
  
      cache.$prodPrice.text(`$${formattedPrice}`)
 
    }

    const updateQVSubscriptionSavings = function(){

      if ( currentVariant.selling_plan_allocations ) {
        let sellingPlan = currentVariant.selling_plan_allocations[0]
  
        if (sellingPlan) {
          let subscriptionSavings = sellingPlan.compare_at_price - sellingPlan.price;
          let formattedSavings = "$" + formatMoney(subscriptionSavings, "amount");
  
          cache.$subscriptionSavings.text(formattedSavings)
        }
      }    
    }

    const handleDeliveryChangeQV = function(e){
      let $this = jquery_default()(this)

      // console.log($this)
      
  
      $form.find('.qv-custom-checkbox').each(function(){
        jquery_default()(this).removeClass('tab__active')
      })

      
  
  
      $this.closest('.qv-custom-checkbox').addClass('tab__active')
      
  
  
      if ($this.val() === "subscribe") {
        // Expand the Frequency group

        // console.log('Sub clicked')
        cache.$frequencyContainer.slideDown(300)
  
  
        cache.$sellingPlan.attr('disabled', false)
  
        $form.find('.js-one-time-group').css('display','none')
        $form.find('.js-selling-plan-div').css('display','block')
  
        $form.find('.ot__prod-var-select>div').appendTo($form.find('.sub__prod-var-select'));
        $form.find('.ot__quantity-box>div').appendTo($form.find('.sub__quantity-box'));
  
  
      } else {

        // console.log('OT clicked')
        cache.$frequencyContainer.slideUp(300)
        cache.$sellingPlan.attr('disabled', true)
  
  
        //Display One time section
        $form.find('.js-one-time-group').css('display','block')
        $form.find('.js-selling-plan-div').css('display','none')
  
  
        $form.find('.sub__prod-var-select>div').appendTo($form.find('.ot__prod-var-select'));
        $form.find('.sub__quantity-box>div').appendTo($form.find('.ot__quantity-box'));
      }
  
      updateQVProductPrice()
    }


    const updateQVProductPrice = function(){
      let subscriptionOptionSelectedQV = cache.$deliveryOptionQV.closest(":checked").val() === "subscribe"
  
      if (subscriptionOptionSelectedQV) {
        updateQVSubscriptionPrice()
      } else {
        updateQVOneTimePrice()
      }
    }

    const setQVCurrentVariant = function(e) {
        // findVariant by matching activeOptions[0] / activeOptions[1] etc
        if (!variants) return;
    
        // console.log('Prod QV: HiddenOptionSelect change ---> setCurrentVariant called')
    
        let name = jquery_default()(this).data("name")
        let value = jquery_default()(this).val()
    
        setActiveOption(name, value)
    
        currentVariant = variants.find(variant => {
          let filteredOptions = product.options.filter((option, index) => {
            let optionName = `option${index + 1}`
            return variant[optionName] === options[option]
          })
    
          return filteredOptions.length === product.options.length
        })

    
        // console.log('Prod QV: currentVariant ====>', currentVariant)  

        // console.log(cache.$idInput)

        if (currentVariant) {
          cache.$idInput
            .val(currentVariant.id)
            .change()
        }

    
        return currentVariant;
    }

    const handleQVSwatchChange = function(e){
        e.preventDefault()
        e.stopPropagation()
    
        // console.log('Handle QV swatch change')
    
        let $this = jquery_default()(this)
        let name = $this.data('option')
        let value = $this.data('value')
  
        // console.log('Prod QV: ',$this, name, value)
    


         console.log('Prod QV:', cache.$hiddenOptionSelects
            .closest(`[data-name=${name}]`)
            .val());


        cache.$hiddenOptionSelects
          .closest(`[data-name=${name}]`)
          .val(value)
          .change()
    }

    const init = function(){
        // Modal -- options

        // console.log('form   =====>    ',$form)
        initEventListeners()
        parseVariants()
        parseOptions()


        cache.$hiddenOptionSelects.change()


        //Select OT by default
        $form.find('.pdp-custom-checkbox__onetime').trigger('click');


    }


    init()

}


/* harmony default export */ const productFormQV = (ProductFormQV);
;// CONCATENATED MODULE: ./assets/js/productFormsQVInit.js




const ProductFormsQVInit = (function(){
  const selectors = {
    form: ".js-product-form-qv",
    $qvOpen: jquery_default()('.quick-view-btn'),
    $qvClose: jquery_default()('.quick-view-close'),
  }

  let currentCardActive;

  const init = function(){


     if (!elementsExist([selectors.form])) return;

    selectors.$qvOpen.each(function(){
      jquery_default()(this).on('click', quickViewOpen)
    })

    selectors.$qvClose.each(function(){
      jquery_default()(this).on('click', quickViewClose)
    })
 

    
  }

  const quickViewOpen = function(e){
        console.log('QV open', jquery_default()(this))
        e.preventDefault();
        e.stopPropagation();

        currentCardActive = jquery_default()(this);


        let currentQuickViewContent = jquery_default()(this).siblings('.product--buy-panel-quick-order').children('.product-form-quick-view').html()



        jquery_default()('.plp-quick-view .plp-qv--content').html(currentQuickViewContent)
        jquery_default()('.plp-quick-view').fadeIn()

        let currentForm = jquery_default()('.plp-quick-view .plp-qv--content').find('.js-product-form-qv')
        // console.log('this ===>', $(this))
        // console.log('currentForm ===>', $('.plp-quick-view .plp-qv--content').find('.js-product-form-qv'))

        // console.log( $(this).siblings('.product--buy-panel-quick-order').children('.product-form-quick-view'))



        jquery_default()(this).siblings('.product--buy-panel-quick-order').children('.product-form-quick-view').empty()

        
        initializeProductForms(currentForm);

        jquery_default()(document.body).addClass('no-scroll');
  }

  
  const quickViewClose = function(e){
        e.preventDefault(); 

        console.log(currentCardActive)

        let contentInsideForm = jquery_default()('.plp-quick-view .plp-qv--content').html()
        //console.log(contentInsideForm)
        currentCardActive.siblings('.product--buy-panel-quick-order').children('.product-form-quick-view').html(contentInsideForm)

        jquery_default()('.plp-quick-view').fadeOut()


        jquery_default()(document.body).removeClass('no-scroll');
  }



  const initializeProductForms = function(currentForm){
    console.log('product form QV init')

    productFormQV(currentForm)
    // $(selectors.form).each(function(index, form){
    //   ProductFormQV($(form))
    // }) 


  }

  return {
    init
  }

})()

/* harmony default export */ const productFormsQVInit = (ProductFormsQVInit);

;// CONCATENATED MODULE: ./assets/js/twelveDays.js



const TwelveDays = (function() {

    const selectors = {
        stampFeature: ".twelvedays-stamp-feature",
        productStamp: ".js-product-stamp",
        stampLockShadow: ".stamp--lock-shadow",
        stampProdParent: ".stamp-prod-parent",
        stampDatProdDetails: ".js-stamp-product-details",
        stampDetailsPopup: ".twelveDays-popup",
        popupClose: ".twelveDaysPopupClose",
        stampProdSlider: ".stamp-prod-slider",
        stampProductDetails: ".stamp-prod-details"

    };

    // Global variable to store unlocked stamps
    let stampsUnlocked;

    const init = function(){
        // Retrieve the current value of stampsUnlocked from localStorage
        try {
            stampsUnlocked = JSON.parse(localStorage.getItem("stampsUnlocked")) || [];
        } catch (e) {
            // Handle non-JSON format by initializing a new array
            stampsUnlocked = localStorage.getItem("stampsUnlocked") ? localStorage.getItem("stampsUnlocked").split(',') : [];
        }

        if (elementsExist([selectors.stampFeature])) {
            unlockInitialStamps();
            initEventListeners();
        }
    };

   
    const unlockInitialStamps = function() {
        if (stampsUnlocked.length > 0) {
    
            const $slickSlider = jquery_default()('.stamp-prod-details--slick');
    
            // Check if Slick is already initialized; if not, initialize it
            if (!$slickSlider.hasClass('slick-initialized')) {
                $slickSlider.slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: false,
                    nextArrow: '<button type="button" class="slick-next custom-slick-arrow relative">Next</button>',
                    prevArrow: '<button type="button" class="slick-prev custom-slick-arrow relative">Prev</button>'
                });
            }
    
            // Array to hold products to add
            const productsToAdd = [];
    
            stampsUnlocked.forEach(stampDay => {
                // Unlock the stamps that are already unlocked
                jquery_default()(selectors.productStamp).each(function() {
                    const $stamp = jquery_default()(this);
                    if ($stamp.attr('data-stamp-day') == stampDay) {
                        $stamp.attr('data-stamp-locked', false);
                        $stamp.find('.stamp--lock-shadow').addClass('hidden');
                    }
                });
    
                // Collect unlocked products to add them in order
                jquery_default()(selectors.stampDatProdDetails).each(function() {
                    const $productStamp = jquery_default()(this);
                    if ($productStamp.attr('data-stamp-prod-ref') == stampDay) {
                        // Store the product along with its index
                        productsToAdd.push({
                            element: $productStamp.clone(),
                            index: parseInt($productStamp.attr('data-slider-index'), 10) // Parse as integer
                        });
                    }
                });
            });

    
            // Sort products by data-slider-index
            productsToAdd.sort((a, b) => a.index - b.index);
    
            // Add the sorted products to the Slick slider
            productsToAdd.forEach(product => {
                $slickSlider.slick('slickAdd', product.element);
            });
    
            // Display the slider
            //$(selectors.stampProdSlider).removeClass('hidden');
    
        } else {
            console.log('NO STAMPS UNLOCKED');
        }
    };
    

    const initEventListeners = function(){
        jquery_default()(selectors.stampLockShadow).on('click', function(event) {
            handleStampShadowClick(event);
        });

        jquery_default()(selectors.productStamp).on('click', function(event) {
            handleStampClick(event);
        });

        jquery_default()(selectors.popupClose).on('click', handlePopupClose)
    };

    const handleStampShadowClick = function(event){
        event.stopPropagation();

        const dayStamp = event.target.closest('.js-product-stamp');
        const stampDayClicked = jquery_default()(dayStamp).attr('data-stamp-day');

        // 1. Update UI
        jquery_default()(dayStamp).attr('data-stamp-locked', false);
        jquery_default()(dayStamp).find('.stamp--lock-shadow').addClass('hidden');

        // 2. Add the new stamp day if it's not already in the array
        if (!stampsUnlocked.includes(stampDayClicked)) {
            stampsUnlocked.push(stampDayClicked);
        }

        // 3. Store the updated array back in localStorage as a JSON string
        localStorage.setItem("stampsUnlocked", JSON.stringify(stampsUnlocked));
    };




    const handleStampClick = function(event) {
        const dayStamp = event.target.closest('.js-product-stamp');
        const stampDayClicked = jquery_default()(dayStamp).attr('data-stamp-day');
        const stampIndex = jquery_default()(dayStamp).attr('data-stamp-index');
    

        const currentSelectProd = jquery_default()(selectors.stampProdParent).find('.js-stamp-product-details').filter((_, stampProd) => {
            return jquery_default()(stampProd).attr('data-stamp-prod-ref') == stampDayClicked;
        });
 
    
        if (currentSelectProd.length) {

            //1. Display Popup
            const selectedStampDetails = currentSelectProd.first(); // Get the first matched element
            jquery_default()('.twelveDays-popup').find('.popupDetails').empty().html(selectedStampDetails.html());
            jquery_default()('.twelveDays-popup').show();
            jquery_default()(document.body).addClass('no-scroll');


            

            //2. Add the product to the slider


            // Prepare the single product to add to the slider
            const productToAdd = {
                element: selectedStampDetails,
                index: stampIndex
            };


            const newSlide = jquery_default()(productToAdd.element.clone().get(0));


            const $slickSlider = jquery_default()('.stamp-prod-details--slick');


            if ($slickSlider.hasClass('slick-initialized')) {
                // Determine if the product already exists in the slider
                const existsInSlider = $slickSlider.find(`[data-stamp-prod-ref="${stampDayClicked}"]`).length > 0;
    
                if (!existsInSlider) {
    
                    // Add the selected product at the specified index
                    $slickSlider.slick('slickAdd', newSlide );
                    //$slickSlider.slick('reinit');
                } else {
                    console.log('Product already exists in the slider');
                }
            } else {
                console.error('Slick slider is not initialized.');

                $slickSlider.slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: false,
                    nextArrow: '<button type="button" class="slick-next custom-slick-arrow relative">Next</button>',
                    prevArrow: '<button type="button" class="slick-prev custom-slick-arrow relative">Prev</button>'
                });

                $slickSlider.slick('slickAdd', newSlide );


            }
        }
    };
    
    
    
    
    
    const handlePopupClose = function(){
        jquery_default()('.twelveDays-popup').find('.popupDetails').html('')
        jquery_default()('.twelveDays-popup').hide();

        jquery_default()(document.body).removeClass('no-scroll');
    }

    return { init };

})();

/* harmony default export */ const twelveDays = (TwelveDays);

;// CONCATENATED MODULE: ./assets/js/bundleBuilder.js


 


const bundleBuilder = {
    settings: {
        bundleBuilder: '.BYOB--bundle-builder',
        packOfElement: 'input[name="pack"]',
        packDescription: '.pack-description',
        packTitleMob: '.pack-title-mob',
        container: '.byob-items-container',
        mobStickyContainer: '.byob-mob-sticky-container',
        addBundlePro: '.bundle-btn',
        bundleSlots: '.item',
        qtyBox: '',
        collectionTab: '.byob-collection__sub-tab',
        bundleProdCards: '.product-card-byob',
        bundleATC: ".js-product-form-atc-byob",
        bundleATCMob: ".js-product-form-atc-byob-mob",
        quantityButton: ".js-change-quantity--byob",
        quantityInput: ".js-quantity-input--byob",
        bundleQtySelector: ".bundle-qty-selector",
        mobileStickyCalloutMsg: ".mob-sticky-callout-message"
    },

    // Global values defined here
    bundleProducts: [],
    totalSelectedPack: null,
    bundleDiscount: 0,
    bundleDiscountedPrice: null,
    bundleRegularPrice: null,

    init: function() {
        //Total number of packs selected initially - 3
        const selectedPack = document.querySelector('input[name="pack"]:checked');
        this.totalSelectedPack = selectedPack ? selectedPack.value : 0; 
        



        if (elementsExist([this.settings.bundleBuilder])) {
  


            //1. Collection Tab Switch
            document.querySelectorAll(this.settings.collectionTab).forEach((tab) => {
                tab.addEventListener("click", (event) => this.collectionTabSwitch(event));
            });


            //2. Pack Number Selector
            const totalPacks = document.querySelectorAll(this.settings.packOfElement);
            totalPacks.forEach((radio) => {
                radio.addEventListener("change", (event) => this.manageBundleChange(event));
            });


            //3. Bundle Product - Add to Bundle
            document.querySelectorAll(this.settings.quantityButton).forEach((button) => {
                button.addEventListener("click", (event) => this.handleQtyChange(event));
            });

            //4. Handle Quantity Change
            document.querySelectorAll(this.settings.addBundlePro).forEach((button) => {
                button.addEventListener("click", (event) => this.addBundleProduct(event));
            });


            //5. Bundle - Add to Cart
            document.querySelector(this.settings.bundleATC).addEventListener("click",  (event) => this.handleAddToCart(event))


            //5. Bundle - Add to Cart (Mobile) - Triggers the Main ATC 
            document.querySelector(this.settings.bundleATCMob).addEventListener("click", () => {
                document.querySelector(this.settings.bundleATC).click();
            });


            //6. On click of the Display Products scroll to top:
            document.querySelector(this.settings.mobStickyContainer).addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            })
            
        }
    },

    //Collection Tab Switch - Function
    collectionTabSwitch(event){
        const targetTab = event.target.closest('li');
        if (targetTab) {

            //1. Update the Active State of Tabs
            document.querySelectorAll(this.settings.collectionTab).forEach(tab => {
                tab.classList.remove('byob-tab--active')
            })
            targetTab.classList.add('byob-tab--active')


            //2. Update the products
            const selectedTabName = targetTab.getAttribute('data-byob-tab-title')

            const allProducts = Array.from(document.querySelectorAll(this.settings.bundleProdCards));
            if (selectedTabName === "all") {
                allProducts.forEach(product => product.classList.remove('hidden'));
            } else {
                allProducts.forEach(product => product.classList.add('hidden'));
                // Show only the products that match the selected tab
                const selectedTabProducts = allProducts.filter(product => product.getAttribute('data-product-tab-name') === selectedTabName);
                selectedTabProducts.forEach(product => product.classList.remove('hidden'));

            }
            
        }
        
    },


    //Pack Number Selector - Function
    manageBundleChange(event) {



        //1. Get the currently clicked number
        let seletedPack = document.querySelector('input[type="radio"].form-radio:checked');
        const numberOfPacks = parseInt(seletedPack.value, 10); // Get the selected number of packs

        this.totalSelectedPack = numberOfPacks;
        const container = document.querySelector(this.settings.container);
        container.innerHTML = ''; 

        const mobStickycontainer = document.querySelector(this.settings.mobStickyContainer);
        mobStickycontainer.innerHTML = ''; 
        


        //2. Update the status of the Pack Labels
        document.querySelectorAll(".discount_container label").forEach((element) => {
            element.classList.remove("active-pack");
        });
        seletedPack.closest("label").classList.add("active-pack")




        //3. Create the HTML for the selected Products (based on the packNumber selected)
        Array.from({ length: numberOfPacks }, (_, i) => {
            const itemDiv = document.createElement('div');
            itemDiv.classList.add('product_item', 'relative');
            const span = document.createElement('span');
            span.classList.add('position-relative', 'empty-state');

            span.innerHTML = this.emptyBlockSvg();
            itemDiv.appendChild(span);
            container.appendChild(itemDiv);


            if (i !== numberOfPacks - 1) {
                //console.log('i !== numberOfPacks - 1')
                const plusIconDiv = document.createElement('div');
                plusIconDiv.classList.add('flex', 'justify-center', 'flex-shrink-0')
                plusIconDiv.innerHTML = this.plusIconSvg(); // Set the inner HTML to the SVG string
                container.appendChild(plusIconDiv)
            }
        });



        //======== MOBILE  ========
        //4. Update the images in the Mobile Sticky container also
        Array.from({ length: numberOfPacks }, (_, i) => {
            const itemDiv = document.createElement('div');
            itemDiv.classList.add('w-7', 'sticky-product_item', `z-${i+1}`);
            itemDiv.setAttribute('data-sticky-block-index', i+1)
            if(i == 0){
                itemDiv.classList.add('mt-[-12px]');
            }else if(i == 1){
                itemDiv.classList.add('ml-[-16px]');
            }else if(i == 2){
                itemDiv.classList.add('ml-[-16px]', 'mt-[12px]');
            }
            const span = document.createElement('span');
            span.classList.add('position-relative', 'sticky-empty-state');

            span.innerHTML = this.emptyBlockColorSvg();
            itemDiv.appendChild(span);
            mobStickycontainer.appendChild(itemDiv);

        });






        this.renderBundleItems();
        this.manageBtnState();
    },

    //Add Product to Bundle - Function
    addBundleProduct(event) {
    

        //1. Gather info about the product added
        let varID = event.target.dataset.varId;
        let productID = event.target.dataset.proId;
        let currentProduct = JSON.parse(document.querySelector(`[product-data-${productID}]`).innerHTML);
        let currentVariant = currentProduct.variants.filter(variant => variant.id == varID);
        let currentImage = event.target.dataset.packImg;

        //2. Create Array of product details
        const newProduct = {
            varID: varID, 
            proID: productID,
            imageSrc: currentImage ? currentImage : currentProduct.images[0],
            price: currentVariant[0].price
        };


        

        //3. Add the new product to the bundleProducts Array
        this.bundleProducts.push(newProduct);


        //4. Enable Quantity Selector for the Products Added to Bundle
        $(event.target).addClass('hidden')
        let currentSelectedQty =  $(event.target).siblings('.bundle-qty-selector')
        currentSelectedQty.removeClass('hidden')


        //5. Manage Button State and Bundle Products container
        this.renderBundleItems();
        this.manageBtnState();
        
    },

    //Handle Quantity Change for Products in Bundle
    handleQtyChange(event) {
    
        // Get the action attribute from the clicked element
        let action = event.currentTarget.getAttribute('data-action');
    
        // Get the input element for quantity
        let inputSelector = this.settings.quantityInput;
        let inputElement = event.currentTarget.parentElement.querySelector(inputSelector);
        let quantity = parseInt(inputElement.value);

 
    
        // Get the minimum quantity allowed
        let min = parseInt(inputElement.getAttribute('min'));
        let newQty = quantity;
    
        // Adjust quantity based on action
        if (action === "plus") {
            newQty = quantity + 1;
        } 
        // else {
        //     newQty = (quantity === min ? min : quantity - 1);
        // }
    

        // Update the quantity in the input element and trigger change event
        inputElement.value = newQty;
        inputElement.setAttribute('value', newQty);
        inputElement.dispatchEvent(new Event('change'));


    


        //Get the Current Product Details
        if (action === 'plus') {
            const bundleButton = event.currentTarget.closest('.bundle-qty-selector').nextElementSibling;
            if (bundleButton && bundleButton.classList.contains('bundle-btn')) {
                bundleButton.click();
            }
        }
        else{
            const prodIdToBeRemoved = event.currentTarget.dataset.proId ;



            const closeButtons = [...document.querySelectorAll(".close-btn")].reverse();
            for (let element of closeButtons) {
                // console.log(element.dataset.removeItem);
                const closeBtnProdId = element.dataset.removeItem;

                if (prodIdToBeRemoved === closeBtnProdId) {
                    element.click();
                    break; // Delete only the last matching item
                }
            }

        }


    },
    

    //Handles the 'Add to Bundle' button state based on number of Products in the Bundle - Function 
    manageBtnState() {

        if(this.bundleProducts.length < this.totalSelectedPack) {
            document.querySelectorAll(this.settings.addBundlePro).forEach((button) => {
                button.removeAttribute("disabled");
            });

            //bundleQtySelector
            document.querySelectorAll(this.settings.bundleQtySelector).forEach((qtyBox) => {
                qtyBox.querySelector('.product-plus').classList.remove("pointer-events-none");
            });

            document.querySelector(this.settings.bundleATC).setAttribute("disabled", true)
            document.querySelector(this.settings.bundleATCMob).setAttribute("disabled", true)


        } else {
            document.querySelectorAll(this.settings.addBundlePro).forEach((button) => {
                button.setAttribute("disabled", true);
            });

            //bundleQtySelector
            document.querySelectorAll(this.settings.bundleQtySelector).forEach((qtyBox) => {
                qtyBox.querySelector('.product-plus').classList.add("pointer-events-none");
            });

            document.querySelector(this.settings.bundleATC).removeAttribute("disabled")
            document.querySelector(this.settings.bundleATCMob).removeAttribute("disabled")
        }  



        this.manageMsgState()
    },

    //Manage the Callout Message State on the Sticky Mobile Banner
    manageMsgState(){

        const stickyCalloutBanner = document.querySelector(this.settings.mobileStickyCalloutMsg)
        const stickyBannerSVG =  stickyCalloutBanner.querySelector('.celebrate-svg')
        const stickyBannerText =  stickyCalloutBanner.querySelector('.celebrate-text')

        const amountSaved = (this.bundleRegularPrice - this.bundleDiscountedPrice).toFixed(2);

        if(this.bundleProducts.length < this.totalSelectedPack) {
            // console.log('Add More Products')
            stickyBannerSVG.classList.add('hidden')

            if(this.totalSelectedPack == 2){
                if(this.bundleProducts.length == 0){
                    stickyBannerText.innerHTML = 'Add two items and get 15% off + Free Shipping'  //Empty state for 2-Pack
                }
                else{

                    if((this.totalSelectedPack - this.bundleProducts.length) == 1){
                        stickyBannerText.innerHTML = 'Add one more item and get 15% off + Free Shipping'
                    }
                    else{
                        stickyBannerText.innerHTML = 'Add more products to 2 Pack to get 15% off + Free Shipping'
                    }
                   
                }
               
            }
            else if(this.totalSelectedPack == 3){
                if(this.bundleProducts.length == 0){
                    stickyBannerText.innerHTML = 'Add three items and get 25% off + Free Shipping'   //Empty state for 3-Pack
                }
                else{
                    if((this.totalSelectedPack - this.bundleProducts.length) == 1){
                        stickyBannerText.innerHTML = 'Add one more items and get 25% off + Free Shipping'
                    }
                    else if((this.totalSelectedPack - this.bundleProducts.length) == 2){
                        stickyBannerText.innerHTML = 'Add two more items and get 25% off + Free Shipping'
                    }
                    else{
                        stickyBannerText.innerHTML = 'Add more products to 3 Pack to get 25% off + Free Shipping'
                    }
                    
                }
            }
			else if(this.totalSelectedPack == 4){
                if(this.bundleProducts.length == 0){
                    stickyBannerText.innerHTML = 'Add four items and get 30% off + Free Shipping'   //Empty state for 3-Pack
                }
                else{
                    if((this.totalSelectedPack - this.bundleProducts.length) == 1){
                        stickyBannerText.innerHTML = 'Add one more items and get 30% off + Free Shipping'
                    }
                    else if((this.totalSelectedPack - this.bundleProducts.length) == 2){
                        stickyBannerText.innerHTML = 'Add two more items and get 30% off + Free Shipping'
                    }
					else if((this.totalSelectedPack - this.bundleProducts.length) == 3){
                        stickyBannerText.innerHTML = 'Add three more items and get 30% off + Free Shipping'
                    }
                    else{
                        stickyBannerText.innerHTML = 'Add more products to 4 Pack to get 30% off + Free Shipping'
                    }
                    
                }
            }
            
           
        }else{
            // console.log('Correct amount of products added for the Pack');
            stickyBannerSVG.classList.remove('hidden')
            stickyBannerText.innerHTML = `You get Free Shipping & save $${amountSaved} on this order!`
        }
    },


    //Render the Product Items in the Bundle - Function
    renderBundleItems() {
  

        const container = document.querySelector(this.settings.container);
        const mobStickyContainer = document.querySelector(this.settings.mobStickyContainer);
        const items = container.querySelectorAll('.product_item');
        const mobStickyitems = mobStickyContainer.querySelectorAll('.sticky-product_item');
      

        //1. Update the Pack Description
        document.querySelectorAll(this.settings.packDescription).forEach((pack) => {
            pack.classList.add('hidden')

            if(pack.getAttribute('data-desc-pack-num') == this.totalSelectedPack){
                pack.classList.remove('hidden')
            }
        })


        //2. Clear existing items in the Container UI
        items.forEach((item, index) => {
            item.innerHTML = '';
            if (this.bundleProducts[index]) {
                const ele = this.bundleProducts[index];
                item.innerHTML = `
                    <div class="product-data relative">
                        <img class="product-img" src="${ele.imageSrc}">
                        <div class="close-btn cursor-pointer" data-index="${index}" data-remove-item="${ele.proID}">
                            <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.966064" y="0.00341797" width="28.8482" height="28.8484" rx="14.4241" fill="#00108F"/>
                                <path d="M20.1998 10.4194L16.6697 14.1536L20.4039 17.6838L19.2272 18.9285L15.493 15.3984L11.9629 19.1326L10.7181 17.9559L14.2482 14.2217L10.514 10.6915L11.6907 9.44678L15.4249 12.9769L18.955 9.24267L20.1998 10.4194Z" fill="white"/>
                            </svg>
                        </div>
                    </div>
                `;
            } else {
                // If there's no product, display empty state
                item.innerHTML = `<span class="position-relative empty-state">${this.emptyBlockSvg()}</span>`;
            }
        });

        //3. Update close button event listeners
        document.querySelectorAll(".close-btn").forEach((element) => {
            element.addEventListener("click", (event) => {
                this.removeBundle(event);
            });
        });



        //============= MOBILE STICKY ==============
        //4. Clear existing items in the Mobile Sticky Container UI
        mobStickyitems.forEach((item, index) => {
            item.innerHTML = '';
            if (this.bundleProducts[index]) {
                const ele = this.bundleProducts[index];
                item.innerHTML = `
                    <div class="sticky-product-data relative w-full">
                        <img class="sticky-product-img" src="${ele.imageSrc}">
                    </div>
                `;
            } else {
                // If there's no product, display empty state
                item.innerHTML = `<span class="position-relative sticky-empty-state">${this.emptyBlockColorSvg()}</span>`;
            }
        });




        //5. Update price based on the Pack Selected & Products 
        const selectedProducts = this.bundleProducts.slice(0, this.totalSelectedPack);
        const regularPrice = formatMoney(selectedProducts.reduce((accumulator, item) => accumulator + item.price, 0), "amount");
        // let discountPrice = parseFloat(regularPrice - regularPrice * 0.10);
        // document.querySelectorAll("[data-bundle-discount-price]").forEach((ele) => {
        //     ele.innerText = "";
        // });
        // document.querySelectorAll("[data-bundle-regular-price]").forEach((ele) => {
        //     ele.innerText = "";
        // });

        // Set discount percentage based on `this.totalSelectedPack`
        let discountPercentage = 0.10; // Default to 10%
        if (this.totalSelectedPack == 2) {
            discountPercentage = 0.15; // 10% discount if 2 packs are selected
            this.bundleDiscount = 15;
        } else if (this.totalSelectedPack == 3) {
            discountPercentage = 0.20; // 20% discount if 3 packs are selected
            this.bundleDiscount = 20;
        } else if (this.totalSelectedPack == 4) {
            discountPercentage = 0.25; // 25% discount if 4 packs are selected
            this.bundleDiscount = 25;
        }




        //6. Calculate the discount price
        this.bundleRegularPrice = regularPrice;
        const discountPrice = parseFloat(regularPrice - regularPrice * discountPercentage);
        this.bundleDiscountedPrice = Number(discountPrice.toFixed(2));


        if(this.bundleProducts.length > 0){
            document.querySelector(".active-pack [data-bundle-discount-price]").innerText = `$${Number(discountPrice.toFixed(2))}`;
            document.querySelector(".active-pack [data-bundle-regular-price]").innerText = `$${regularPrice}`;
        } 
        else{
            document.querySelector(".active-pack [data-bundle-discount-price]").innerText = '';
            document.querySelector(".active-pack [data-bundle-regular-price]").innerText = '';
        }


        // this.bundleRegularPrice = regularPrice;
        // this.bundleDiscountedPrice = discountPrice




        //======== MOBILE STICKY ===========//
        //7. Update Bundle Items and Price on the Mobile ATC Sticky Bar
        document.querySelectorAll(this.settings.packTitleMob).forEach((pack) => {
            pack.classList.add('hidden')

            if(pack.getAttribute('data-title-pack-num') == this.totalSelectedPack){
                pack.classList.remove('hidden')
            }
        })


        //8. Update the price of the Sticky Banner
        if(this.bundleProducts.length > 0){
            document.querySelector(".sticky-pack-price [data-bundle-discount-price]").innerText = `$${Number(discountPrice.toFixed(2))}`;
            document.querySelector(".sticky-pack-price [data-bundle-regular-price]").innerText = `$${regularPrice}`;
        } 
        else{
            document.querySelector(".sticky-pack-price [data-bundle-discount-price]").innerText = '';
            document.querySelector(".sticky-pack-price [data-bundle-regular-price]").innerText = '';
        }


    },

    //Remove Product from Bundle - Function
    removeBundle(event) {


        //1. Remove the product deleted from the bundleProducts Array
        const deletedProdId = event.currentTarget.dataset.removeItem;
        const indexToRemove = parseInt(event.currentTarget.dataset.index, 10); // Get the index from the data attribute

        this.bundleProducts.splice(indexToRemove, 1);
       
        //2. Manage the quantity state of the deleted product
        const inputItemToDecrease = Array.from(document.querySelectorAll('.js-quantity-input--byob')).filter(qtyBox => {
            return qtyBox && qtyBox.dataset.proId === deletedProdId;
        });


        if (inputItemToDecrease.length > 0) {
            const inputElement = inputItemToDecrease[0];
            const currentValue = parseInt(inputElement.value, 10) || 0; // Get current value as an integer
        
            // Decrease by 1, ensuring it doesn't go below 0
            const newValue = Math.max(0, currentValue - 1);
        
            // Update both the 'value' property and the 'value' attribute
            if(newValue == 0){
                // Reinstate the 'Add to Bundle' button if the count reaches 0
                const bundleQtySelector = inputElement.closest('.bundle-qty-selector');
                bundleQtySelector.classList.add('hidden')
                
                // Get the 'Add to Bundle' button (next sibling or based on your structure)
                const bundleATCBtn = bundleQtySelector ? bundleQtySelector.nextElementSibling : null;
                
                if (bundleATCBtn && bundleATCBtn.classList.contains('bundle-btn')) {
                    // console.log('Reinstating Add to Bundle button:', bundleATCBtn);
                    bundleATCBtn.classList.remove('hidden')
                    // Your logic for reinstating the button goes here
                } else {
                    console.log('No Add to Bundle button found');
                }

            }
            else{
                // Update the 'value' attribute
                inputElement.value = newValue;
                inputElement.setAttribute('value', newValue); 
            }
            // console.log('Decreased input value to:', newValue);
        } else {
            console.log('No matching input element found');
        }
        
        

        

        //3. Manage Button State and Bundle Products container
        this.renderBundleItems();
        this.manageBtnState();
    },

    //Bundle Add to Cart
    handleAddToCart(event){

        const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
                        
        const bundleCode = genRanHex(6);

        const currentPackSelected = this.totalSelectedPack
        const bundleVariantIDs = this.bundleProducts.slice(0, currentPackSelected).map(product =>  {
            return product.varID
        });

        // Prepare the line items array
        const lineItems = bundleVariantIDs.map((variantID, index) => {
            return {
                id: `${variantID}`,
                quantity: 1,
                properties: {
                    '_uniqueKey': `${bundleCode}_${variantID}_${index}`, // Unique key for each item
                    '_bundleCode': bundleCode,
                    '_cart_Discount': `${this.bundleDiscount}_${bundleCode}_${this.totalSelectedPack}`,
                    '_bundleProductName': 'Bundle Pack of '+currentPackSelected,
                    '_bundlePrice': this.bundleDiscountedPrice * 100,
                    '_bundleProductImg': this.totalSelectedPack == 2 ? 'https://cdn.shopify.com/s/files/1/0249/4283/7837/files/2bags_1.png?v=1731672992': this.totalSelectedPack == 3 ? 'https://cdn.shopify.com/s/files/1/0249/4283/7837/files/3bags_1.png?v=1731672992': 'https://cdn.shopify.com/s/files/1/0249/4283/7837/files/4pack.png?v=1764819403',
                    'PART OF': "Build Your Bundle"
                }
            };
        });



        // Create the cart object
        const cart = {
            items: lineItems,
        };



        // Make an AJAX request to add items to the cart
        fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(cart),
            })
            .then(response => response.json())
            .then(data => {
                // console.log('Added to cart:', data);

				setTimeout(function(){
                // Open AJAX Cart
                //this.openAJAXCart();
			}, 1500)
			Cart.openCart();

            // Optionally, you can also call other methods, such as rebuilding the cart
            // if you need to update its contents or UI.
            Cart.buildCart();

                })
                .catch(error => {
                    console.error('Error adding to cart:', error);
                });

    },
    
    emptyBlockSvg() {
        return `<svg class="w-full h-full" width="113" height="196" viewBox="0 0 113 196" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.4698 178.747L4.15655 20.6166L9.70549 0.493652H103.407L109.192 20.6166L110.879 178.747M2.4698 178.747L1.38208 185.344H111.967L110.879 178.747M2.4698 178.747H110.879" stroke="#A8A8A8" stroke-width="0.961609" stroke-dasharray="3.85 3.85"/>
        <path d="M19.1368 111.014V156.4H94.1894V111.014M19.1368 111.014V98.0254H94.1894V111.014M19.1368 111.014H94.1894" stroke="#A8A8A8" stroke-width="0.961609" stroke-linecap="round" stroke-dasharray="3.85 3.85"/>
        <path d="M66.0011 18.2647C66.3336 19.0665 66.5657 19.9205 66.6819 20.8109L66.2051 20.8731C66.2587 21.2841 66.2864 21.7035 66.2864 22.1296C66.2864 22.5558 66.2587 22.9752 66.2051 23.3862L66.6819 23.4484C66.5657 24.3388 66.3336 25.1928 66.0011 25.9946L65.5569 25.8104C65.2329 26.5919 64.8086 27.3217 64.3 27.9835L64.6812 28.2765C64.1437 28.976 63.5166 29.603 62.8172 30.1405L62.5242 29.7593C61.8624 30.2679 61.1326 30.6922 60.3511 31.0163L60.5353 31.4604C59.7335 31.7929 58.8795 32.0251 57.9891 32.1412L57.9269 31.6645C57.5159 31.7181 57.0965 31.7458 56.6703 31.7458C56.2442 31.7458 55.8248 31.7181 55.4138 31.6645L55.3516 32.1412C54.4612 32.0251 53.6072 31.7929 52.8054 31.4604L52.9896 31.0163C52.2081 30.6922 51.4783 30.2679 50.8165 29.7593L50.5235 30.1405C49.8241 29.603 49.197 28.976 48.6595 28.2765L49.0407 27.9835C48.5321 27.3217 48.1078 26.5919 47.7838 25.8104L47.3396 25.9946C47.0071 25.1928 46.775 24.3388 46.6588 23.4484L47.1356 23.3862C47.082 22.9752 47.0543 22.5558 47.0543 22.1296C47.0543 21.7035 47.082 21.2841 47.1356 20.8731L46.6588 20.8109C46.775 19.9205 47.0071 19.0665 47.3396 18.2647L47.7838 18.4488C48.1078 17.6673 48.5321 16.9376 49.0407 16.2758L48.6595 15.9828C49.197 15.2833 49.8241 14.6563 50.5235 14.1188L50.8165 14.5C51.4783 13.9914 52.2081 13.5671 52.9896 13.243L52.8054 12.7989C53.6072 12.4664 54.4612 12.2342 55.3516 12.1181L55.4138 12.5948C55.8248 12.5412 56.2442 12.5135 56.6703 12.5135C57.0965 12.5135 57.5159 12.5412 57.9269 12.5948L57.9891 12.1181C58.8795 12.2342 59.7335 12.4664 60.5353 12.7989L60.3511 13.243C61.1326 13.5671 61.8624 13.9914 62.5242 14.5L62.8172 14.1188C63.5166 14.6563 64.1437 15.2833 64.6812 15.9828L64.3 16.2758C64.8086 16.9376 65.2329 17.6673 65.5569 18.4488L66.0011 18.2647Z" stroke="#656565" stroke-width="0.961609" stroke-dasharray="2.88 2.88"/>
        <ellipse cx="57.1555" cy="21.6476" rx="0.961606" ry="0.961612" fill="#656565"/>
        </svg>`
        ;
    },

    emptyBlockColorSvg() {
        return `<svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" width="31" height="50" viewBox="0 0 31 50" fill="none">
                <path d="M27.8868 0.995605L29.4113 6.29816L29.8558 47.9667L30.1424 49.7052H1.00244L1.28906 47.9667L1.73354 6.29816L3.19573 0.995605H27.8868Z" fill="#FFFFE4"/>
                <path d="M1.28906 47.9667L1.73354 6.29816L3.19573 0.995605H27.8868L29.4113 6.29816L29.8558 47.9667M1.28906 47.9667L1.00244 49.7052H30.1424L29.8558 47.9667M1.28906 47.9667H29.8558" stroke="black" stroke-width="0.253392" stroke-dasharray="1.01 1.01"/>
                <path d="M5.6947 30.1126V42.0721H25.4717V30.1126M5.6947 30.1126V26.6899H25.4717V30.1126M5.6947 30.1126H25.4717" stroke="black" stroke-width="0.253392" stroke-linecap="round" stroke-dasharray="1.01 1.01"/>
                <path d="M18.0466 5.66561C18.1342 5.8769 18.1954 6.10193 18.226 6.33656L18.1003 6.35295C18.1145 6.46126 18.1218 6.57178 18.1218 6.68406C18.1218 6.79635 18.1145 6.90686 18.1003 7.01518L18.226 7.03156C18.1954 7.2662 18.1342 7.49122 18.0466 7.70251L17.9295 7.65398C17.8441 7.85992 17.7323 8.0522 17.5983 8.22661L17.6988 8.3038C17.5571 8.48812 17.3919 8.65336 17.2076 8.795L17.1304 8.69454C16.956 8.82856 16.7637 8.94037 16.5578 9.02576L16.6063 9.14279C16.395 9.23041 16.17 9.29159 15.9354 9.3222L15.919 9.19657C15.8107 9.21069 15.7001 9.21799 15.5879 9.21799C15.4756 9.21799 15.3651 9.21069 15.2567 9.19657L15.2404 9.3222C15.0057 9.29159 14.7807 9.23041 14.5694 9.14279L14.6179 9.02576C14.412 8.94037 14.2197 8.82856 14.0453 8.69454L13.9681 8.795C13.7838 8.65336 13.6186 8.48812 13.4769 8.3038L13.5774 8.2266C13.4434 8.0522 13.3316 7.85992 13.2462 7.65398L13.1291 7.70251C13.0415 7.49122 12.9803 7.2662 12.9497 7.03156L13.0754 7.01518C13.0612 6.90686 13.0539 6.79635 13.0539 6.68406C13.0539 6.57178 13.0612 6.46126 13.0754 6.35295L12.9497 6.33656C12.9803 6.10193 13.0415 5.8769 13.1291 5.66561L13.2462 5.71414C13.3316 5.50821 13.4434 5.31592 13.5774 5.14152L13.4769 5.06432C13.6186 4.88 13.7838 4.71477 13.9681 4.57313L14.0453 4.67359C14.2197 4.53956 14.412 4.42776 14.6179 4.34236L14.5694 4.22533C14.7807 4.13771 15.0057 4.07653 15.2404 4.04593L15.2567 4.17156C15.3651 4.15743 15.4756 4.15013 15.5879 4.15013C15.7001 4.15013 15.8107 4.15743 15.919 4.17156L15.9354 4.04593C16.17 4.07653 16.395 4.13771 16.6063 4.22533L16.5578 4.34236C16.7637 4.42776 16.956 4.53956 17.1304 4.67359L17.2076 4.57313C17.3919 4.71477 17.5571 4.88 17.6988 5.06432L17.5983 5.14152C17.7323 5.31592 17.8441 5.50821 17.9295 5.71414L18.0466 5.66561Z" stroke="black" stroke-width="0.253392" stroke-dasharray="0.76 0.76"/>
                <ellipse cx="15.7209" cy="6.56443" rx="0.253391" ry="0.253393" fill="#656565"/>
                </svg>`
        ;
    },

    plusIconSvg() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M18.3781 10.7529H10.9188V18.2123H8.43234V10.7529H0.973022V8.26649H8.43234V0.807129H10.9188V8.26649H18.3781V10.7529Z" fill="#1F1F1F"/>
                </svg>`;
    }
};

/* harmony default export */ const js_bundleBuilder = (bundleBuilder);
;// CONCATENATED MODULE: ./assets/js/historyRecord.js


const historyRecord = {
    settings: {
      historyPopupClose: '.year-history-popup--close',
      playlistPopupClose: '.playlist--close',
      playlistPopup: '.playlist-popup',
      videoPopup: '.video-popup',
      videoPopupClose: '.video-popup--close',
      radioButton: '.radio_logo'
  },
   
    init: function() {
      if (!elementsExist([document.querySelector('.history-section')])) return;
      
      // console.log(window.yearHistoryData, "window.yearHistoryData");
      let historyRecordJSON = JSON.parse(document.querySelector("[data-window-yearHistoryData]").innerText);
      document.querySelectorAll("[data-interaction]").forEach((element) => {
        element.addEventListener("click", (event) => {
          let currentTarget = event.currentTarget;
          let finalHistoryData = historyRecordJSON[currentTarget.dataset.interaction][0];
          document.querySelector(".year-history-popup [data-year]").setAttribute("src", finalHistoryData.icon);
          document.querySelector(".year-history-popup [data-content]").innerText = finalHistoryData.content;
          document.querySelector(".year-history-popup [data-img]").setAttribute("src", finalHistoryData.img);
          document.querySelector(".year-history-popup").classList.remove("hidden");
          // document.body.classList.add("overflow-hidden");
        });
      })
      if(document.querySelector(this.settings.historyPopupClose)) {
        document.querySelector(this.settings.historyPopupClose).addEventListener("click", (event) => {
          let currentTarget = event.currentTarget;
          currentTarget.closest(".year-history-popup").classList.add("hidden");
          // document.body.classList.remove("overflow-hidden");
        });
      }
     
      if(document.querySelector(this.settings.playlistPopupClose)) {
        document.querySelector(this.settings.playlistPopupClose).addEventListener("click", (event) => {
          let currentTarget = event.currentTarget;
          currentTarget.closest(this.settings.playlistPopup).classList.add("hidden");
        });
      }
  
      if(document.querySelector(this.settings.videoPopupClose)) {
        document.querySelector(this.settings.videoPopupClose).addEventListener("click", (event) => {
          let currentTarget = event.currentTarget;
          currentTarget.closest(this.settings.videoPopup).classList.add("hidden");
        });
      }
      
  
      if(document.querySelectorAll(this.settings.radioButton).length) {
        document.querySelectorAll(this.settings.radioButton).forEach((element) => {
          element.addEventListener("click", (event) => {
            document.querySelector(this.settings.playlistPopup).classList.remove("hidden");
          });
        });
      }
     
      
    }
  };
  
  /* harmony default export */ const js_historyRecord = (historyRecord);
;// CONCATENATED MODULE: ./assets/js/common.js
















































jquery_default()(() => {
  initComponents()
  // pageRouter()

  menu.init()

  triggerMarquee();
  triggerSlick();

  quantityBox.init();
  Cart.init();
  js_collectionNav.init();
  productBuyPanel.init();
  productFormsInit.init();
  productCard.init();
  accordion.init();
  productRecommendations.init();
  filterOptions.init();
  video.init();
  audioTrigger.init();
  predictiveSearch.init();
  backInStock.init();
  js_contactForm.init();
  js_largeOrderInquiryForm.init();
  js_loginForm.init();
  js_registerForm.init();
  blendComponents.init();
  giftSubscription.init();
  quantityBoxGiftSub.init();
  js_allCollection.init(); 
  js_account.init(); 
  js_giftGuide.init(); 
  js_quiz.init(); 
  productBundleForm.init();
  accordion_bundle.init();
  accordion_brew.init();
  _2bagSubscriptionLP.init();
  productFormsQVInit.init();
  twelveDays.init();
  js_bundleBuilder.init();
  js_historyRecord.init();
}); 


/**
 * Instantiates global components
 */
const initComponents = () => {
  jquery_default()(document).watchFor('.animate', function($el) {
    $el.each(function() { new RevealAnimation(this).init(); });
  });

  jquery_default()(document).watchFor('[data-section-nav]', function($el) {
    $el.each(function() { new SectionNav(this).init(); });
  });

  jquery_default()(document).watchFor('[data-section-rerender]', function($el) {
    $el.each(function() { new SectionRerender(this).init(); });
  });

  jquery_default()(document).watchFor('.js-custom-select-container', function($el) {
    $el.each(function(index, node) {
      customSelect(jquery_default()(node))
    });
  });

  jquery_default()(document).watchFor('.js-pagination', function($el) {
    $el.each(function(index, node) {
      pagination.init(jquery_default()(node));
    })
  });

  jquery_default()(document).watchFor('[data-customer-addresses]', function($el){
    customerAddresses.init();
  });

  // * InlineToggle
  jquery_default()('[data-toggle]').each(function() {
    new InlineToggle(this).init();
  });
  
  // * Deactivate
  jquery_default()('[data-deactivate]').each(function() {
    new Deactivate(this).init();
  });

  // $(document).watchFor('.js-slick', function($el){
  //    const slickSlider = new Slider($el);
  //    slickSlider.init();
  // });
}

/**
 * Instantiates the proper JS Class based on template file name
 */
 const pageRouter = () => {
    const template = $('body').data('template');

    switch ( template ) {

      case 'login':

        break;
    }
};


const triggerMarquee = () => {
  const config = {
    wrapperSelector: '.js-marquee-wrapper',
    marqueeSelector: '.js-marquee',
    initializedClass: 'js-marquee--initialized'
  };

  const marquee = new Marquee(config);
  marquee.init();
};


const triggerSlick = () => {
  const config = {
    slickSelector: '.js-slick:visible'
  };

  let $sliders = jquery_default()(config.slickSelector)

   $sliders.each(function(index, slider){
     const slickSlider = new Slider(slider);
     slickSlider.init();
   })
};

})();

/******/ })()
;

